//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerNotOtp(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/RegisterNotOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterNotOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterNotOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegisterNotOtp(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminTopUpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getListWallet(body: BaseRequest | undefined): Observable<WalletAdminDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminTopUp/GetListWallet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListWallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletAdminDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletAdminDtoPagedResultDto>;
        }));
    }

    protected processGetListWallet(response: HttpResponseBase): Observable<WalletAdminDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletAdminDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    adminTopUp(body: AdminTopUpDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdminTopUp/AdminTopUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminTopUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminTopUp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdminTopUp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWalletHistoryByUser(body: GetWalletHistoryInput | undefined): Observable<WalletHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminTopUp/GetWalletHistoryByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWalletHistoryByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWalletHistoryByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetWalletHistoryByUser(response: HttpResponseBase): Observable<WalletHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportListWalletToExcel(body: BaseRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AdminTopUp/ExportListWalletToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportListWalletToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportListWalletToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportListWalletToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AgencyDto> {
        let url_ = this.baseUrl + "/api/services/app/Agency/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllDropdown(): Observable<AgencyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Agency/GetAllDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyDto[]>;
        }));
    }

    protected processGetAllDropdown(response: HttpResponseBase): Observable<AgencyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AgencyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<AgencyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Agency/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<AgencyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActionLogs(body: AgencyActionLogRequestDto | undefined): Observable<AgencyActionLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Agency/GetActionLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActionLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyActionLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyActionLogDtoPagedResultDto>;
        }));
    }

    protected processGetActionLogs(response: HttpResponseBase): Observable<AgencyActionLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyActionLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateAgencyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agency/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStoreFeeConfigs(body: GetStoreFeeRequestDto | undefined): Observable<StoreFeeConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Agency/GetStoreFeeConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreFeeConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreFeeConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreFeeConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreFeeConfigDto[]>;
        }));
    }

    protected processGetStoreFeeConfigs(response: HttpResponseBase): Observable<StoreFeeConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreFeeConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agency/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    validateDelete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Agency/ValidateDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AgencyHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLogAgencyHistory(body: CreateUpdateAgencyHistoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AgencyHistory/CreateLogAgencyHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLogAgencyHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLogAgencyHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLogAgencyHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: AgencyHistoryRequestDto | undefined): Observable<AgencyHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgencyHistory/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<AgencyHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStoreCommission(body: AgencyHistoryRequestDto | undefined): Observable<AgencyHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgencyHistory/GetStoreCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreCommission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreCommission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetStoreCommission(response: HttpResponseBase): Observable<AgencyHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSaleCommission(body: AgencyHistoryRequestDto | undefined): Observable<AgencyHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AgencyHistory/GetSaleCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaleCommission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleCommission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetSaleCommission(response: HttpResponseBase): Observable<AgencyHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSaleCommissionSumary(): Observable<SaleCommissionSumaryDto> {
        let url_ = this.baseUrl + "/api/services/app/AgencyHistory/GetSaleCommissionSumary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaleCommissionSumary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleCommissionSumary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaleCommissionSumaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaleCommissionSumaryDto>;
        }));
    }

    protected processGetSaleCommissionSumary(response: HttpResponseBase): Observable<SaleCommissionSumaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaleCommissionSumaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BankServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    seedVietnamBanks(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bank/SeedVietnamBanks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSeedVietnamBanks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSeedVietnamBanks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSeedVietnamBanks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateBankDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bank/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bank/DeleteAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdown(): Observable<BankDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bank/GetAllForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankDto[]>;
        }));
    }

    protected processGetAllForDropdown(response: HttpResponseBase): Observable<BankDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BankDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateCartDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cart/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<CartDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<CartDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CartDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cart/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CatalogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllLegalStatus(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllLegalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLegalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLegalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllLegalStatus(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllStatusTransaction(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllStatusTransaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllStatusTransaction(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllStatusPaymentTransaction(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllStatusPaymentTransaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusPaymentTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusPaymentTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllStatusPaymentTransaction(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrentlyRenting(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllCurrentlyRenting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentlyRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentlyRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllCurrentlyRenting(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllStatusInvestor(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllStatusInvestor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllStatusInvestor(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllInvestmentStatus(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllInvestmentStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInvestmentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInvestmentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllInvestmentStatus(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPhoneColor(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllPhoneColor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPhoneColor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPhoneColor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllPhoneColor(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCapacity(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllCapacity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllCapacity(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllMachineCondition(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllMachineCondition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMachineCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMachineCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllMachineCondition(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPackage(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllPackage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllPackage(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllLeaseTerm(): Observable<CatalogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllLeaseTerm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLeaseTerm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaseTerm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CatalogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CatalogDto[]>;
        }));
    }

    protected processGetAllLeaseTerm(response: HttpResponseBase): Observable<CatalogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CatalogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllStatusOrder(): Observable<StatusOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Catalog/GetAllStatusOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatusOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatusOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatusOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatusOrderDto[]>;
        }));
    }

    protected processGetAllStatusOrder(response: HttpResponseBase): Observable<StatusOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StatusOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CategoryMobileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    initData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryMobile/InitData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getServiceFee(orderId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CategoryMobile/GetServiceFee?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceFee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetServiceFee(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<CategoryMobileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryMobile/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryMobileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryMobileDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<CategoryMobileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryMobileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CategoryMobileDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryMobile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryMobileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryMobileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CategoryMobileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryMobileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param orderNo (optional) 
     * @param isActive (optional) 
     * @param serviceFee (optional) 
     * @return Success
     */
    createOrEdit(id: number | undefined, code: string | undefined, name: string | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, orderNo: number | undefined, isActive: boolean | undefined, serviceFee: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryMobile/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (code === null || code === undefined)
            throw new Error("The parameter 'code' cannot be null.");
        else
            content_.append("Code", code.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (orderNo === null || orderNo === undefined)
            throw new Error("The parameter 'orderNo' cannot be null.");
        else
            content_.append("OrderNo", orderNo.toString());
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (serviceFee === null || serviceFee === undefined)
            throw new Error("The parameter 'serviceFee' cannot be null.");
        else
            content_.append("ServiceFee", serviceFee.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryMobile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<ConfigDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<ConfigDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param listCode (optional) 
     * @return Success
     */
    getListConfigByListCode(listCode: string[] | undefined): Observable<ConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetListConfigByListCode?";
        if (listCode === null)
            throw new Error("The parameter 'listCode' cannot be null.");
        else if (listCode !== undefined)
            listCode && listCode.forEach(item => { url_ += "listCode=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListConfigByListCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListConfigByListCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigDto[]>;
        }));
    }

    protected processGetListConfigByListCode(response: HttpResponseBase): Observable<ConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateUpdateConfigDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<ConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStatusContract(body: PublicTemplateDocument[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetStatusContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetStatusContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUrlSidContact(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetUrlSidContact";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUrlSidContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUrlSidContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetUrlSidContact(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sid (optional) 
     * @param path (optional) 
     * @param body (optional) 
     * @return Success
     */
    signFlow(sid: string | undefined, path: string | undefined, body: Stream | undefined): Observable<SignFlowResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/SignFlow?";
        if (sid === null)
            throw new Error("The parameter 'sid' cannot be null.");
        else if (sid !== undefined)
            url_ += "sid=" + encodeURIComponent("" + sid) + "&";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SignFlowResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SignFlowResultDto>;
        }));
    }

    protected processSignFlow(response: HttpResponseBase): Observable<SignFlowResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignFlowResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sid (optional) 
     * @return Success
     */
    updateStatusContract(sid: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contract/UpdateStatusContract?";
        if (sid === null)
            throw new Error("The parameter 'sid' cannot be null.");
        else if (sid !== undefined)
            url_ += "sid=" + encodeURIComponent("" + sid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sid (optional) 
     * @param documentId (optional) 
     * @param reason (optional) 
     * @return Success
     */
    cancelContract(sid: string | undefined, documentId: string | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contract/CancelContract?";
        if (sid === null)
            throw new Error("The parameter 'sid' cannot be null.");
        else if (sid !== undefined)
            url_ += "sid=" + encodeURIComponent("" + sid) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signContract(body: Order | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contract/SignContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSignContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    generate(orderId: number | undefined): Observable<FileManagerDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Generate?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileManagerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileManagerDto>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<FileManagerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileManagerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOverview(body: DashboardOverviewRequestDto | undefined): Observable<DashboardOverviewDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<DashboardOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderList(body: DashboardOrderListRequestDto | undefined): Observable<DashboardOrderItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOrderList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOrderItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOrderItemDtoPagedResultDto>;
        }));
    }

    protected processGetOrderList(response: HttpResponseBase): Observable<DashboardOrderItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOrderItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTransactionList(body: DashboardTransactionListRequestDto | undefined): Observable<DashboardTransactionItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetTransactionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardTransactionItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardTransactionItemDtoPagedResultDto>;
        }));
    }

    protected processGetTransactionList(response: HttpResponseBase): Observable<DashboardTransactionItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardTransactionItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportOrderList(body: DashboardOrderListRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/ExportOrderList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportOrderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOrderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportOrderList(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportTransactionList(body: DashboardTransactionListRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/ExportTransactionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportTransactionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportTransactionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportTransactionList(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param path (optional) 
     * @param name (optional) 
     * @param extension (optional) 
     * @param fileType (optional) 
     * @return Success
     */
    downloadFile(id: number | undefined, path: string | undefined, name: string | undefined, extension: string | undefined, fileType: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/File/DownloadFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "Path=" + encodeURIComponent("" + path) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (extension === null)
            throw new Error("The parameter 'extension' cannot be null.");
        else if (extension !== undefined)
            url_ += "Extension=" + encodeURIComponent("" + extension) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileMangerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param tempFilePath (optional) 
     * @param subSystem (optional) 
     * @return Success
     */
    moveFileFromTemp(tempFilePath: string | undefined, subSystem: string | undefined): Observable<FileManager> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/MoveFileFromTemp?";
        if (tempFilePath === null)
            throw new Error("The parameter 'tempFilePath' cannot be null.");
        else if (tempFilePath !== undefined)
            url_ += "tempFilePath=" + encodeURIComponent("" + tempFilePath) + "&";
        if (subSystem === null)
            throw new Error("The parameter 'subSystem' cannot be null.");
        else if (subSystem !== undefined)
            url_ += "subSystem=" + encodeURIComponent("" + subSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveFileFromTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveFileFromTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileManager>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileManager>;
        }));
    }

    protected processMoveFileFromTemp(response: HttpResponseBase): Observable<FileManager> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileManager.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    getFileTemp(path: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/GetFileTemp?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileTemp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileTemp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFileTemp(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFile(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/GetFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileDb (optional) 
     * @param subSystem (optional) 
     * @param body (optional) 
     * @return Success
     */
    processFiles(fileDb: string | undefined, subSystem: string | undefined, body: number[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/ProcessFiles?";
        if (fileDb === null)
            throw new Error("The parameter 'fileDb' cannot be null.");
        else if (fileDb !== undefined)
            url_ += "fileDb=" + encodeURIComponent("" + fileDb) + "&";
        if (subSystem === null)
            throw new Error("The parameter 'subSystem' cannot be null.");
        else if (subSystem !== undefined)
            url_ += "subSystem=" + encodeURIComponent("" + subSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processProcessFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileDb (optional) 
     * @return Success
     */
    getByListFile(fileDb: string | undefined): Observable<FileManagerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/GetByListFile?";
        if (fileDb === null)
            throw new Error("The parameter 'fileDb' cannot be null.");
        else if (fileDb !== undefined)
            url_ += "fileDb=" + encodeURIComponent("" + fileDb) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByListFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByListFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileManagerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileManagerDto[]>;
        }));
    }

    protected processGetByListFile(response: HttpResponseBase): Observable<FileManagerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FileManagerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getByListId(ids: number[] | undefined): Observable<FileManagerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/GetByListId?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByListId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByListId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileManagerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileManagerDto[]>;
        }));
    }

    protected processGetByListId(response: HttpResponseBase): Observable<FileManagerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FileManagerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subsystem (optional) 
     * @param fileType (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadFiles(subsystem: string | undefined, fileType: string | undefined, files: FileParameter[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/UploadFiles?";
        if (subsystem === null)
            throw new Error("The parameter 'subsystem' cannot be null.");
        else if (subsystem !== undefined)
            url_ += "subsystem=" + encodeURIComponent("" + subsystem) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subsystem (optional) 
     * @param fileType (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadFile(subsystem: string | undefined, fileType: string | undefined, file: FileParameter | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/UploadFile?";
        if (subsystem === null)
            throw new Error("The parameter 'subsystem' cannot be null.");
        else if (subsystem !== undefined)
            url_ += "subsystem=" + encodeURIComponent("" + subsystem) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileIds (optional) 
     * @return Success
     */
    cloneFiles(fileIds: string | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/CloneFiles?";
        if (fileIds === null)
            throw new Error("The parameter 'fileIds' cannot be null.");
        else if (fileIds !== undefined)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCloneFiles(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    cloneFileByPath(path: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/CloneFileByPath?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneFileByPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneFileByPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCloneFileByPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param subsystem (optional) 
     * @param file (optional) 
     * @return Success
     */
    uploadFileReturnPath(subsystem: string | undefined, file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/UploadFileReturnPath?";
        if (subsystem === null)
            throw new Error("The parameter 'subsystem' cannot be null.");
        else if (subsystem !== undefined)
            url_ += "subsystem=" + encodeURIComponent("" + subsystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFileReturnPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFileReturnPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFileReturnPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pathFile (optional) 
     * @return Success
     */
    deleteFileByPath(pathFile: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/DeleteFileByPath?";
        if (pathFile === null)
            throw new Error("The parameter 'pathFile' cannot be null.");
        else if (pathFile !== undefined)
            url_ += "pathFile=" + encodeURIComponent("" + pathFile) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFileByPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFileByPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFileByPath(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    deleteFileStrings(fileId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/DeleteFileStrings?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFileStrings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFileStrings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFileStrings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteFiles(ids: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/DeleteFiles?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param path (optional) 
     * @return Success
     */
    getFileByPath(path: string | undefined): Observable<FileManagerDto> {
        let url_ = this.baseUrl + "/api/services/app/FileManger/GetFileByPath?";
        if (path === null)
            throw new Error("The parameter 'path' cannot be null.");
        else if (path !== undefined)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileByPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileByPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileManagerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileManagerDto>;
        }));
    }

    protected processGetFileByPath(response: HttpResponseBase): Observable<FileManagerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileManagerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HistoryOrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateUpdateHistoryOrder | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HistoryOrder/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: HistoyOrderRequestModel | undefined): Observable<HistoryOrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoryOrder/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoryOrderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoryOrderDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<HistoryOrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoryOrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportHistoryOrdersToExcel(body: HistoyOrderRequestModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/HistoryOrder/ExportHistoryOrdersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportHistoryOrdersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportHistoryOrdersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportHistoryOrdersToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HoangHaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @param status (optional) 
     * @param note (optional) 
     * @return Success
     */
    updateStatusApi(orderId: number | undefined, status: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoangHa/UpdateStatusApi?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatusApi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatusApi(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatusApi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    initData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoangHa/InitData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoangHa/DeleteData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initFromData(body: IPhoneProductData | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HoangHa/InitFromData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitFromData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitFromData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitFromData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvestorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getByUserId(userId: number | undefined): Observable<InvestorDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDto>;
        }));
    }

    protected processGetByUserId(response: HttpResponseBase): Observable<InvestorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InvestorDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InvestorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: InvestorRequestDto | undefined): Observable<InvestorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<InvestorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActionLogs(body: InvestorActionLogRequestDto | undefined): Observable<InvestorActionLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetActionLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActionLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorActionLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorActionLogDtoPagedResultDto>;
        }));
    }

    protected processGetActionLogs(response: HttpResponseBase): Observable<InvestorActionLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorActionLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateInvestorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Investor/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Investor/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param investorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    caculateInvestor(investorId: number | undefined, body: Transaction | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Investor/CaculateInvestor?";
        if (investorId === null)
            throw new Error("The parameter 'investorId' cannot be null.");
        else if (investorId !== undefined)
            url_ += "investorId=" + encodeURIComponent("" + investorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCaculateInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCaculateInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCaculateInvestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getInvestorSumary(): Observable<InvestorSumaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetInvestorSumary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvestorSumary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvestorSumary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorSumaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorSumaryDto>;
        }));
    }

    protected processGetInvestorSumary(response: HttpResponseBase): Observable<InvestorSumaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorSumaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrdersByInvestorAndStatus(body: GetOrdersByInvestorAndStatusRequestDto | undefined): Observable<OrderInvestorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetOrdersByInvestorAndStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersByInvestorAndStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersByInvestorAndStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderInvestorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderInvestorDtoPagedResultDto>;
        }));
    }

    protected processGetOrdersByInvestorAndStatus(response: HttpResponseBase): Observable<OrderInvestorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderInvestorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportOrdersByInvestorAndStatusToExcel(body: GetOrdersByInvestorAndStatusRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Investor/ExportOrdersByInvestorAndStatusToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportOrdersByInvestorAndStatusToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOrdersByInvestorAndStatusToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportOrdersByInvestorAndStatusToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    approvedInvestor(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Investor/ApprovedInvestor?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovedInvestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    rejectInvestor(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Investor/RejectInvestor?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectInvestor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingTransactionInvestor(body: TransactionRequestModel | undefined): Observable<TransactionInvestorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetPagingTransactionInvestor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingTransactionInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingTransactionInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionInvestorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionInvestorDtoPagedResultDto>;
        }));
    }

    protected processGetPagingTransactionInvestor(response: HttpResponseBase): Observable<TransactionInvestorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionInvestorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getSettlementProfit(orderId: number | undefined): Observable<SettlementProfitDto> {
        let url_ = this.baseUrl + "/api/services/app/Investor/GetSettlementProfit?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettlementProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettlementProfit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettlementProfitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettlementProfitDto>;
        }));
    }

    protected processGetSettlementProfit(response: HttpResponseBase): Observable<SettlementProfitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettlementProfitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvestorDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: InvestorDetailRequestDto | undefined): Observable<OrderInvestorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InvestorDetail/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderInvestorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderInvestorDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<OrderInvestorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderInvestorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadFile(body: InvestorDetailRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/InvestorDetail/DownloadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getListInvesterTransaction(body: InvestorDetailTransactionRequestDto | undefined): Observable<InvestorDetailTransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InvestorDetail/GetListInvesterTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListInvesterTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListInvesterTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorDetailTransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorDetailTransactionDto[]>;
        }));
    }

    protected processGetListInvesterTransaction(response: HttpResponseBase): Observable<InvestorDetailTransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(InvestorDetailTransactionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvestorHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLogInvestorHistory(body: CreateUpdateInvestorHistoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InvestorHistory/CreateLogInvestorHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLogInvestorHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLogInvestorHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLogInvestorHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: InvestorHistoryRequestDto | undefined): Observable<InvestorHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InvestorHistory/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvestorHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvestorHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<InvestorHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSaleInvestorCommission(body: InvestorHistoryRequestDto | undefined): Observable<SaleInvestorHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InvestorHistory/GetSaleInvestorCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaleInvestorCommission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleInvestorCommission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaleInvestorHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaleInvestorHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetSaleInvestorCommission(response: HttpResponseBase): Observable<SaleInvestorHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaleInvestorHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSaleInvestorCommissionSumary(): Observable<SaleInvestorCommissionSumaryDto> {
        let url_ = this.baseUrl + "/api/services/app/InvestorHistory/GetSaleInvestorCommissionSumary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSaleInvestorCommissionSumary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSaleInvestorCommissionSumary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaleInvestorCommissionSumaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaleInvestorCommissionSumaryDto>;
        }));
    }

    protected processGetSaleInvestorCommissionSumary(response: HttpResponseBase): Observable<SaleInvestorCommissionSumaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaleInvestorCommissionSumaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MachineConditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<MachineConditionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MachineCondition/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MachineConditionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MachineConditionDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<MachineConditionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineConditionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MachineConditionDto> {
        let url_ = this.baseUrl + "/api/services/app/MachineCondition/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MachineConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MachineConditionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MachineConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MachineConditionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateMachineConditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MachineCondition/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MachineCondition/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManagerAgencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param agencyId (optional) 
     * @return Success
     */
    getInfoAgency(agencyId: number | undefined): Observable<ManagerAgencyDto> {
        let url_ = this.baseUrl + "/api/services/app/ManagerAgency/GetInfoAgency?";
        if (agencyId === null)
            throw new Error("The parameter 'agencyId' cannot be null.");
        else if (agencyId !== undefined)
            url_ += "agencyId=" + encodeURIComponent("" + agencyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfoAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfoAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManagerAgencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManagerAgencyDto>;
        }));
    }

    protected processGetInfoAgency(response: HttpResponseBase): Observable<ManagerAgencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManagerAgencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: ManagerAgencyRequestDto | undefined): Observable<ManagerAgencyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ManagerAgency/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManagerAgencyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManagerAgencyDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<ManagerAgencyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManagerAgencyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param orderCode (optional) 
     * @param storeCode (optional) 
     * @return Success
     */
    calculateCommission(orderId: number | undefined, orderCode: string | undefined, storeCode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ManagerAgency/CalculateCommission?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (orderCode === null)
            throw new Error("The parameter 'orderCode' cannot be null.");
        else if (orderCode !== undefined)
            url_ += "orderCode=" + encodeURIComponent("" + orderCode) + "&";
        if (storeCode === null)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateCommission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateCommission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateCommission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSumaryAgency(): Observable<AgencySumaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ManagerAgency/GetSumaryAgency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSumaryAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSumaryAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencySumaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencySumaryDto>;
        }));
    }

    protected processGetSumaryAgency(response: HttpResponseBase): Observable<AgencySumaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencySumaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingInfoAgency(body: AgencyInfoRequestDto | undefined): Observable<AgencyInfoDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ManagerAgency/GetPagingInfoAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingInfoAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingInfoAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgencyInfoDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgencyInfoDtoPagedResultDto>;
        }));
    }

    protected processGetPagingInfoAgency(response: HttpResponseBase): Observable<AgencyInfoDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgencyInfoDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: OrderRequestDto | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param note (optional) 
     * @return Success
     */
    updateNoteOrder(orderId: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateNoteOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNoteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNoteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNoteOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param paymentApplicationFeeTarget (optional) 
     * @return Success
     */
    updatePaymentApplicationFeeTarget(orderId: number | undefined, paymentApplicationFeeTarget: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdatePaymentApplicationFeeTarget?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (paymentApplicationFeeTarget === null)
            throw new Error("The parameter 'paymentApplicationFeeTarget' cannot be null.");
        else if (paymentApplicationFeeTarget !== undefined)
            url_ += "paymentApplicationFeeTarget=" + encodeURIComponent("" + paymentApplicationFeeTarget) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentApplicationFeeTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentApplicationFeeTarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaymentApplicationFeeTarget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    uploadNoteOrder(files: FileParameter[] | undefined, listIdDelete: number[] | undefined, orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UploadNoteOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadNoteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadNoteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadNoteOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getById(orderId: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assingEmployee(body: AssingEmployeeRequestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/AssingEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssingEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssingEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssingEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getCustomerForEditById(orderId: number | undefined): Observable<CustomerOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetCustomerForEditById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerForEditById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerForEditById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOrderDto>;
        }));
    }

    protected processGetCustomerForEditById(response: HttpResponseBase): Observable<CustomerOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendContract(body: ResendContractDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/ResendContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param fullName (optional) 
     * @param phoneNumber (optional) 
     * @param email (optional) 
     * @param fileBefore (optional) 
     * @param fileAlter (optional) 
     * @param address (optional) 
     * @param cCCD (optional) 
     * @param listIdDelete (optional) 
     * @param issuingAuthority (optional) 
     * @param dateIssued (optional) 
     * @param birthday (optional) 
     * @param personRelativeDtoJson (optional) 
     * @return Success
     */
    updateCustomerOrder(orderId: number | undefined, fullName: string | undefined, phoneNumber: string | undefined, email: string | undefined, fileBefore: FileParameter | undefined, fileAlter: FileParameter | undefined, address: string | undefined, cCCD: string | undefined, listIdDelete: number[] | undefined, issuingAuthority: string | undefined, dateIssued: string | undefined, birthday: string | undefined, personRelativeDtoJson: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateCustomerOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (fullName === null || fullName === undefined)
            throw new Error("The parameter 'fullName' cannot be null.");
        else
            content_.append("FullName", fullName.toString());
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (fileBefore === null || fileBefore === undefined)
            throw new Error("The parameter 'fileBefore' cannot be null.");
        else
            content_.append("FileBefore", fileBefore.data, fileBefore.fileName ? fileBefore.fileName : "FileBefore");
        if (fileAlter === null || fileAlter === undefined)
            throw new Error("The parameter 'fileAlter' cannot be null.");
        else
            content_.append("FileAlter", fileAlter.data, fileAlter.fileName ? fileAlter.fileName : "FileAlter");
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (cCCD === null || cCCD === undefined)
            throw new Error("The parameter 'cCCD' cannot be null.");
        else
            content_.append("CCCD", cCCD.toString());
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (dateIssued === null || dateIssued === undefined)
            throw new Error("The parameter 'dateIssued' cannot be null.");
        else
            content_.append("DateIssued", dateIssued.toString());
        if (birthday === null || birthday === undefined)
            throw new Error("The parameter 'birthday' cannot be null.");
        else
            content_.append("Birthday", birthday.toString());
        if (personRelativeDtoJson === null || personRelativeDtoJson === undefined)
            throw new Error("The parameter 'personRelativeDtoJson' cannot be null.");
        else
            content_.append("PersonRelativeDtoJson", personRelativeDtoJson.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCustomerOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param note (optional) 
     * @return Success
     */
    approvedOrder(orderId: number | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/ApprovedOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovedOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    createSigned(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateSigned?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSigned(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param fileSeris (optional) 
     * @param listIdSeriDelete (optional) 
     * @param fileImeis (optional) 
     * @param listIdImeiDelete (optional) 
     * @param fileInfoDevices (optional) 
     * @param listIdFileInfoDeviceDelete (optional) 
     * @param fileInfoHandOvers (optional) 
     * @param listIdInfoHandOverDelete (optional) 
     * @param fileFileVideos (optional) 
     * @param listIdFileVideoDelete (optional) 
     * @param fileTransactionFirsts (optional) 
     * @param listIdTransactionFirstDelete (optional) 
     * @return Success
     */
    editFileOrder(orderId: number | undefined, fileSeris: FileParameter[] | undefined, listIdSeriDelete: number[] | undefined, fileImeis: FileParameter[] | undefined, listIdImeiDelete: number[] | undefined, fileInfoDevices: FileParameter[] | undefined, listIdFileInfoDeviceDelete: number[] | undefined, fileInfoHandOvers: FileParameter[] | undefined, listIdInfoHandOverDelete: number[] | undefined, fileFileVideos: FileParameter[] | undefined, listIdFileVideoDelete: number[] | undefined, fileTransactionFirsts: FileParameter[] | undefined, listIdTransactionFirstDelete: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/EditFileOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (fileSeris === null || fileSeris === undefined)
            throw new Error("The parameter 'fileSeris' cannot be null.");
        else
            fileSeris.forEach(item_ => content_.append("FileSeris", item_.data, item_.fileName ? item_.fileName : "FileSeris") );
        if (listIdSeriDelete === null || listIdSeriDelete === undefined)
            throw new Error("The parameter 'listIdSeriDelete' cannot be null.");
        else
            listIdSeriDelete.forEach(item_ => content_.append("ListIdSeriDelete", item_.toString()));
        if (fileImeis === null || fileImeis === undefined)
            throw new Error("The parameter 'fileImeis' cannot be null.");
        else
            fileImeis.forEach(item_ => content_.append("FileImeis", item_.data, item_.fileName ? item_.fileName : "FileImeis") );
        if (listIdImeiDelete === null || listIdImeiDelete === undefined)
            throw new Error("The parameter 'listIdImeiDelete' cannot be null.");
        else
            listIdImeiDelete.forEach(item_ => content_.append("ListIdImeiDelete", item_.toString()));
        if (fileInfoDevices === null || fileInfoDevices === undefined)
            throw new Error("The parameter 'fileInfoDevices' cannot be null.");
        else
            fileInfoDevices.forEach(item_ => content_.append("FileInfoDevices", item_.data, item_.fileName ? item_.fileName : "FileInfoDevices") );
        if (listIdFileInfoDeviceDelete === null || listIdFileInfoDeviceDelete === undefined)
            throw new Error("The parameter 'listIdFileInfoDeviceDelete' cannot be null.");
        else
            listIdFileInfoDeviceDelete.forEach(item_ => content_.append("ListIdFileInfoDeviceDelete", item_.toString()));
        if (fileInfoHandOvers === null || fileInfoHandOvers === undefined)
            throw new Error("The parameter 'fileInfoHandOvers' cannot be null.");
        else
            fileInfoHandOvers.forEach(item_ => content_.append("FileInfoHandOvers", item_.data, item_.fileName ? item_.fileName : "FileInfoHandOvers") );
        if (listIdInfoHandOverDelete === null || listIdInfoHandOverDelete === undefined)
            throw new Error("The parameter 'listIdInfoHandOverDelete' cannot be null.");
        else
            listIdInfoHandOverDelete.forEach(item_ => content_.append("ListIdInfoHandOverDelete", item_.toString()));
        if (fileFileVideos === null || fileFileVideos === undefined)
            throw new Error("The parameter 'fileFileVideos' cannot be null.");
        else
            fileFileVideos.forEach(item_ => content_.append("FileFileVideos", item_.data, item_.fileName ? item_.fileName : "FileFileVideos") );
        if (listIdFileVideoDelete === null || listIdFileVideoDelete === undefined)
            throw new Error("The parameter 'listIdFileVideoDelete' cannot be null.");
        else
            listIdFileVideoDelete.forEach(item_ => content_.append("ListIdFileVideoDelete", item_.toString()));
        if (fileTransactionFirsts === null || fileTransactionFirsts === undefined)
            throw new Error("The parameter 'fileTransactionFirsts' cannot be null.");
        else
            fileTransactionFirsts.forEach(item_ => content_.append("FileTransactionFirsts", item_.data, item_.fileName ? item_.fileName : "FileTransactionFirsts") );
        if (listIdTransactionFirstDelete === null || listIdTransactionFirstDelete === undefined)
            throw new Error("The parameter 'listIdTransactionFirstDelete' cannot be null.");
        else
            listIdTransactionFirstDelete.forEach(item_ => content_.append("ListIdTransactionFirstDelete", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditFileOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditFileOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditFileOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param seri (optional) 
     * @param note (optional) 
     * @param orderId (optional) 
     * @param fileSeris (optional) 
     * @param listIdSeriDelete (optional) 
     * @param imei (optional) 
     * @param fileImeis (optional) 
     * @param listIdImeiDelete (optional) 
     * @param isEdit (optional) 
     * @return Success
     */
    createSeriOrder(seri: string | undefined, note: string | undefined, orderId: number | undefined, fileSeris: FileParameter[] | undefined, listIdSeriDelete: number[] | undefined, imei: string | undefined, fileImeis: FileParameter[] | undefined, listIdImeiDelete: number[] | undefined, isEdit: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateSeriOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (seri === null || seri === undefined)
            throw new Error("The parameter 'seri' cannot be null.");
        else
            content_.append("Seri", seri.toString());
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (fileSeris === null || fileSeris === undefined)
            throw new Error("The parameter 'fileSeris' cannot be null.");
        else
            fileSeris.forEach(item_ => content_.append("FileSeris", item_.data, item_.fileName ? item_.fileName : "FileSeris") );
        if (listIdSeriDelete === null || listIdSeriDelete === undefined)
            throw new Error("The parameter 'listIdSeriDelete' cannot be null.");
        else
            listIdSeriDelete.forEach(item_ => content_.append("ListIdSeriDelete", item_.toString()));
        if (imei === null || imei === undefined)
            throw new Error("The parameter 'imei' cannot be null.");
        else
            content_.append("Imei", imei.toString());
        if (fileImeis === null || fileImeis === undefined)
            throw new Error("The parameter 'fileImeis' cannot be null.");
        else
            fileImeis.forEach(item_ => content_.append("FileImeis", item_.data, item_.fileName ? item_.fileName : "FileImeis") );
        if (listIdImeiDelete === null || listIdImeiDelete === undefined)
            throw new Error("The parameter 'listIdImeiDelete' cannot be null.");
        else
            listIdImeiDelete.forEach(item_ => content_.append("ListIdImeiDelete", item_.toString()));
        if (isEdit === null || isEdit === undefined)
            throw new Error("The parameter 'isEdit' cannot be null.");
        else
            content_.append("IsEdit", isEdit.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSeriOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSeriOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateSeriOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param note (optional) 
     * @param sid (optional) 
     * @param pathFileFromSystem (optional) 
     * @return Success
     */
    createContractSystem(orderId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, note: string | undefined, sid: string | undefined, pathFileFromSystem: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateContractSystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());
        if (sid === null || sid === undefined)
            throw new Error("The parameter 'sid' cannot be null.");
        else
            content_.append("Sid", sid.toString());
        if (pathFileFromSystem === null || pathFileFromSystem === undefined)
            throw new Error("The parameter 'pathFileFromSystem' cannot be null.");
        else
            content_.append("PathFileFromSystem", pathFileFromSystem.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContractSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContractSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateContractSystem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param note (optional) 
     * @param sid (optional) 
     * @param pathFileFromSystem (optional) 
     * @return Success
     */
    createContract(orderId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, note: string | undefined, sid: string | undefined, pathFileFromSystem: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CreateContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());
        if (sid === null || sid === undefined)
            throw new Error("The parameter 'sid' cannot be null.");
        else
            content_.append("Sid", sid.toString());
        if (pathFileFromSystem === null || pathFileFromSystem === undefined)
            throw new Error("The parameter 'pathFileFromSystem' cannot be null.");
        else
            content_.append("PathFileFromSystem", pathFileFromSystem.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param note (optional) 
     * @return Success
     */
    updateInfoDevice(orderId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateInfoDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfoDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfoDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInfoDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param note (optional) 
     * @return Success
     */
    updateInfoHandOver(orderId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/UpdateInfoHandOver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfoHandOver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfoHandOver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInfoHandOver(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param note (optional) 
     * @return Success
     */
    settlement(orderId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, note: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/Settlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSettlement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectConfirm(body: RejectConfirmDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/RejectConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectConfirm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param reason (optional) 
     * @return Success
     */
    cancelledOrder(orderId: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/CancelledOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelledOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelledOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelledOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getFinalSettlementInfo(orderId: number | undefined): Observable<FinalSettlementOrderDto> {
        let url_ = this.baseUrl + "/api/services/app/Order/GetFinalSettlementInfo?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinalSettlementInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinalSettlementInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinalSettlementOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinalSettlementOrderDto>;
        }));
    }

    protected processGetFinalSettlementInfo(response: HttpResponseBase): Observable<FinalSettlementOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinalSettlementOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @param fileFinalSettlements (optional) 
     * @param listFinalSettlementIdDelete (optional) 
     * @return Success
     */
    finalSettlementOrder(orderId: number | undefined, fileFinalSettlements: FileParameter[] | undefined, listFinalSettlementIdDelete: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/FinalSettlementOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (orderId === null || orderId === undefined)
            throw new Error("The parameter 'orderId' cannot be null.");
        else
            content_.append("OrderId", orderId.toString());
        if (fileFinalSettlements === null || fileFinalSettlements === undefined)
            throw new Error("The parameter 'fileFinalSettlements' cannot be null.");
        else
            fileFinalSettlements.forEach(item_ => content_.append("FileFinalSettlements", item_.data, item_.fileName ? item_.fileName : "FileFinalSettlements") );
        if (listFinalSettlementIdDelete === null || listFinalSettlementIdDelete === undefined)
            throw new Error("The parameter 'listFinalSettlementIdDelete' cannot be null.");
        else
            listFinalSettlementIdDelete.forEach(item_ => content_.append("ListFinalSettlementIdDelete", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalSettlementOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalSettlementOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinalSettlementOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestForSettlement(body: RequestForSettlementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Order/RequestForSettlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestForSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestForSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestForSettlement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editOrderDetail(body: EditOrderDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/EditOrderDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditOrderDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderDetailId (optional) 
     * @return Success
     */
    getById(orderDetailId: number | undefined): Observable<OrderDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetById?";
        if (orderDetailId === null)
            throw new Error("The parameter 'orderDetailId' cannot be null.");
        else if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrderDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: OrderDetailRequestModel | undefined): Observable<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetail/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderDetailPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingOrderDetail(body: OrderDetailRequestModel | undefined): Observable<OrderDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderDetailPublic/GetPagingOrderDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDetailDtoPagedResultDto>;
        }));
    }

    protected processGetPagingOrderDetail(response: HttpResponseBase): Observable<OrderDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param transactionId (optional) 
     * @param bankCode (optional) 
     * @return Success
     */
    createOrderTransactionVnpay(transactionId: number | undefined, bankCode: string | undefined): Observable<OrderPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPayment/CreateOrderTransactionVnpay?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        if (bankCode === null)
            throw new Error("The parameter 'bankCode' cannot be null.");
        else if (bankCode !== undefined)
            url_ += "bankCode=" + encodeURIComponent("" + bankCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderTransactionVnpay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderTransactionVnpay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPaymentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPaymentResponseDto>;
        }));
    }

    protected processCreateOrderTransactionVnpay(response: HttpResponseBase): Observable<OrderPaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refData (optional) 
     * @return Success
     */
    callbackVNPay(refData: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderPayment/CallbackVNPay?";
        if (refData === null)
            throw new Error("The parameter 'refData' cannot be null.");
        else if (refData !== undefined)
            url_ += "refData=" + encodeURIComponent("" + refData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallbackVNPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallbackVNPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallbackVNPay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getById(orderId: number | undefined): Observable<OrderDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPublic/GetById?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<OrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productStoreDetailId (optional) 
     * @param prepayPrice (optional) 
     * @param leaseTermCode (optional) 
     * @param storeCode (optional) 
     * @param price (optional) 
     * @return Success
     */
    getTransactionsByOrderDetail(productStoreDetailId: number | undefined, prepayPrice: number | undefined, leaseTermCode: number | undefined, storeCode: string | undefined, price: number | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrderPublic/GetTransactionsByOrderDetail?";
        if (productStoreDetailId === null)
            throw new Error("The parameter 'productStoreDetailId' cannot be null.");
        else if (productStoreDetailId !== undefined)
            url_ += "productStoreDetailId=" + encodeURIComponent("" + productStoreDetailId) + "&";
        if (prepayPrice === null)
            throw new Error("The parameter 'prepayPrice' cannot be null.");
        else if (prepayPrice !== undefined)
            url_ += "prepayPrice=" + encodeURIComponent("" + prepayPrice) + "&";
        if (leaseTermCode === null)
            throw new Error("The parameter 'leaseTermCode' cannot be null.");
        else if (leaseTermCode !== undefined)
            url_ += "leaseTermCode=" + encodeURIComponent("" + leaseTermCode) + "&";
        if (storeCode === null)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionsByOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsByOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetTransactionsByOrderDetail(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param password (optional) 
     * @param personId (optional) 
     * @param fullName (optional) 
     * @param cCCD (optional) 
     * @param phoneNumber (optional) 
     * @param email (optional) 
     * @param issuingAuthority (optional) 
     * @param dateIssued (optional) 
     * @param birthday (optional) 
     * @param address (optional) 
     * @param note (optional) 
     * @param storeCode (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param productStoreDetailCode (optional) 
     * @param productStoreCode (optional) 
     * @param productName (optional) 
     * @param price (optional) 
     * @param leaseTermCode (optional) 
     * @param prepayPrice (optional) 
     * @param machineConditionCode (optional) 
     * @param personRelativeJson (optional) 
     * @param seri (optional) 
     * @param imei (optional) 
     * @param fileSeris (optional) 
     * @param fileImeils (optional) 
     * @param fileVideos (optional) 
     * @return Success
     */
    createDataOrder(password: string | undefined, personId: number | undefined, fullName: string | undefined, cCCD: string | undefined, phoneNumber: string | undefined, email: string | undefined, issuingAuthority: string | undefined, dateIssued: string | undefined, birthday: string | undefined, address: string | undefined, note: string | undefined, storeCode: string | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, productStoreDetailCode: string | undefined, productStoreCode: string | undefined, productName: string | undefined, price: number | undefined, leaseTermCode: number | undefined, prepayPrice: number | undefined, machineConditionCode: string | undefined, personRelativeJson: string | undefined, seri: string | undefined, imei: string | undefined, fileSeris: FileParameter[] | undefined, fileImeils: FileParameter[] | undefined, fileVideos: FileParameter[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderPublic/CreateDataOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());
        if (personId === null || personId === undefined)
            throw new Error("The parameter 'personId' cannot be null.");
        else
            content_.append("PersonId", personId.toString());
        if (fullName === null || fullName === undefined)
            throw new Error("The parameter 'fullName' cannot be null.");
        else
            content_.append("FullName", fullName.toString());
        if (cCCD === null || cCCD === undefined)
            throw new Error("The parameter 'cCCD' cannot be null.");
        else
            content_.append("CCCD", cCCD.toString());
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (dateIssued === null || dateIssued === undefined)
            throw new Error("The parameter 'dateIssued' cannot be null.");
        else
            content_.append("DateIssued", dateIssued.toString());
        if (birthday === null || birthday === undefined)
            throw new Error("The parameter 'birthday' cannot be null.");
        else
            content_.append("Birthday", birthday.toString());
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("Note", note.toString());
        if (storeCode === null || storeCode === undefined)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else
            content_.append("StoreCode", storeCode.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (productStoreDetailCode === null || productStoreDetailCode === undefined)
            throw new Error("The parameter 'productStoreDetailCode' cannot be null.");
        else
            content_.append("ProductStoreDetailCode", productStoreDetailCode.toString());
        if (productStoreCode === null || productStoreCode === undefined)
            throw new Error("The parameter 'productStoreCode' cannot be null.");
        else
            content_.append("ProductStoreCode", productStoreCode.toString());
        if (productName === null || productName === undefined)
            throw new Error("The parameter 'productName' cannot be null.");
        else
            content_.append("ProductName", productName.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (leaseTermCode === null || leaseTermCode === undefined)
            throw new Error("The parameter 'leaseTermCode' cannot be null.");
        else
            content_.append("LeaseTermCode", leaseTermCode.toString());
        if (prepayPrice === null || prepayPrice === undefined)
            throw new Error("The parameter 'prepayPrice' cannot be null.");
        else
            content_.append("PrepayPrice", prepayPrice.toString());
        if (machineConditionCode === null || machineConditionCode === undefined)
            throw new Error("The parameter 'machineConditionCode' cannot be null.");
        else
            content_.append("MachineConditionCode", machineConditionCode.toString());
        if (personRelativeJson === null || personRelativeJson === undefined)
            throw new Error("The parameter 'personRelativeJson' cannot be null.");
        else
            content_.append("PersonRelativeJson", personRelativeJson.toString());
        if (seri === null || seri === undefined)
            throw new Error("The parameter 'seri' cannot be null.");
        else
            content_.append("Seri", seri.toString());
        if (imei === null || imei === undefined)
            throw new Error("The parameter 'imei' cannot be null.");
        else
            content_.append("Imei", imei.toString());
        if (fileSeris === null || fileSeris === undefined)
            throw new Error("The parameter 'fileSeris' cannot be null.");
        else
            fileSeris.forEach(item_ => content_.append("FileSeris", item_.data, item_.fileName ? item_.fileName : "FileSeris") );
        if (fileImeils === null || fileImeils === undefined)
            throw new Error("The parameter 'fileImeils' cannot be null.");
        else
            fileImeils.forEach(item_ => content_.append("FileImeils", item_.data, item_.fileName ? item_.fileName : "FileImeils") );
        if (fileVideos === null || fileVideos === undefined)
            throw new Error("The parameter 'fileVideos' cannot be null.");
        else
            fileVideos.forEach(item_ => content_.append("FileVideos", item_.data, item_.fileName ? item_.fileName : "FileVideos") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDataOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDataOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDataOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    delete(orderId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderPublic/Delete?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingData(body: OrderRequestDto | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPublic/GetPagingData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDtoPagedResultDto>;
        }));
    }

    protected processGetPagingData(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingOrderCurent(body: OrderRequestDto | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderPublic/GetPagingOrderCurent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingOrderCurent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingOrderCurent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDtoPagedResultDto>;
        }));
    }

    protected processGetPagingOrderCurent(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OtpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param phone (optional) 
     * @param otp (optional) 
     * @return Success
     */
    sendMultiChannelMessage(phone: string | undefined, otp: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Otp/SendMultiChannelMessage?";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (otp === null)
            throw new Error("The parameter 'otp' cannot be null.");
        else if (otp !== undefined)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMultiChannelMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMultiChannelMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendMultiChannelMessage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phone (optional) 
     * @param otp (optional) 
     * @param campaignid (optional) 
     * @return Success
     */
    sendMessage(phone: string | undefined, otp: string | undefined, campaignid: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Otp/SendMessage?";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (otp === null)
            throw new Error("The parameter 'otp' cannot be null.");
        else if (otp !== undefined)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        if (campaignid === null)
            throw new Error("The parameter 'campaignid' cannot be null.");
        else if (campaignid !== undefined)
            url_ += "campaignid=" + encodeURIComponent("" + campaignid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSendMessage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OtpSpamLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param ip (optional) 
     * @param userAgent (optional) 
     * @return Success
     */
    checkSpam(ip: string | undefined, userAgent: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OtpSpamLog/CheckSpam?";
        if (ip === null)
            throw new Error("The parameter 'ip' cannot be null.");
        else if (ip !== undefined)
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        if (userAgent === null)
            throw new Error("The parameter 'userAgent' cannot be null.");
        else if (userAgent !== undefined)
            url_ += "userAgent=" + encodeURIComponent("" + userAgent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSpam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSpam(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckSpam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param idObject (optional) 
     * @param price (optional) 
     * @param description (optional) 
     * @param redirectUrl (optional) 
     * @param callbackUrl (optional) 
     * @return Success
     */
    createPaymentZalo(idObject: number | undefined, price: number | undefined, description: string | undefined, redirectUrl: string | undefined, callbackUrl: string | undefined): Observable<ZaloPayCreateOrderResponse> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePaymentZalo?";
        if (idObject === null)
            throw new Error("The parameter 'idObject' cannot be null.");
        else if (idObject !== undefined)
            url_ += "idObject=" + encodeURIComponent("" + idObject) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        if (callbackUrl === null)
            throw new Error("The parameter 'callbackUrl' cannot be null.");
        else if (callbackUrl !== undefined)
            url_ += "callbackUrl=" + encodeURIComponent("" + callbackUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentZalo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentZalo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZaloPayCreateOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZaloPayCreateOrderResponse>;
        }));
    }

    protected processCreatePaymentZalo(response: HttpResponseBase): Observable<ZaloPayCreateOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZaloPayCreateOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idObject (optional) 
     * @param price (optional) 
     * @param description (optional) 
     * @param redirectUrl (optional) 
     * @param callbackUrl (optional) 
     * @return Success
     */
    createPaymentTopPay(idObject: number | undefined, price: number | undefined, description: string | undefined, redirectUrl: string | undefined, callbackUrl: string | undefined): Observable<TopPayCreateOrderResponse> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePaymentTopPay?";
        if (idObject === null)
            throw new Error("The parameter 'idObject' cannot be null.");
        else if (idObject !== undefined)
            url_ += "idObject=" + encodeURIComponent("" + idObject) + "&";
        if (price === null)
            throw new Error("The parameter 'price' cannot be null.");
        else if (price !== undefined)
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        if (callbackUrl === null)
            throw new Error("The parameter 'callbackUrl' cannot be null.");
        else if (callbackUrl !== undefined)
            url_ += "callbackUrl=" + encodeURIComponent("" + callbackUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentTopPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentTopPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopPayCreateOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopPayCreateOrderResponse>;
        }));
    }

    protected processCreatePaymentTopPay(response: HttpResponseBase): Observable<TopPayCreateOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopPayCreateOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param idObject (optional) 
     * @param typePayment (optional) 
     * @param amount (optional) 
     * @param description (optional) 
     * @param redirectUrl (optional) 
     * @param bankCode (optional) 
     * @return Success
     */
    createPaymentVNPayUrl(idObject: number | undefined, typePayment: string | undefined, amount: number | undefined, description: string | undefined, redirectUrl: string | undefined, bankCode: string | undefined): Observable<VNPayResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePaymentVNPayUrl?";
        if (idObject === null)
            throw new Error("The parameter 'idObject' cannot be null.");
        else if (idObject !== undefined)
            url_ += "idObject=" + encodeURIComponent("" + idObject) + "&";
        if (typePayment === null)
            throw new Error("The parameter 'typePayment' cannot be null.");
        else if (typePayment !== undefined)
            url_ += "typePayment=" + encodeURIComponent("" + typePayment) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        if (bankCode === null)
            throw new Error("The parameter 'bankCode' cannot be null.");
        else if (bankCode !== undefined)
            url_ += "bankCode=" + encodeURIComponent("" + bankCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentVNPayUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentVNPayUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VNPayResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VNPayResponseDto>;
        }));
    }

    protected processCreatePaymentVNPayUrl(response: HttpResponseBase): Observable<VNPayResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VNPayResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    isDuplicate(phoneNumber: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Person/IsDuplicate?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDuplicate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownRecall(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownRecall";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownRecall(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownRecall(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownRecall(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownProcessor(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownProcessor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownProcessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownProcessor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownProcessor(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownAgency(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownAgency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownAgency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownAgency(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownSale(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownSale";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownSale(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownStore(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownStore(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownInvestor(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownInvestor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownInvestor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownInvestor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownInvestor(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllForDropdownManagerSystem(): Observable<PersonSelectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAllForDropdownManagerSystem";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdownManagerSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdownManagerSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonSelectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonSelectDto[]>;
        }));
    }

    protected processGetAllForDropdownManagerSystem(response: HttpResponseBase): Observable<PersonSelectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonSelectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    forgotPassword(phoneNumber: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Person/ForgotPassword?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getPersonByOrderId(orderId: number | undefined): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetPersonByOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto>;
        }));
    }

    protected processGetPersonByOrderId(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCurrentPerson(body: PersonRequestModel | undefined): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetCurrentPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDto>;
        }));
    }

    protected processGetCurrentPerson(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param emailAddress (optional) 
     * @param userId (optional) 
     * @param fileBefore (optional) 
     * @param fileAlter (optional) 
     * @param address (optional) 
     * @param cCCD (optional) 
     * @param listIdDelete (optional) 
     * @param personRelativeDtoJson (optional) 
     * @param issuingAuthority (optional) 
     * @param dateIssued (optional) 
     * @param birthday (optional) 
     * @return Success
     */
    updatePerson(id: number | undefined, name: string | undefined, emailAddress: string | undefined, userId: number | undefined, fileBefore: FileParameter | undefined, fileAlter: FileParameter | undefined, address: string | undefined, cCCD: string | undefined, listIdDelete: number[] | undefined, personRelativeDtoJson: string | undefined, issuingAuthority: string | undefined, dateIssued: string | undefined, birthday: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Person/UpdatePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (emailAddress === null || emailAddress === undefined)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else
            content_.append("EmailAddress", emailAddress.toString());
        if (userId === null || userId === undefined)
            throw new Error("The parameter 'userId' cannot be null.");
        else
            content_.append("UserId", userId.toString());
        if (fileBefore === null || fileBefore === undefined)
            throw new Error("The parameter 'fileBefore' cannot be null.");
        else
            content_.append("FileBefore", fileBefore.data, fileBefore.fileName ? fileBefore.fileName : "FileBefore");
        if (fileAlter === null || fileAlter === undefined)
            throw new Error("The parameter 'fileAlter' cannot be null.");
        else
            content_.append("FileAlter", fileAlter.data, fileAlter.fileName ? fileAlter.fileName : "FileAlter");
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (cCCD === null || cCCD === undefined)
            throw new Error("The parameter 'cCCD' cannot be null.");
        else
            content_.append("CCCD", cCCD.toString());
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (personRelativeDtoJson === null || personRelativeDtoJson === undefined)
            throw new Error("The parameter 'personRelativeDtoJson' cannot be null.");
        else
            content_.append("PersonRelativeDtoJson", personRelativeDtoJson.toString());
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (dateIssued === null || dateIssued === undefined)
            throw new Error("The parameter 'dateIssued' cannot be null.");
        else
            content_.append("DateIssued", dateIssued.toString());
        if (birthday === null || birthday === undefined)
            throw new Error("The parameter 'birthday' cannot be null.");
        else
            content_.append("Birthday", birthday.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePerson(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    isExistPhoneNumber(phoneNumber: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Person/IsExistPhoneNumber?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsExistPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExistPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsExistPhoneNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonRelativeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdatePersonRelativeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonRelative/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRange(body: CreateOrUpdatePersonRelativeDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonRelative/CreateOrUpdateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phoneNumberUser (optional) 
     * @return Success
     */
    deletePersonRelativeByUserId(phoneNumberUser: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonRelative/DeletePersonRelativeByUserId?";
        if (phoneNumberUser === null)
            throw new Error("The parameter 'phoneNumberUser' cannot be null.");
        else if (phoneNumberUser !== undefined)
            url_ += "phoneNumberUser=" + encodeURIComponent("" + phoneNumberUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePersonRelativeByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePersonRelativeByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePersonRelativeByUserId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCurrentPersonRelative(): Observable<PersonRelativeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonRelative/GetAllCurrentPersonRelative";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCurrentPersonRelative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCurrentPersonRelative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRelativeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRelativeDto[]>;
        }));
    }

    protected processGetAllCurrentPersonRelative(response: HttpResponseBase): Observable<PersonRelativeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonRelativeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phoneNumberUser (optional) 
     * @return Success
     */
    getAllPersonRelative(phoneNumberUser: string | undefined): Observable<PersonRelativeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonRelative/GetAllPersonRelative?";
        if (phoneNumberUser === null)
            throw new Error("The parameter 'phoneNumberUser' cannot be null.");
        else if (phoneNumberUser !== undefined)
            url_ += "phoneNumberUser=" + encodeURIComponent("" + phoneNumberUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPersonRelative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPersonRelative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonRelativeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonRelativeDto[]>;
        }));
    }

    protected processGetAllPersonRelative(response: HttpResponseBase): Observable<PersonRelativeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PersonRelativeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PostLeaseManagementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: OrderRequestDto | undefined): Observable<OrderDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PostLeaseManagement/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<OrderDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setInvestorOrder(body: UpdatePostLeaseManagement | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostLeaseManagement/SetInvestorOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetInvestorOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetInvestorOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetInvestorOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllForDropdown(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetAllForDropdown(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateProductDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    validateDelete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/ValidateDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductStoreServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: BaseRequest | undefined): Observable<ProductStoreDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<ProductStoreDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductStoreDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productStoreId (optional) 
     * @return Success
     */
    getListProductDetailStore(productStoreId: number[] | undefined): Observable<ProductStoreDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/GetListProductDetailStore?";
        if (productStoreId === null)
            throw new Error("The parameter 'productStoreId' cannot be null.");
        else if (productStoreId !== undefined)
            productStoreId && productStoreId.forEach(item => { url_ += "productStoreId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListProductDetailStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListProductDetailStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDetailDto[]>;
        }));
    }

    protected processGetListProductDetailStore(response: HttpResponseBase): Observable<ProductStoreDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductStoreDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDetail(id: number | undefined): Observable<ProductStoreDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/GetDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDto>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<ProductStoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductStoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param storeCode (optional) 
     * @return Success
     */
    getListProductStoreByStore(storeCode: string | undefined): Observable<ProductStoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/GetListProductStoreByStore?";
        if (storeCode === null)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListProductStoreByStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListProductStoreByStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDto[]>;
        }));
    }

    protected processGetListProductStoreByStore(response: HttpResponseBase): Observable<ProductStoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductStoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param code (optional) 
     * @param storeCode (optional) 
     * @param productCode (optional) 
     * @param pathImage (optional) 
     * @param price (optional) 
     * @param stars (optional) 
     * @param sold (optional) 
     * @param count (optional) 
     * @param listProductStoreDetailDto (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    createOrEdit(id: number | undefined, code: string | undefined, storeCode: string | undefined, productCode: string | undefined, pathImage: string | undefined, price: number | undefined, stars: number | undefined, sold: number | undefined, count: number | undefined, listProductStoreDetailDto: ProductStoreDetailDto[] | undefined, isActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (code === null || code === undefined)
            throw new Error("The parameter 'code' cannot be null.");
        else
            content_.append("Code", code.toString());
        if (storeCode === null || storeCode === undefined)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else
            content_.append("StoreCode", storeCode.toString());
        if (productCode === null || productCode === undefined)
            throw new Error("The parameter 'productCode' cannot be null.");
        else
            content_.append("ProductCode", productCode.toString());
        if (pathImage === null || pathImage === undefined)
            throw new Error("The parameter 'pathImage' cannot be null.");
        else
            content_.append("PathImage", pathImage.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (stars === null || stars === undefined)
            throw new Error("The parameter 'stars' cannot be null.");
        else
            content_.append("Stars", stars.toString());
        if (sold === null || sold === undefined)
            throw new Error("The parameter 'sold' cannot be null.");
        else
            content_.append("Sold", sold.toString());
        if (count === null || count === undefined)
            throw new Error("The parameter 'count' cannot be null.");
        else
            content_.append("Count", count.toString());
        if (listProductStoreDetailDto === null || listProductStoreDetailDto === undefined)
            throw new Error("The parameter 'listProductStoreDetailDto' cannot be null.");
        else
            listProductStoreDetailDto.forEach(item_ => content_.append("ListProductStoreDetailDto", item_.toString()));
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param storeCode (optional) 
     * @return Success
     */
    deleteByStoreCode(storeCode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/DeleteByStoreCode?";
        if (storeCode === null)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByStoreCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByStoreCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByStoreCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    deleteByListId(listId: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/DeleteByListId?";
        if (listId === null)
            throw new Error("The parameter 'listId' cannot be null.");
        else if (listId !== undefined)
            listId && listId.forEach(item => { url_ += "listId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByListId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByListId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByListId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductStore/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductStoreDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param productId (optional) 
     * @param colorCode (optional) 
     * @param capacityCode (optional) 
     * @return Success
     */
    getProductStoreDetailIdByFilter(productId: string | undefined, colorCode: string | undefined, capacityCode: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProductStoreDetail/GetProductStoreDetailIdByFilter?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (colorCode === null)
            throw new Error("The parameter 'colorCode' cannot be null.");
        else if (colorCode !== undefined)
            url_ += "ColorCode=" + encodeURIComponent("" + colorCode) + "&";
        if (capacityCode === null)
            throw new Error("The parameter 'capacityCode' cannot be null.");
        else if (capacityCode !== undefined)
            url_ += "CapacityCode=" + encodeURIComponent("" + capacityCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductStoreDetailIdByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStoreDetailIdByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProductStoreDetailIdByFilter(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param listId (optional) 
     * @return Success
     */
    deleteByListId(listId: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProductStoreDetail/DeleteByListId?";
        if (listId === null)
            throw new Error("The parameter 'listId' cannot be null.");
        else if (listId !== undefined)
            listId && listId.forEach(item => { url_ += "listId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByListId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByListId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByListId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductStorePublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingFeaturedProduct(body: BaseRequest | undefined): Observable<ProductStoreDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductStorePublic/GetPagingFeaturedProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingFeaturedProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingFeaturedProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDtoPagedResultDto>;
        }));
    }

    protected processGetPagingFeaturedProduct(response: HttpResponseBase): Observable<ProductStoreDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductStoreDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param productCode (optional) 
     * @param machineConditionCode (optional) 
     * @return Success
     */
    getListStoreByProductCode(productCode: string | undefined, machineConditionCode: string | undefined): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProductStorePublic/GetListStoreByProductCode?";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        if (machineConditionCode === null)
            throw new Error("The parameter 'machineConditionCode' cannot be null.");
        else if (machineConditionCode !== undefined)
            url_ += "machineConditionCode=" + encodeURIComponent("" + machineConditionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListStoreByProductCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListStoreByProductCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetListStoreByProductCode(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param machineConditionCode (optional) 
     * @return Success
     */
    getDetail(id: number | undefined, machineConditionCode: string | undefined): Observable<ProductStoreDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductStorePublic/GetDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (machineConditionCode === null)
            throw new Error("The parameter 'machineConditionCode' cannot be null.");
        else if (machineConditionCode !== undefined)
            url_ += "machineConditionCode=" + encodeURIComponent("" + machineConditionCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDto>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<ProductStoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductStoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param storeCode (optional) 
     * @return Success
     */
    getProductStoreStoreCode(storeCode: string | undefined): Observable<ProductStoreWrapDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductStorePublic/GetProductStoreStoreCode?";
        if (storeCode === null)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductStoreStoreCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStoreStoreCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreWrapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreWrapDto>;
        }));
    }

    protected processGetProductStoreStoreCode(response: HttpResponseBase): Observable<ProductStoreWrapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductStoreWrapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPagingFilter(body: ProductStoreRequestModel | undefined): Observable<ProductStoreDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProductStorePublic/GetPagingFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagingFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagingFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductStoreDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductStoreDtoPagedResultDto>;
        }));
    }

    protected processGetPagingFilter(response: HttpResponseBase): Observable<ProductStoreDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductStoreDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProvinceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    initProvince(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Province/InitProvince";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitProvince(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitProvince(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllProvince(): Observable<ProvinceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Province/GetAllProvince";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProvince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProvince(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvinceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvinceDto[]>;
        }));
    }

    protected processGetAllProvince(response: HttpResponseBase): Observable<ProvinceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProvinceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getAllWard(code: string | undefined): Observable<ProvinceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Province/GetAllWard?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvinceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvinceDto[]>;
        }));
    }

    protected processGetAllWard(response: HttpResponseBase): Observable<ProvinceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProvinceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getReportUserRenting(body: ReportUserRentingRequestDto | undefined): Observable<ReportUserRentingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetReportUserRenting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportUserRenting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportUserRenting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportUserRentingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportUserRentingDtoPagedResultDto>;
        }));
    }

    protected processGetReportUserRenting(response: HttpResponseBase): Observable<ReportUserRentingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportUserRentingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportUserRentingReport(body: ReportUserRentingRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/ExportUserRentingReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportUserRentingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportUserRentingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportUserRentingReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getReportDisbursementAgent(body: DisbursementAgentRequestDto | undefined): Observable<DisbursementAgentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetReportDisbursementAgent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDisbursementAgent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDisbursementAgent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisbursementAgentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisbursementAgentDtoPagedResultDto>;
        }));
    }

    protected processGetReportDisbursementAgent(response: HttpResponseBase): Observable<DisbursementAgentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisbursementAgentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportDisbursementAgentReport(body: DisbursementAgentRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/ExportDisbursementAgentReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportDisbursementAgentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportDisbursementAgentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportDisbursementAgentReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTransactionReport(body: TransactionReportRequestDto | undefined): Observable<TransactionReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetTransactionReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionReportDtoPagedResultDto>;
        }));
    }

    protected processGetTransactionReport(response: HttpResponseBase): Observable<TransactionReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadTransactionReport(body: TransactionReportRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/DownloadTransactionReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTransactionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTransactionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadTransactionReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderReport(body: OrderReportRequestDto | undefined): Observable<OrderReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetOrderReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderReportDtoPagedResultDto>;
        }));
    }

    protected processGetOrderReport(response: HttpResponseBase): Observable<OrderReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadFile(body: OrderReportRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Report/DownloadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StoreServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllStore(): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetAllStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetAllStore(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param storeName (optional) 
     * @return Success
     */
    isDuplicate(storeName: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Store/IsDuplicate?";
        if (storeName === null)
            throw new Error("The parameter 'storeName' cannot be null.");
        else if (storeName !== undefined)
            url_ += "storeName=" + encodeURIComponent("" + storeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsDuplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsDuplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsDuplicate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param search (optional) 
     * @return Success
     */
    getAllStoreBySearch(search: string | undefined): Observable<StoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetAllStoreBySearch?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStoreBySearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStoreBySearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto[]>;
        }));
    }

    protected processGetAllStoreBySearch(response: HttpResponseBase): Observable<StoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StoreDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: StoreRequestDto | undefined): Observable<StoreDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<StoreDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getByCode(code: string | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDetail(id: number | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetDetail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processGetDetail(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDefault(): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processGetDefault(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateStoreDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Store/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param monthlyInterestRate (optional) 
     * @param serviceFee (optional) 
     * @param saleFeePercent (optional) 
     * @param agencyFeePercent (optional) 
     * @param storeFeePercent (optional) 
     * @param id (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param address (optional) 
     * @param leaseTermCode (optional) 
     * @param isActive (optional) 
     * @param agencyCode (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param fileImageStores (optional) 
     * @param listIdDeleteImageStore (optional) 
     * @param phoneNumber (optional) 
     * @param fileImagePayments (optional) 
     * @param listIdDeleteImagePayment (optional) 
     * @param fileIdentityFronts (optional) 
     * @param listIdDeleteIdentityFront (optional) 
     * @param fileIdentityBacks (optional) 
     * @param listIdDeleteIdentityBack (optional) 
     * @param fileBusinessLicenses (optional) 
     * @param listIdDeleteBusinessLicense (optional) 
     * @param bankAccount (optional) 
     * @param bankCode (optional) 
     * @param accountName (optional) 
     * @param shopOwner (optional) 
     * @param ownerId (optional) 
     * @param prepayPricePercentage (optional) 
     * @param email (optional) 
     * @return Success
     */
    createStoreByCustomer(monthlyInterestRate: number | undefined, serviceFee: number | undefined, saleFeePercent: number | undefined, agencyFeePercent: number | undefined, storeFeePercent: number | undefined, id: number | undefined, code: string | undefined, name: string | undefined, address: string | undefined, leaseTermCode: number | undefined, isActive: boolean | undefined, agencyCode: string | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, fileImageStores: FileParameter[] | undefined, listIdDeleteImageStore: number[] | undefined, phoneNumber: string | undefined, fileImagePayments: FileParameter[] | undefined, listIdDeleteImagePayment: number[] | undefined, fileIdentityFronts: FileParameter[] | undefined, listIdDeleteIdentityFront: number[] | undefined, fileIdentityBacks: FileParameter[] | undefined, listIdDeleteIdentityBack: number[] | undefined, fileBusinessLicenses: FileParameter[] | undefined, listIdDeleteBusinessLicense: number[] | undefined, bankAccount: string | undefined, bankCode: string | undefined, accountName: string | undefined, shopOwner: string | undefined, ownerId: number | undefined, prepayPricePercentage: number | undefined, email: string | undefined): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/CreateStoreByCustomer?";
        if (monthlyInterestRate === null)
            throw new Error("The parameter 'monthlyInterestRate' cannot be null.");
        else if (monthlyInterestRate !== undefined)
            url_ += "MonthlyInterestRate=" + encodeURIComponent("" + monthlyInterestRate) + "&";
        if (serviceFee === null)
            throw new Error("The parameter 'serviceFee' cannot be null.");
        else if (serviceFee !== undefined)
            url_ += "ServiceFee=" + encodeURIComponent("" + serviceFee) + "&";
        if (saleFeePercent === null)
            throw new Error("The parameter 'saleFeePercent' cannot be null.");
        else if (saleFeePercent !== undefined)
            url_ += "SaleFeePercent=" + encodeURIComponent("" + saleFeePercent) + "&";
        if (agencyFeePercent === null)
            throw new Error("The parameter 'agencyFeePercent' cannot be null.");
        else if (agencyFeePercent !== undefined)
            url_ += "AgencyFeePercent=" + encodeURIComponent("" + agencyFeePercent) + "&";
        if (storeFeePercent === null)
            throw new Error("The parameter 'storeFeePercent' cannot be null.");
        else if (storeFeePercent !== undefined)
            url_ += "StoreFeePercent=" + encodeURIComponent("" + storeFeePercent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (code === null || code === undefined)
            throw new Error("The parameter 'code' cannot be null.");
        else
            content_.append("Code", code.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (leaseTermCode === null || leaseTermCode === undefined)
            throw new Error("The parameter 'leaseTermCode' cannot be null.");
        else
            content_.append("LeaseTermCode", leaseTermCode.toString());
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (agencyCode === null || agencyCode === undefined)
            throw new Error("The parameter 'agencyCode' cannot be null.");
        else
            content_.append("AgencyCode", agencyCode.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (fileImageStores === null || fileImageStores === undefined)
            throw new Error("The parameter 'fileImageStores' cannot be null.");
        else
            fileImageStores.forEach(item_ => content_.append("FileImageStores", item_.data, item_.fileName ? item_.fileName : "FileImageStores") );
        if (listIdDeleteImageStore === null || listIdDeleteImageStore === undefined)
            throw new Error("The parameter 'listIdDeleteImageStore' cannot be null.");
        else
            listIdDeleteImageStore.forEach(item_ => content_.append("ListIdDeleteImageStore", item_.toString()));
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (fileImagePayments === null || fileImagePayments === undefined)
            throw new Error("The parameter 'fileImagePayments' cannot be null.");
        else
            fileImagePayments.forEach(item_ => content_.append("FileImagePayments", item_.data, item_.fileName ? item_.fileName : "FileImagePayments") );
        if (listIdDeleteImagePayment === null || listIdDeleteImagePayment === undefined)
            throw new Error("The parameter 'listIdDeleteImagePayment' cannot be null.");
        else
            listIdDeleteImagePayment.forEach(item_ => content_.append("ListIdDeleteImagePayment", item_.toString()));
        if (fileIdentityFronts === null || fileIdentityFronts === undefined)
            throw new Error("The parameter 'fileIdentityFronts' cannot be null.");
        else
            fileIdentityFronts.forEach(item_ => content_.append("FileIdentityFronts", item_.data, item_.fileName ? item_.fileName : "FileIdentityFronts") );
        if (listIdDeleteIdentityFront === null || listIdDeleteIdentityFront === undefined)
            throw new Error("The parameter 'listIdDeleteIdentityFront' cannot be null.");
        else
            listIdDeleteIdentityFront.forEach(item_ => content_.append("ListIdDeleteIdentityFront", item_.toString()));
        if (fileIdentityBacks === null || fileIdentityBacks === undefined)
            throw new Error("The parameter 'fileIdentityBacks' cannot be null.");
        else
            fileIdentityBacks.forEach(item_ => content_.append("FileIdentityBacks", item_.data, item_.fileName ? item_.fileName : "FileIdentityBacks") );
        if (listIdDeleteIdentityBack === null || listIdDeleteIdentityBack === undefined)
            throw new Error("The parameter 'listIdDeleteIdentityBack' cannot be null.");
        else
            listIdDeleteIdentityBack.forEach(item_ => content_.append("ListIdDeleteIdentityBack", item_.toString()));
        if (fileBusinessLicenses === null || fileBusinessLicenses === undefined)
            throw new Error("The parameter 'fileBusinessLicenses' cannot be null.");
        else
            fileBusinessLicenses.forEach(item_ => content_.append("FileBusinessLicenses", item_.data, item_.fileName ? item_.fileName : "FileBusinessLicenses") );
        if (listIdDeleteBusinessLicense === null || listIdDeleteBusinessLicense === undefined)
            throw new Error("The parameter 'listIdDeleteBusinessLicense' cannot be null.");
        else
            listIdDeleteBusinessLicense.forEach(item_ => content_.append("ListIdDeleteBusinessLicense", item_.toString()));
        if (bankAccount === null || bankAccount === undefined)
            throw new Error("The parameter 'bankAccount' cannot be null.");
        else
            content_.append("BankAccount", bankAccount.toString());
        if (bankCode === null || bankCode === undefined)
            throw new Error("The parameter 'bankCode' cannot be null.");
        else
            content_.append("BankCode", bankCode.toString());
        if (accountName === null || accountName === undefined)
            throw new Error("The parameter 'accountName' cannot be null.");
        else
            content_.append("AccountName", accountName.toString());
        if (shopOwner === null || shopOwner === undefined)
            throw new Error("The parameter 'shopOwner' cannot be null.");
        else
            content_.append("ShopOwner", shopOwner.toString());
        if (ownerId === null || ownerId === undefined)
            throw new Error("The parameter 'ownerId' cannot be null.");
        else
            content_.append("OwnerId", ownerId.toString());
        if (prepayPricePercentage === null || prepayPricePercentage === undefined)
            throw new Error("The parameter 'prepayPricePercentage' cannot be null.");
        else
            content_.append("PrepayPricePercentage", prepayPricePercentage.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateStoreByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStoreByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processCreateStoreByCustomer(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getStoreByCustomer(): Observable<StoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Store/GetStoreByCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreByCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StoreDto>;
        }));
    }

    protected processGetStoreByCustomer(response: HttpResponseBase): Observable<StoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    approvedStore(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/ApprovedStore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovedStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    rejectStore(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/RejectStore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteStoreCustomer(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/DeleteStoreCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStoreCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStoreCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStoreCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param store_MonthlyInterestRate (optional) 
     * @param store_ServiceFee (optional) 
     * @param store_SaleFeePercent (optional) 
     * @param store_AgencyFeePercent (optional) 
     * @param store_StoreFeePercent (optional) 
     * @param store_Id (optional) 
     * @param store_Code (optional) 
     * @param store_Name (optional) 
     * @param store_Address (optional) 
     * @param store_LeaseTermCode (optional) 
     * @param store_IsActive (optional) 
     * @param store_AgencyCode (optional) 
     * @param store_Files (optional) 
     * @param store_ListIdDelete (optional) 
     * @param store_FileImageStores (optional) 
     * @param store_ListIdDeleteImageStore (optional) 
     * @param store_PhoneNumber (optional) 
     * @param store_FileImagePayments (optional) 
     * @param store_ListIdDeleteImagePayment (optional) 
     * @param store_FileIdentityFronts (optional) 
     * @param store_ListIdDeleteIdentityFront (optional) 
     * @param store_FileIdentityBacks (optional) 
     * @param store_ListIdDeleteIdentityBack (optional) 
     * @param store_FileBusinessLicenses (optional) 
     * @param store_ListIdDeleteBusinessLicense (optional) 
     * @param store_BankAccount (optional) 
     * @param store_BankCode (optional) 
     * @param store_AccountName (optional) 
     * @param store_ShopOwner (optional) 
     * @param store_OwnerId (optional) 
     * @param store_PrepayPricePercentage (optional) 
     * @param store_Email (optional) 
     * @param productStores (optional) 
     * @param listProductStoreDelete (optional) 
     * @param listProductStoreDetailDelete (optional) 
     * @return Success
     */
    createUpdateProductStore(store_MonthlyInterestRate: number | undefined, store_ServiceFee: number | undefined, store_SaleFeePercent: number | undefined, store_AgencyFeePercent: number | undefined, store_StoreFeePercent: number | undefined, store_Id: number | undefined, store_Code: string | undefined, store_Name: string | undefined, store_Address: string | undefined, store_LeaseTermCode: number | undefined, store_IsActive: boolean | undefined, store_AgencyCode: string | undefined, store_Files: FileParameter[] | undefined, store_ListIdDelete: number[] | undefined, store_FileImageStores: FileParameter[] | undefined, store_ListIdDeleteImageStore: number[] | undefined, store_PhoneNumber: string | undefined, store_FileImagePayments: FileParameter[] | undefined, store_ListIdDeleteImagePayment: number[] | undefined, store_FileIdentityFronts: FileParameter[] | undefined, store_ListIdDeleteIdentityFront: number[] | undefined, store_FileIdentityBacks: FileParameter[] | undefined, store_ListIdDeleteIdentityBack: number[] | undefined, store_FileBusinessLicenses: FileParameter[] | undefined, store_ListIdDeleteBusinessLicense: number[] | undefined, store_BankAccount: string | undefined, store_BankCode: string | undefined, store_AccountName: string | undefined, store_ShopOwner: string | undefined, store_OwnerId: number | undefined, store_PrepayPricePercentage: number | undefined, store_Email: string | undefined, productStores: CreateUpdateProductStoreDto[] | undefined, listProductStoreDelete: number[] | undefined, listProductStoreDetailDelete: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/CreateUpdateProductStore?";
        if (store_MonthlyInterestRate === null)
            throw new Error("The parameter 'store_MonthlyInterestRate' cannot be null.");
        else if (store_MonthlyInterestRate !== undefined)
            url_ += "Store.MonthlyInterestRate=" + encodeURIComponent("" + store_MonthlyInterestRate) + "&";
        if (store_ServiceFee === null)
            throw new Error("The parameter 'store_ServiceFee' cannot be null.");
        else if (store_ServiceFee !== undefined)
            url_ += "Store.ServiceFee=" + encodeURIComponent("" + store_ServiceFee) + "&";
        if (store_SaleFeePercent === null)
            throw new Error("The parameter 'store_SaleFeePercent' cannot be null.");
        else if (store_SaleFeePercent !== undefined)
            url_ += "Store.SaleFeePercent=" + encodeURIComponent("" + store_SaleFeePercent) + "&";
        if (store_AgencyFeePercent === null)
            throw new Error("The parameter 'store_AgencyFeePercent' cannot be null.");
        else if (store_AgencyFeePercent !== undefined)
            url_ += "Store.AgencyFeePercent=" + encodeURIComponent("" + store_AgencyFeePercent) + "&";
        if (store_StoreFeePercent === null)
            throw new Error("The parameter 'store_StoreFeePercent' cannot be null.");
        else if (store_StoreFeePercent !== undefined)
            url_ += "Store.StoreFeePercent=" + encodeURIComponent("" + store_StoreFeePercent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (store_Id === null || store_Id === undefined)
            throw new Error("The parameter 'store_Id' cannot be null.");
        else
            content_.append("Store.Id", store_Id.toString());
        if (store_Code === null || store_Code === undefined)
            throw new Error("The parameter 'store_Code' cannot be null.");
        else
            content_.append("Store.Code", store_Code.toString());
        if (store_Name === null || store_Name === undefined)
            throw new Error("The parameter 'store_Name' cannot be null.");
        else
            content_.append("Store.Name", store_Name.toString());
        if (store_Address === null || store_Address === undefined)
            throw new Error("The parameter 'store_Address' cannot be null.");
        else
            content_.append("Store.Address", store_Address.toString());
        if (store_LeaseTermCode === null || store_LeaseTermCode === undefined)
            throw new Error("The parameter 'store_LeaseTermCode' cannot be null.");
        else
            content_.append("Store.LeaseTermCode", store_LeaseTermCode.toString());
        if (store_IsActive === null || store_IsActive === undefined)
            throw new Error("The parameter 'store_IsActive' cannot be null.");
        else
            content_.append("Store.IsActive", store_IsActive.toString());
        if (store_AgencyCode === null || store_AgencyCode === undefined)
            throw new Error("The parameter 'store_AgencyCode' cannot be null.");
        else
            content_.append("Store.AgencyCode", store_AgencyCode.toString());
        if (store_Files === null || store_Files === undefined)
            throw new Error("The parameter 'store_Files' cannot be null.");
        else
            store_Files.forEach(item_ => content_.append("Store.Files", item_.data, item_.fileName ? item_.fileName : "Store.Files") );
        if (store_ListIdDelete === null || store_ListIdDelete === undefined)
            throw new Error("The parameter 'store_ListIdDelete' cannot be null.");
        else
            store_ListIdDelete.forEach(item_ => content_.append("Store.ListIdDelete", item_.toString()));
        if (store_FileImageStores === null || store_FileImageStores === undefined)
            throw new Error("The parameter 'store_FileImageStores' cannot be null.");
        else
            store_FileImageStores.forEach(item_ => content_.append("Store.FileImageStores", item_.data, item_.fileName ? item_.fileName : "Store.FileImageStores") );
        if (store_ListIdDeleteImageStore === null || store_ListIdDeleteImageStore === undefined)
            throw new Error("The parameter 'store_ListIdDeleteImageStore' cannot be null.");
        else
            store_ListIdDeleteImageStore.forEach(item_ => content_.append("Store.ListIdDeleteImageStore", item_.toString()));
        if (store_PhoneNumber === null || store_PhoneNumber === undefined)
            throw new Error("The parameter 'store_PhoneNumber' cannot be null.");
        else
            content_.append("Store.PhoneNumber", store_PhoneNumber.toString());
        if (store_FileImagePayments === null || store_FileImagePayments === undefined)
            throw new Error("The parameter 'store_FileImagePayments' cannot be null.");
        else
            store_FileImagePayments.forEach(item_ => content_.append("Store.FileImagePayments", item_.data, item_.fileName ? item_.fileName : "Store.FileImagePayments") );
        if (store_ListIdDeleteImagePayment === null || store_ListIdDeleteImagePayment === undefined)
            throw new Error("The parameter 'store_ListIdDeleteImagePayment' cannot be null.");
        else
            store_ListIdDeleteImagePayment.forEach(item_ => content_.append("Store.ListIdDeleteImagePayment", item_.toString()));
        if (store_FileIdentityFronts === null || store_FileIdentityFronts === undefined)
            throw new Error("The parameter 'store_FileIdentityFronts' cannot be null.");
        else
            store_FileIdentityFronts.forEach(item_ => content_.append("Store.FileIdentityFronts", item_.data, item_.fileName ? item_.fileName : "Store.FileIdentityFronts") );
        if (store_ListIdDeleteIdentityFront === null || store_ListIdDeleteIdentityFront === undefined)
            throw new Error("The parameter 'store_ListIdDeleteIdentityFront' cannot be null.");
        else
            store_ListIdDeleteIdentityFront.forEach(item_ => content_.append("Store.ListIdDeleteIdentityFront", item_.toString()));
        if (store_FileIdentityBacks === null || store_FileIdentityBacks === undefined)
            throw new Error("The parameter 'store_FileIdentityBacks' cannot be null.");
        else
            store_FileIdentityBacks.forEach(item_ => content_.append("Store.FileIdentityBacks", item_.data, item_.fileName ? item_.fileName : "Store.FileIdentityBacks") );
        if (store_ListIdDeleteIdentityBack === null || store_ListIdDeleteIdentityBack === undefined)
            throw new Error("The parameter 'store_ListIdDeleteIdentityBack' cannot be null.");
        else
            store_ListIdDeleteIdentityBack.forEach(item_ => content_.append("Store.ListIdDeleteIdentityBack", item_.toString()));
        if (store_FileBusinessLicenses === null || store_FileBusinessLicenses === undefined)
            throw new Error("The parameter 'store_FileBusinessLicenses' cannot be null.");
        else
            store_FileBusinessLicenses.forEach(item_ => content_.append("Store.FileBusinessLicenses", item_.data, item_.fileName ? item_.fileName : "Store.FileBusinessLicenses") );
        if (store_ListIdDeleteBusinessLicense === null || store_ListIdDeleteBusinessLicense === undefined)
            throw new Error("The parameter 'store_ListIdDeleteBusinessLicense' cannot be null.");
        else
            store_ListIdDeleteBusinessLicense.forEach(item_ => content_.append("Store.ListIdDeleteBusinessLicense", item_.toString()));
        if (store_BankAccount === null || store_BankAccount === undefined)
            throw new Error("The parameter 'store_BankAccount' cannot be null.");
        else
            content_.append("Store.BankAccount", store_BankAccount.toString());
        if (store_BankCode === null || store_BankCode === undefined)
            throw new Error("The parameter 'store_BankCode' cannot be null.");
        else
            content_.append("Store.BankCode", store_BankCode.toString());
        if (store_AccountName === null || store_AccountName === undefined)
            throw new Error("The parameter 'store_AccountName' cannot be null.");
        else
            content_.append("Store.AccountName", store_AccountName.toString());
        if (store_ShopOwner === null || store_ShopOwner === undefined)
            throw new Error("The parameter 'store_ShopOwner' cannot be null.");
        else
            content_.append("Store.ShopOwner", store_ShopOwner.toString());
        if (store_OwnerId === null || store_OwnerId === undefined)
            throw new Error("The parameter 'store_OwnerId' cannot be null.");
        else
            content_.append("Store.OwnerId", store_OwnerId.toString());
        if (store_PrepayPricePercentage === null || store_PrepayPricePercentage === undefined)
            throw new Error("The parameter 'store_PrepayPricePercentage' cannot be null.");
        else
            content_.append("Store.PrepayPricePercentage", store_PrepayPricePercentage.toString());
        if (store_Email === null || store_Email === undefined)
            throw new Error("The parameter 'store_Email' cannot be null.");
        else
            content_.append("Store.Email", store_Email.toString());
        if (productStores === null || productStores === undefined)
            throw new Error("The parameter 'productStores' cannot be null.");
        else
            productStores.forEach(item_ => content_.append("ProductStores", item_.toString()));
        if (listProductStoreDelete === null || listProductStoreDelete === undefined)
            throw new Error("The parameter 'listProductStoreDelete' cannot be null.");
        else
            listProductStoreDelete.forEach(item_ => content_.append("ListProductStoreDelete", item_.toString()));
        if (listProductStoreDetailDelete === null || listProductStoreDetailDelete === undefined)
            throw new Error("The parameter 'listProductStoreDetailDelete' cannot be null.");
        else
            listProductStoreDetailDelete.forEach(item_ => content_.append("ListProductStoreDetailDelete", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdateProductStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdateProductStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUpdateProductStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateDelete(body: Store | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/ValidateDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    addProductInStore(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Store/AddProductInStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProductInStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProductInStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProductInStore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TelegramServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param message (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendTelegramMessage(message: string | undefined, body: TypeToppic | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TelegramService/SendTelegramMessage?";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTelegramMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTelegramMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTelegramMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param url (optional) 
     * @param message (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendTelegramPhoto(url: string | undefined, message: string | undefined, body: TypeToppic | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TelegramService/SendTelegramPhoto?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTelegramPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTelegramPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTelegramPhoto(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editTransaction(body: EditTransactionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/EditTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditTransaction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @return Success
     */
    editFileTransaction(transactionId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/EditFileTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (transactionId === null || transactionId === undefined)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else
            content_.append("TransactionId", transactionId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditFileTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditFileTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditFileTransaction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: TransactionRequestModel | undefined): Observable<TransactionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<TransactionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approvedTransaction(body: TransactionRequestModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/ApprovedTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprovedTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovedTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApprovedTransaction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rejectTransaction(body: TransactionRequestModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Transaction/RejectTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectTransaction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TransactionDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TransactionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetail/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDetailDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TransactionDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaging(body: TransactionDetailRequestDto | undefined): Observable<TransactionDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetail/GetPaging";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDetailDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<TransactionDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateTransactionDetailDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetail/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionDetail/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TransactionPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    updateCodeTransaction(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPublic/UpdateCodeTransaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCodeTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCodeTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCodeTransaction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @return Success
     */
    getTransactionPaymentInfo(transactionId: number | undefined): Observable<TransactionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPublic/GetTransactionPaymentInfo?";
        if (transactionId === null)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else if (transactionId !== undefined)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionPaymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionPaymentDto>;
        }));
    }

    protected processGetTransactionPaymentInfo(response: HttpResponseBase): Observable<TransactionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @param files (optional) 
     * @param listIdDelete (optional) 
     * @param methodTranfer (optional) 
     * @param paymentApplicationFeeTarget (optional) 
     * @return Success
     */
    paymentWithEvidence(transactionId: number | undefined, files: FileParameter[] | undefined, listIdDelete: number[] | undefined, methodTranfer: string | undefined, paymentApplicationFeeTarget: string | undefined, payFromCustomer: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPublic/PaymentWithEvidence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (transactionId === null || transactionId === undefined)
            throw new Error("The parameter 'transactionId' cannot be null.");
        else
            content_.append("TransactionId", transactionId.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (methodTranfer === null || methodTranfer === undefined)
            throw new Error("The parameter 'methodTranfer' cannot be null.");
        else
            content_.append("MethodTranfer", methodTranfer.toString());
        if (paymentApplicationFeeTarget === null || paymentApplicationFeeTarget === undefined)
            throw new Error("The parameter 'paymentApplicationFeeTarget' cannot be null.");
        else
            content_.append("PaymentApplicationFeeTarget", paymentApplicationFeeTarget.toString());
        if (payFromCustomer !== null && payFromCustomer !== undefined)
            content_.append("PayFromCustomer", payFromCustomer.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentWithEvidence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentWithEvidence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentWithEvidence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getPaymentFirstByOrderId(orderId: number | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionPublic/GetPaymentFirstByOrderId?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentFirstByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentFirstByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processGetPaymentFirstByOrderId(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param roleId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, roleId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param emailAddress (optional) 
     * @param userName (optional) 
     * @param phoneNumber (optional) 
     * @param isActive (optional) 
     * @param roleNames (optional) 
     * @param password (optional) 
     * @param storeCode (optional) 
     * @param agencyCode (optional) 
     * @param fileBefore (optional) 
     * @param fileAlter (optional) 
     * @param address (optional) 
     * @param cCCD (optional) 
     * @param listIdDelete (optional) 
     * @param issuingAuthority (optional) 
     * @param dateIssued (optional) 
     * @param birthday (optional) 
     * @param bankCode (optional) 
     * @param accountName (optional) 
     * @param bankAccount (optional) 
     * @param fileImagePayment (optional) 
     * @param listIdPaymentDelete (optional) 
     * @return Success
     */
    create(name: string | undefined, emailAddress: string | undefined, userName: string | undefined, phoneNumber: string | undefined, isActive: boolean | undefined, roleNames: string[] | undefined, password: string | undefined, storeCode: string | undefined, agencyCode: string | undefined, fileBefore: FileParameter | undefined, fileAlter: FileParameter | undefined, address: string | undefined, cCCD: string | undefined, listIdDelete: number[] | undefined, issuingAuthority: string | undefined, dateIssued: string | undefined, birthday: string | undefined, bankCode: string | undefined, accountName: string | undefined, bankAccount: string | undefined, fileImagePayment: FileParameter[] | undefined, listIdPaymentDelete: number[] | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (emailAddress === null || emailAddress === undefined)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else
            content_.append("EmailAddress", emailAddress.toString());
        if (userName === null || userName === undefined)
            throw new Error("The parameter 'userName' cannot be null.");
        else
            content_.append("UserName", userName.toString());
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (roleNames === null || roleNames === undefined)
            throw new Error("The parameter 'roleNames' cannot be null.");
        else
            roleNames.forEach(item_ => content_.append("RoleNames", item_.toString()));
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());
        if (storeCode === null || storeCode === undefined)
            throw new Error("The parameter 'storeCode' cannot be null.");
        else
            content_.append("StoreCode", storeCode.toString());
        if (agencyCode === null || agencyCode === undefined)
            throw new Error("The parameter 'agencyCode' cannot be null.");
        else
            content_.append("AgencyCode", agencyCode.toString());
        if (fileBefore === null || fileBefore === undefined)
            throw new Error("The parameter 'fileBefore' cannot be null.");
        else
            content_.append("FileBefore", fileBefore.data, fileBefore.fileName ? fileBefore.fileName : "FileBefore");
        if (fileAlter === null || fileAlter === undefined)
            throw new Error("The parameter 'fileAlter' cannot be null.");
        else
            content_.append("FileAlter", fileAlter.data, fileAlter.fileName ? fileAlter.fileName : "FileAlter");
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (cCCD === null || cCCD === undefined)
            throw new Error("The parameter 'cCCD' cannot be null.");
        else
            content_.append("CCCD", cCCD.toString());
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (dateIssued === null || dateIssued === undefined)
            throw new Error("The parameter 'dateIssued' cannot be null.");
        else
            content_.append("DateIssued", dateIssued.toString());
        if (birthday === null || birthday === undefined)
            throw new Error("The parameter 'birthday' cannot be null.");
        else
            content_.append("Birthday", birthday.toString());
        if (bankCode === null || bankCode === undefined)
            throw new Error("The parameter 'bankCode' cannot be null.");
        else
            content_.append("BankCode", bankCode.toString());
        if (accountName === null || accountName === undefined)
            throw new Error("The parameter 'accountName' cannot be null.");
        else
            content_.append("AccountName", accountName.toString());
        if (bankAccount === null || bankAccount === undefined)
            throw new Error("The parameter 'bankAccount' cannot be null.");
        else
            content_.append("BankAccount", bankAccount.toString());
        if (fileImagePayment === null || fileImagePayment === undefined)
            throw new Error("The parameter 'fileImagePayment' cannot be null.");
        else
            fileImagePayment.forEach(item_ => content_.append("FileImagePayment", item_.data, item_.fileName ? item_.fileName : "FileImagePayment") );
        if (listIdPaymentDelete === null || listIdPaymentDelete === undefined)
            throw new Error("The parameter 'listIdPaymentDelete' cannot be null.");
        else
            listIdPaymentDelete.forEach(item_ => content_.append("ListIdPaymentDelete", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userName (optional) 
     * @param name (optional) 
     * @param emailAddress (optional) 
     * @param phoneNumber (optional) 
     * @param isActive (optional) 
     * @param roleNames (optional) 
     * @param storeCodes (optional) 
     * @param agencyCodes (optional) 
     * @param fileBefore (optional) 
     * @param fileAlter (optional) 
     * @param address (optional) 
     * @param cCCD (optional) 
     * @param listIdDelete (optional) 
     * @param fileBeforeCCCDCard_Id (optional) 
     * @param fileBeforeCCCDCard_Path (optional) 
     * @param fileBeforeCCCDCard_Name (optional) 
     * @param fileBeforeCCCDCard_Extension (optional) 
     * @param fileBeforeCCCDCard_FileType (optional) 
     * @param fileAlterCCCDCard_Id (optional) 
     * @param fileAlterCCCDCard_Path (optional) 
     * @param fileAlterCCCDCard_Name (optional) 
     * @param fileAlterCCCDCard_Extension (optional) 
     * @param fileAlterCCCDCard_FileType (optional) 
     * @param listFileId (optional) 
     * @param issuingAuthority (optional) 
     * @param dateIssued (optional) 
     * @param birthday (optional) 
     * @param bankCode (optional) 
     * @param accountName (optional) 
     * @param bankAccount (optional) 
     * @param fileImagePayment (optional) 
     * @param listIdPaymentDelete (optional) 
     * @param money (optional) 
     * @param creationTime (optional) 
     * @param id (optional) 
     * @return Success
     */
    update(userName: string | undefined, name: string | undefined, emailAddress: string | undefined, phoneNumber: string | undefined, isActive: boolean | undefined, roleNames: string[] | undefined, storeCodes: string | undefined, agencyCodes: string | undefined, fileBefore: FileParameter | undefined, fileAlter: FileParameter | undefined, address: string | undefined, cCCD: string | undefined, listIdDelete: number[] | undefined, fileBeforeCCCDCard_Id: number | undefined, fileBeforeCCCDCard_Path: string | undefined, fileBeforeCCCDCard_Name: string | undefined, fileBeforeCCCDCard_Extension: string | undefined, fileBeforeCCCDCard_FileType: string | undefined, fileAlterCCCDCard_Id: number | undefined, fileAlterCCCDCard_Path: string | undefined, fileAlterCCCDCard_Name: string | undefined, fileAlterCCCDCard_Extension: string | undefined, fileAlterCCCDCard_FileType: string | undefined, listFileId: number[] | undefined, issuingAuthority: string | undefined, dateIssued: string | undefined, birthday: string | undefined, bankCode: string | undefined, accountName: string | undefined, bankAccount: string | undefined, fileImagePayment: FileParameter[] | undefined, listIdPaymentDelete: number[] | undefined, money: number | undefined, creationTime: moment.Moment | undefined, id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName === null || userName === undefined)
            throw new Error("The parameter 'userName' cannot be null.");
        else
            content_.append("UserName", userName.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (emailAddress === null || emailAddress === undefined)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else
            content_.append("EmailAddress", emailAddress.toString());
        if (phoneNumber === null || phoneNumber === undefined)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else
            content_.append("PhoneNumber", phoneNumber.toString());
        if (isActive === null || isActive === undefined)
            throw new Error("The parameter 'isActive' cannot be null.");
        else
            content_.append("IsActive", isActive.toString());
        if (roleNames === null || roleNames === undefined)
            throw new Error("The parameter 'roleNames' cannot be null.");
        else
            roleNames.forEach(item_ => content_.append("RoleNames", item_.toString()));
        if (storeCodes === null || storeCodes === undefined)
            throw new Error("The parameter 'storeCodes' cannot be null.");
        else
            content_.append("StoreCodes", storeCodes.toString());
        if (agencyCodes === null || agencyCodes === undefined)
            throw new Error("The parameter 'agencyCodes' cannot be null.");
        else
            content_.append("AgencyCodes", agencyCodes.toString());
        if (fileBefore === null || fileBefore === undefined)
            throw new Error("The parameter 'fileBefore' cannot be null.");
        else
            content_.append("FileBefore", fileBefore.data, fileBefore.fileName ? fileBefore.fileName : "FileBefore");
        if (fileAlter === null || fileAlter === undefined)
            throw new Error("The parameter 'fileAlter' cannot be null.");
        else
            content_.append("FileAlter", fileAlter.data, fileAlter.fileName ? fileAlter.fileName : "FileAlter");
        if (address === null || address === undefined)
            throw new Error("The parameter 'address' cannot be null.");
        else
            content_.append("Address", address.toString());
        if (cCCD === null || cCCD === undefined)
            throw new Error("The parameter 'cCCD' cannot be null.");
        else
            content_.append("CCCD", cCCD.toString());
        if (listIdDelete === null || listIdDelete === undefined)
            throw new Error("The parameter 'listIdDelete' cannot be null.");
        else
            listIdDelete.forEach(item_ => content_.append("ListIdDelete", item_.toString()));
        if (fileBeforeCCCDCard_Id === null || fileBeforeCCCDCard_Id === undefined)
            throw new Error("The parameter 'fileBeforeCCCDCard_Id' cannot be null.");
        else
            content_.append("FileBeforeCCCDCard.Id", fileBeforeCCCDCard_Id.toString());
        if (fileBeforeCCCDCard_Path === null || fileBeforeCCCDCard_Path === undefined)
            throw new Error("The parameter 'fileBeforeCCCDCard_Path' cannot be null.");
        else
            content_.append("FileBeforeCCCDCard.Path", fileBeforeCCCDCard_Path.toString());
        if (fileBeforeCCCDCard_Name === null || fileBeforeCCCDCard_Name === undefined)
            throw new Error("The parameter 'fileBeforeCCCDCard_Name' cannot be null.");
        else
            content_.append("FileBeforeCCCDCard.Name", fileBeforeCCCDCard_Name.toString());
        if (fileBeforeCCCDCard_Extension === null || fileBeforeCCCDCard_Extension === undefined)
            throw new Error("The parameter 'fileBeforeCCCDCard_Extension' cannot be null.");
        else
            content_.append("FileBeforeCCCDCard.Extension", fileBeforeCCCDCard_Extension.toString());
        if (fileBeforeCCCDCard_FileType === null || fileBeforeCCCDCard_FileType === undefined)
            throw new Error("The parameter 'fileBeforeCCCDCard_FileType' cannot be null.");
        else
            content_.append("FileBeforeCCCDCard.FileType", fileBeforeCCCDCard_FileType.toString());
        if (fileAlterCCCDCard_Id === null || fileAlterCCCDCard_Id === undefined)
            throw new Error("The parameter 'fileAlterCCCDCard_Id' cannot be null.");
        else
            content_.append("FileAlterCCCDCard.Id", fileAlterCCCDCard_Id.toString());
        if (fileAlterCCCDCard_Path === null || fileAlterCCCDCard_Path === undefined)
            throw new Error("The parameter 'fileAlterCCCDCard_Path' cannot be null.");
        else
            content_.append("FileAlterCCCDCard.Path", fileAlterCCCDCard_Path.toString());
        if (fileAlterCCCDCard_Name === null || fileAlterCCCDCard_Name === undefined)
            throw new Error("The parameter 'fileAlterCCCDCard_Name' cannot be null.");
        else
            content_.append("FileAlterCCCDCard.Name", fileAlterCCCDCard_Name.toString());
        if (fileAlterCCCDCard_Extension === null || fileAlterCCCDCard_Extension === undefined)
            throw new Error("The parameter 'fileAlterCCCDCard_Extension' cannot be null.");
        else
            content_.append("FileAlterCCCDCard.Extension", fileAlterCCCDCard_Extension.toString());
        if (fileAlterCCCDCard_FileType === null || fileAlterCCCDCard_FileType === undefined)
            throw new Error("The parameter 'fileAlterCCCDCard_FileType' cannot be null.");
        else
            content_.append("FileAlterCCCDCard.FileType", fileAlterCCCDCard_FileType.toString());
        if (listFileId === null || listFileId === undefined)
            throw new Error("The parameter 'listFileId' cannot be null.");
        else
            listFileId.forEach(item_ => content_.append("ListFileId", item_.toString()));
        if (issuingAuthority === null || issuingAuthority === undefined)
            throw new Error("The parameter 'issuingAuthority' cannot be null.");
        else
            content_.append("IssuingAuthority", issuingAuthority.toString());
        if (dateIssued === null || dateIssued === undefined)
            throw new Error("The parameter 'dateIssued' cannot be null.");
        else
            content_.append("DateIssued", dateIssued.toString());
        if (birthday === null || birthday === undefined)
            throw new Error("The parameter 'birthday' cannot be null.");
        else
            content_.append("Birthday", birthday.toString());
        if (bankCode === null || bankCode === undefined)
            throw new Error("The parameter 'bankCode' cannot be null.");
        else
            content_.append("BankCode", bankCode.toString());
        if (accountName === null || accountName === undefined)
            throw new Error("The parameter 'accountName' cannot be null.");
        else
            content_.append("AccountName", accountName.toString());
        if (bankAccount === null || bankAccount === undefined)
            throw new Error("The parameter 'bankAccount' cannot be null.");
        else
            content_.append("BankAccount", bankAccount.toString());
        if (fileImagePayment === null || fileImagePayment === undefined)
            throw new Error("The parameter 'fileImagePayment' cannot be null.");
        else
            fileImagePayment.forEach(item_ => content_.append("FileImagePayment", item_.data, item_.fileName ? item_.fileName : "FileImagePayment") );
        if (listIdPaymentDelete === null || listIdPaymentDelete === undefined)
            throw new Error("The parameter 'listIdPaymentDelete' cannot be null.");
        else
            listIdPaymentDelete.forEach(item_ => content_.append("ListIdPaymentDelete", item_.toString()));
        if (money === null || money === undefined)
            throw new Error("The parameter 'money' cannot be null.");
        else
            content_.append("Money", money.toString());
        if (creationTime === null || creationTime === undefined)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else
            content_.append("CreationTime", creationTime.toJSON());
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserOrderSplittingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserOrderSplitting(): Observable<UserOrderSplittingDto> {
        let url_ = this.baseUrl + "/api/services/app/UserOrderSplitting/GetUserOrderSplitting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserOrderSplitting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOrderSplitting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrderSplittingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrderSplittingDto>;
        }));
    }

    protected processGetUserOrderSplitting(response: HttpResponseBase): Observable<UserOrderSplittingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOrderSplittingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateUserOrderSplittingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserOrderSplitting/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateUserOnline(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserOrderSplitting/UpdateUserOnline";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserOnline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserOnline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserOnline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateUserOffline(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserOrderSplitting/UpdateUserOffline";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserOffline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserOffline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserOffline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    orderRouting(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserOrderSplitting/OrderRouting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderRouting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderRouting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processOrderRouting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserOtpServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    sendOtp(phoneNumber: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserOtp/SendOtp?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOtp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phoneNumber (optional) 
     * @return Success
     */
    sendOtpPassword(phoneNumber: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserOtp/SendOtpPassword?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendOtpPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOtpPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOtpPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param phoneNumber (optional) 
     * @param otp (optional) 
     * @return Success
     */
    isValidOtp(phoneNumber: string | undefined, otp: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserOtp/IsValidOtp?";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (otp === null)
            throw new Error("The parameter 'otp' cannot be null.");
        else if (otp !== undefined)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidOtp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsValidOtp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    iPN(): Observable<void> {
        let url_ = this.baseUrl + "/IPN";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIPN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIPN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIPN(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WalletServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentWallet(): Observable<WalletDto> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/GetCurrentWallet";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentWallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletDto>;
        }));
    }

    protected processGetCurrentWallet(response: HttpResponseBase): Observable<WalletDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transactionId (optional) 
     * @return Success
     */
    getCustomerWalletByTransactionId(transactionId: number | undefined): Observable<WalletDto> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/GetCustomerWalletByTransactionId?";
        if (transactionId !== undefined && transactionId !== null)
            url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentWallet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentWallet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletDto>;
        }));
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    topUpTopPay(body: TopUpWalletDto | undefined): Observable<OrderPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/TopUpTopPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTopUpTopPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTopUpTopPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPaymentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPaymentResponseDto>;
        }));
    }

    protected processTopUpTopPay(response: HttpResponseBase): Observable<OrderPaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    callbackTopPay(body: OrderPaymentTopPayCallbackDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/CallbackTopPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallbackTopPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallbackTopPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallbackTopPay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    topUpZalo(body: TopUpWalletDto | undefined): Observable<OrderPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/TopUpZalo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTopUpZalo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTopUpZalo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPaymentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPaymentResponseDto>;
        }));
    }

    protected processTopUpZalo(response: HttpResponseBase): Observable<OrderPaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    callbackZalo(body: ZaloPayCallbackRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/CallbackZalo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallbackZalo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallbackZalo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallbackZalo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    topUpVnPay(body: TopUpWalletDto | undefined): Observable<OrderPaymentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/TopUpVnPay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTopUpVnPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTopUpVnPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderPaymentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderPaymentResponseDto>;
        }));
    }

    protected processTopUpVnPay(response: HttpResponseBase): Observable<OrderPaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refData (optional) 
     * @param amount (optional) 
     * @return Success
     */
    callbackVnPay(refData: string | undefined, amount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wallet/CallbackVnPay?";
        if (refData === null)
            throw new Error("The parameter 'refData' cannot be null.");
        else if (refData !== undefined)
            url_ += "refData=" + encodeURIComponent("" + refData) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallbackVnPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallbackVnPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCallbackVnPay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WalletHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLogWalletHistory(body: CreateUpdateWalletHistoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WalletHistory/CreateLogWalletHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLogWalletHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLogWalletHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateLogWalletHistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param search (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPaging(search: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WalletHistoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WalletHistory/GetPaging?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaging(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaging(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WalletHistoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WalletHistoryDtoPagedResultDto>;
        }));
    }

    protected processGetPaging(response: HttpResponseBase): Observable<WalletHistoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletHistoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportWalletHistoryToExcel(body: BaseRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/WalletHistory/ExportWalletHistoryToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportWalletHistoryToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWalletHistoryToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportWalletHistoryToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    webhook(body: PublicTemplateDocument[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WithdrawServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPading(body: WithdrawRequestDto | undefined): Observable<WithdrawDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Withdraw/GetPading";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPading(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPading(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithdrawDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithdrawDtoPagedResultDto>;
        }));
    }

    protected processGetPading(response: HttpResponseBase): Observable<WithdrawDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WithdrawDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportWithdrawsToExcel(body: WithdrawRequestDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Withdraw/ExportWithdrawsToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportWithdrawsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWithdrawsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportWithdrawsToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateUpdateWithdrawDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Withdraw/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    rejectWithdraw(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Withdraw/RejectWithdraw?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectWithdraw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectWithdraw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectWithdraw(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    processingWithdraw(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Withdraw/ProcessingWithdraw?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessingWithdraw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessingWithdraw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessingWithdraw(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    completedWithdraw(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Withdraw/CompletedWithdraw?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletedWithdraw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletedWithdraw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCompletedWithdraw(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminTopUpDto implements IAdminTopUpDto {
    userId: number;
    amount: number;
    note: string | undefined;

    constructor(data?: IAdminTopUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AdminTopUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminTopUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): AdminTopUpDto {
        const json = this.toJSON();
        let result = new AdminTopUpDto();
        result.init(json);
        return result;
    }
}

export interface IAdminTopUpDto {
    userId: number;
    amount: number;
    note: string | undefined;
}

export class AgencyActionFieldChangeDto implements IAgencyActionFieldChangeDto {
    field: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;

    constructor(data?: IAgencyActionFieldChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): AgencyActionFieldChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyActionFieldChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }

    clone(): AgencyActionFieldChangeDto {
        const json = this.toJSON();
        let result = new AgencyActionFieldChangeDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyActionFieldChangeDto {
    field: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;
}

export class AgencyActionLogDto implements IAgencyActionLogDto {
    id: number;
    action: string | undefined;
    agencyId: number | undefined;
    operatorUserId: number | undefined;
    operatorUserName: string | undefined;
    operatorPhoneNumber: string | undefined;
    affectedUserId: number | undefined;
    affectedUserName: string | undefined;
    affectedPhoneNumber: string | undefined;
    note: string | undefined;
    creationTime: moment.Moment;
    changes: AgencyActionFieldChangeDto[] | undefined;

    constructor(data?: IAgencyActionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.agencyId = _data["agencyId"];
            this.operatorUserId = _data["operatorUserId"];
            this.operatorUserName = _data["operatorUserName"];
            this.operatorPhoneNumber = _data["operatorPhoneNumber"];
            this.affectedUserId = _data["affectedUserId"];
            this.affectedUserName = _data["affectedUserName"];
            this.affectedPhoneNumber = _data["affectedPhoneNumber"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes.push(AgencyActionFieldChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgencyActionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyActionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["agencyId"] = this.agencyId;
        data["operatorUserId"] = this.operatorUserId;
        data["operatorUserName"] = this.operatorUserName;
        data["operatorPhoneNumber"] = this.operatorPhoneNumber;
        data["affectedUserId"] = this.affectedUserId;
        data["affectedUserName"] = this.affectedUserName;
        data["affectedPhoneNumber"] = this.affectedPhoneNumber;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data;
    }

    clone(): AgencyActionLogDto {
        const json = this.toJSON();
        let result = new AgencyActionLogDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyActionLogDto {
    id: number;
    action: string | undefined;
    agencyId: number | undefined;
    operatorUserId: number | undefined;
    operatorUserName: string | undefined;
    operatorPhoneNumber: string | undefined;
    affectedUserId: number | undefined;
    affectedUserName: string | undefined;
    affectedPhoneNumber: string | undefined;
    note: string | undefined;
    creationTime: moment.Moment;
    changes: AgencyActionFieldChangeDto[] | undefined;
}

export class AgencyActionLogDtoPagedResultDto implements IAgencyActionLogDtoPagedResultDto {
    items: AgencyActionLogDto[] | undefined;
    totalCount: number;

    constructor(data?: IAgencyActionLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AgencyActionLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgencyActionLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyActionLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgencyActionLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgencyActionLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyActionLogDtoPagedResultDto {
    items: AgencyActionLogDto[] | undefined;
    totalCount: number;
}

export class AgencyActionLogRequestDto implements IAgencyActionLogRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyId: number | undefined;
    affectedUserId: number | undefined;

    constructor(data?: IAgencyActionLogRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.agencyId = _data["agencyId"];
            this.affectedUserId = _data["affectedUserId"];
        }
    }

    static fromJS(data: any): AgencyActionLogRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyActionLogRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["agencyId"] = this.agencyId;
        data["affectedUserId"] = this.affectedUserId;
        return data;
    }

    clone(): AgencyActionLogRequestDto {
        const json = this.toJSON();
        let result = new AgencyActionLogRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyActionLogRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyId: number | undefined;
    affectedUserId: number | undefined;
}

export class AgencyDto implements IAgencyDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    ownerName: string | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    isActive: boolean;

    constructor(data?: IAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.saleId = _data["saleId"];
            this.saleName = _data["saleName"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["saleId"] = this.saleId;
        data["saleName"] = this.saleName;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): AgencyDto {
        const json = this.toJSON();
        let result = new AgencyDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    ownerName: string | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    isActive: boolean;
}

export class AgencyDtoPagedResultDto implements IAgencyDtoPagedResultDto {
    items: AgencyDto[] | undefined;
    totalCount: number;

    constructor(data?: IAgencyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AgencyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgencyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgencyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgencyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyDtoPagedResultDto {
    items: AgencyDto[] | undefined;
    totalCount: number;
}

export class AgencyHistoryDto implements IAgencyHistoryDto {
    id: number;
    ownerId: number | undefined;
    saleId: number | undefined;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    orderCode: string | undefined;
    commissionAgency: number | undefined;
    commissionSale: number | undefined;
    commissionSystem: number | undefined;
    commissionStore: number | undefined;
    agencyFeePercent: number | undefined;
    saleFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;
    creationTime: moment.Moment;
    customerName: string | undefined;
    productName: string | undefined;
    orderPrice: number | undefined;
    orderStatus: string | undefined;

    constructor(data?: IAgencyHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ownerId = _data["ownerId"];
            this.saleId = _data["saleId"];
            this.agencyCode = _data["agencyCode"];
            this.agencyName = _data["agencyName"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
            this.orderCode = _data["orderCode"];
            this.commissionAgency = _data["commissionAgency"];
            this.commissionSale = _data["commissionSale"];
            this.commissionSystem = _data["commissionSystem"];
            this.commissionStore = _data["commissionStore"];
            this.agencyFeePercent = _data["agencyFeePercent"];
            this.saleFeePercent = _data["saleFeePercent"];
            this.storeFeePercent = _data["storeFeePercent"];
            this.systemFeePercent = _data["systemFeePercent"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.productName = _data["productName"];
            this.orderPrice = _data["orderPrice"];
            this.orderStatus = _data["orderStatus"];
        }
    }

    static fromJS(data: any): AgencyHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ownerId"] = this.ownerId;
        data["saleId"] = this.saleId;
        data["agencyCode"] = this.agencyCode;
        data["agencyName"] = this.agencyName;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["orderCode"] = this.orderCode;
        data["commissionAgency"] = this.commissionAgency;
        data["commissionSale"] = this.commissionSale;
        data["commissionSystem"] = this.commissionSystem;
        data["commissionStore"] = this.commissionStore;
        data["agencyFeePercent"] = this.agencyFeePercent;
        data["saleFeePercent"] = this.saleFeePercent;
        data["storeFeePercent"] = this.storeFeePercent;
        data["systemFeePercent"] = this.systemFeePercent;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["productName"] = this.productName;
        data["orderPrice"] = this.orderPrice;
        data["orderStatus"] = this.orderStatus;
        return data;
    }

    clone(): AgencyHistoryDto {
        const json = this.toJSON();
        let result = new AgencyHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyHistoryDto {
    id: number;
    ownerId: number | undefined;
    saleId: number | undefined;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    orderCode: string | undefined;
    commissionAgency: number | undefined;
    commissionSale: number | undefined;
    commissionSystem: number | undefined;
    commissionStore: number | undefined;
    agencyFeePercent: number | undefined;
    saleFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;
    creationTime: moment.Moment;
    customerName: string | undefined;
    productName: string | undefined;
    orderPrice: number | undefined;
    orderStatus: string | undefined;
}

export class AgencyHistoryDtoPagedResultDto implements IAgencyHistoryDtoPagedResultDto {
    items: AgencyHistoryDto[] | undefined;
    totalCount: number;

    constructor(data?: IAgencyHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AgencyHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgencyHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgencyHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgencyHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyHistoryDtoPagedResultDto {
    items: AgencyHistoryDto[] | undefined;
    totalCount: number;
}

export class AgencyHistoryRequestDto implements IAgencyHistoryRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyId: number | undefined;

    constructor(data?: IAgencyHistoryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.agencyId = _data["agencyId"];
        }
    }

    static fromJS(data: any): AgencyHistoryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyHistoryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["agencyId"] = this.agencyId;
        return data;
    }

    clone(): AgencyHistoryRequestDto {
        const json = this.toJSON();
        let result = new AgencyHistoryRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyHistoryRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyId: number | undefined;
}

export class AgencyInfoDto implements IAgencyInfoDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    ownerName: string | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    countMoneyAgency: number | undefined;
    countMoneySale: number | undefined;
    countMoneyStore: number | undefined;
    listStore: StoreAgencyInfoDto[] | undefined;
    isExpanded: boolean;

    constructor(data?: IAgencyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.saleId = _data["saleId"];
            this.saleName = _data["saleName"];
            this.countMoneyAgency = _data["countMoneyAgency"];
            this.countMoneySale = _data["countMoneySale"];
            this.countMoneyStore = _data["countMoneyStore"];
            if (Array.isArray(_data["listStore"])) {
                this.listStore = [] as any;
                for (let item of _data["listStore"])
                    this.listStore.push(StoreAgencyInfoDto.fromJS(item));
            }
            this.isExpanded = _data["isExpanded"];
        }
    }

    static fromJS(data: any): AgencyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["saleId"] = this.saleId;
        data["saleName"] = this.saleName;
        data["countMoneyAgency"] = this.countMoneyAgency;
        data["countMoneySale"] = this.countMoneySale;
        data["countMoneyStore"] = this.countMoneyStore;
        if (Array.isArray(this.listStore)) {
            data["listStore"] = [];
            for (let item of this.listStore)
                data["listStore"].push(item.toJSON());
        }
        data["isExpanded"] = this.isExpanded;
        return data;
    }

    clone(): AgencyInfoDto {
        const json = this.toJSON();
        let result = new AgencyInfoDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyInfoDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    ownerName: string | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    countMoneyAgency: number | undefined;
    countMoneySale: number | undefined;
    countMoneyStore: number | undefined;
    listStore: StoreAgencyInfoDto[] | undefined;
    isExpanded: boolean;
}

export class AgencyInfoDtoPagedResultDto implements IAgencyInfoDtoPagedResultDto {
    items: AgencyInfoDto[] | undefined;
    totalCount: number;

    constructor(data?: IAgencyInfoDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AgencyInfoDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AgencyInfoDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyInfoDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AgencyInfoDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AgencyInfoDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyInfoDtoPagedResultDto {
    items: AgencyInfoDto[] | undefined;
    totalCount: number;
}

export class AgencyInfoRequestDto implements IAgencyInfoRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyCode: string | undefined;
    storeCode: string | undefined;
    agencyPhoneNumber: string | undefined;
    storePhoneNumber: string | undefined;

    constructor(data?: IAgencyInfoRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.agencyCode = _data["agencyCode"];
            this.storeCode = _data["storeCode"];
            this.agencyPhoneNumber = _data["agencyPhoneNumber"];
            this.storePhoneNumber = _data["storePhoneNumber"];
        }
    }

    static fromJS(data: any): AgencyInfoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencyInfoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["agencyCode"] = this.agencyCode;
        data["storeCode"] = this.storeCode;
        data["agencyPhoneNumber"] = this.agencyPhoneNumber;
        data["storePhoneNumber"] = this.storePhoneNumber;
        return data;
    }

    clone(): AgencyInfoRequestDto {
        const json = this.toJSON();
        let result = new AgencyInfoRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAgencyInfoRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyCode: string | undefined;
    storeCode: string | undefined;
    agencyPhoneNumber: string | undefined;
    storePhoneNumber: string | undefined;
}

export class AgencySumaryDto implements IAgencySumaryDto {
    countAgency: number;
    countStore: number;
    commissionAgency: number;
    commissionSale: number;
    commissionStore: number;

    constructor(data?: IAgencySumaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countAgency = _data["countAgency"];
            this.countStore = _data["countStore"];
            this.commissionAgency = _data["commissionAgency"];
            this.commissionSale = _data["commissionSale"];
            this.commissionStore = _data["commissionStore"];
        }
    }

    static fromJS(data: any): AgencySumaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgencySumaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countAgency"] = this.countAgency;
        data["countStore"] = this.countStore;
        data["commissionAgency"] = this.commissionAgency;
        data["commissionSale"] = this.commissionSale;
        data["commissionStore"] = this.commissionStore;
        return data;
    }

    clone(): AgencySumaryDto {
        const json = this.toJSON();
        let result = new AgencySumaryDto();
        result.init(json);
        return result;
    }
}

export interface IAgencySumaryDto {
    countAgency: number;
    countStore: number;
    commissionAgency: number;
    commissionSale: number;
    commissionStore: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class AssingEmployeeRequestDto implements IAssingEmployeeRequestDto {
    processedById: number | undefined;
    orderId: number | undefined;

    constructor(data?: IAssingEmployeeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processedById = _data["processedById"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): AssingEmployeeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssingEmployeeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processedById"] = this.processedById;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): AssingEmployeeRequestDto {
        const json = this.toJSON();
        let result = new AssingEmployeeRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAssingEmployeeRequestDto {
    processedById: number | undefined;
    orderId: number | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    phoneNumber: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    phoneNumber: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BankDto implements IBankDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BankDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): BankDto {
        const json = this.toJSON();
        let result = new BankDto();
        result.init(json);
        return result;
    }
}

export interface IBankDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class BaseRequest implements IBaseRequest {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;

    constructor(data?: IBaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): BaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        return data;
    }

    clone(): BaseRequest {
        const json = this.toJSON();
        let result = new BaseRequest();
        result.init(json);
        return result;
    }
}

export interface IBaseRequest {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
}

export class CartDto implements ICartDto {
    id: number;
    personId: number;
    quantity: number;
    productStoreDetailId: number;
    productName: string | undefined;
    productCode: string | undefined;
    pathImage: string | undefined;
    price: number;
    inStock: boolean;
    selected: boolean;

    constructor(data?: ICartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.quantity = _data["quantity"];
            this.productStoreDetailId = _data["productStoreDetailId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.pathImage = _data["pathImage"];
            this.price = _data["price"];
            this.inStock = _data["inStock"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): CartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["quantity"] = this.quantity;
        data["productStoreDetailId"] = this.productStoreDetailId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["pathImage"] = this.pathImage;
        data["price"] = this.price;
        data["inStock"] = this.inStock;
        data["selected"] = this.selected;
        return data;
    }

    clone(): CartDto {
        const json = this.toJSON();
        let result = new CartDto();
        result.init(json);
        return result;
    }
}

export interface ICartDto {
    id: number;
    personId: number;
    quantity: number;
    productStoreDetailId: number;
    productName: string | undefined;
    productCode: string | undefined;
    pathImage: string | undefined;
    price: number;
    inStock: boolean;
    selected: boolean;
}

export class CartDtoPagedResultDto implements ICartDtoPagedResultDto {
    items: CartDto[] | undefined;
    totalCount: number;

    constructor(data?: ICartDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CartDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CartDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CartDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CartDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICartDtoPagedResultDto {
    items: CartDto[] | undefined;
    totalCount: number;
}

export class CatalogDto implements ICatalogDto {
    code: string | undefined;
    name: string | undefined;
    catalogType: string | undefined;
    description: string | undefined;

    constructor(data?: ICatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.catalogType = _data["catalogType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["catalogType"] = this.catalogType;
        data["description"] = this.description;
        return data;
    }

    clone(): CatalogDto {
        const json = this.toJSON();
        let result = new CatalogDto();
        result.init(json);
        return result;
    }
}

export interface ICatalogDto {
    code: string | undefined;
    name: string | undefined;
    catalogType: string | undefined;
    description: string | undefined;
}

export class CategoryMobileDto implements ICategoryMobileDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    pathImage: string | undefined;
    listFileId: number[] | undefined;
    listFile: FileManagerDto[] | undefined;
    orderNo: number | undefined;
    isActive: boolean;
    serviceFee: number;

    constructor(data?: ICategoryMobileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.pathImage = _data["pathImage"];
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
            if (Array.isArray(_data["listFile"])) {
                this.listFile = [] as any;
                for (let item of _data["listFile"])
                    this.listFile.push(FileManagerDto.fromJS(item));
            }
            this.orderNo = _data["orderNo"];
            this.isActive = _data["isActive"];
            this.serviceFee = _data["serviceFee"];
        }
    }

    static fromJS(data: any): CategoryMobileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryMobileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["pathImage"] = this.pathImage;
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        if (Array.isArray(this.listFile)) {
            data["listFile"] = [];
            for (let item of this.listFile)
                data["listFile"].push(item.toJSON());
        }
        data["orderNo"] = this.orderNo;
        data["isActive"] = this.isActive;
        data["serviceFee"] = this.serviceFee;
        return data;
    }

    clone(): CategoryMobileDto {
        const json = this.toJSON();
        let result = new CategoryMobileDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryMobileDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    pathImage: string | undefined;
    listFileId: number[] | undefined;
    listFile: FileManagerDto[] | undefined;
    orderNo: number | undefined;
    isActive: boolean;
    serviceFee: number;
}

export class CategoryMobileDtoPagedResultDto implements ICategoryMobileDtoPagedResultDto {
    items: CategoryMobileDto[] | undefined;
    totalCount: number;

    constructor(data?: ICategoryMobileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CategoryMobileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CategoryMobileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryMobileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CategoryMobileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CategoryMobileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryMobileDtoPagedResultDto {
    items: CategoryMobileDto[] | undefined;
    totalCount: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CollectionMetricsDto implements ICollectionMetricsDto {
    receivableCountToday: MetricDto;
    receivableAmountToday: MoneyMetricDto;
    collectedCountToday: MetricDto;
    collectedAmountToday: MoneyMetricDto;
    uncollectedCountToday: MetricDto;
    uncollectedAmountToday: MoneyMetricDto;
    collectionRateToday: number;
    trend: CollectionTrendPointDto[] | undefined;

    constructor(data?: ICollectionMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receivableCountToday = _data["receivableCountToday"] ? MetricDto.fromJS(_data["receivableCountToday"]) : <any>undefined;
            this.receivableAmountToday = _data["receivableAmountToday"] ? MoneyMetricDto.fromJS(_data["receivableAmountToday"]) : <any>undefined;
            this.collectedCountToday = _data["collectedCountToday"] ? MetricDto.fromJS(_data["collectedCountToday"]) : <any>undefined;
            this.collectedAmountToday = _data["collectedAmountToday"] ? MoneyMetricDto.fromJS(_data["collectedAmountToday"]) : <any>undefined;
            this.uncollectedCountToday = _data["uncollectedCountToday"] ? MetricDto.fromJS(_data["uncollectedCountToday"]) : <any>undefined;
            this.uncollectedAmountToday = _data["uncollectedAmountToday"] ? MoneyMetricDto.fromJS(_data["uncollectedAmountToday"]) : <any>undefined;
            this.collectionRateToday = _data["collectionRateToday"];
            if (Array.isArray(_data["trend"])) {
                this.trend = [] as any;
                for (let item of _data["trend"])
                    this.trend.push(CollectionTrendPointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receivableCountToday"] = this.receivableCountToday ? this.receivableCountToday.toJSON() : <any>undefined;
        data["receivableAmountToday"] = this.receivableAmountToday ? this.receivableAmountToday.toJSON() : <any>undefined;
        data["collectedCountToday"] = this.collectedCountToday ? this.collectedCountToday.toJSON() : <any>undefined;
        data["collectedAmountToday"] = this.collectedAmountToday ? this.collectedAmountToday.toJSON() : <any>undefined;
        data["uncollectedCountToday"] = this.uncollectedCountToday ? this.uncollectedCountToday.toJSON() : <any>undefined;
        data["uncollectedAmountToday"] = this.uncollectedAmountToday ? this.uncollectedAmountToday.toJSON() : <any>undefined;
        data["collectionRateToday"] = this.collectionRateToday;
        if (Array.isArray(this.trend)) {
            data["trend"] = [];
            for (let item of this.trend)
                data["trend"].push(item.toJSON());
        }
        return data;
    }

    clone(): CollectionMetricsDto {
        const json = this.toJSON();
        let result = new CollectionMetricsDto();
        result.init(json);
        return result;
    }
}

export interface ICollectionMetricsDto {
    receivableCountToday: MetricDto;
    receivableAmountToday: MoneyMetricDto;
    collectedCountToday: MetricDto;
    collectedAmountToday: MoneyMetricDto;
    uncollectedCountToday: MetricDto;
    uncollectedAmountToday: MoneyMetricDto;
    collectionRateToday: number;
    trend: CollectionTrendPointDto[] | undefined;
}

export class CollectionTrendPointDto implements ICollectionTrendPointDto {
    date: moment.Moment;
    receivableAmount: number;
    collectedAmount: number;

    constructor(data?: ICollectionTrendPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.receivableAmount = _data["receivableAmount"];
            this.collectedAmount = _data["collectedAmount"];
        }
    }

    static fromJS(data: any): CollectionTrendPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionTrendPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["receivableAmount"] = this.receivableAmount;
        data["collectedAmount"] = this.collectedAmount;
        return data;
    }

    clone(): CollectionTrendPointDto {
        const json = this.toJSON();
        let result = new CollectionTrendPointDto();
        result.init(json);
        return result;
    }
}

export interface ICollectionTrendPointDto {
    date: moment.Moment;
    receivableAmount: number;
    collectedAmount: number;
}

export class ConfigDto implements IConfigDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    note: string | undefined;
    isActive: boolean;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): ConfigDto {
        const json = this.toJSON();
        let result = new ConfigDto();
        result.init(json);
        return result;
    }
}

export interface IConfigDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    note: string | undefined;
    isActive: boolean;
}

export class ConfigDtoPagedResultDto implements IConfigDtoPagedResultDto {
    items: ConfigDto[] | undefined;
    totalCount: number;

    constructor(data?: IConfigDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ConfigDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ConfigDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ConfigDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ConfigDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IConfigDtoPagedResultDto {
    items: ConfigDto[] | undefined;
    totalCount: number;
}

export class CreateOrUpdatePersonRelativeDto implements ICreateOrUpdatePersonRelativeDto {
    id: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    relationship: string | undefined;
    phoneNumberUser: string;

    constructor(data?: ICreateOrUpdatePersonRelativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.relationship = _data["relationship"];
            this.phoneNumberUser = _data["phoneNumberUser"];
        }
    }

    static fromJS(data: any): CreateOrUpdatePersonRelativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePersonRelativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["relationship"] = this.relationship;
        data["phoneNumberUser"] = this.phoneNumberUser;
        return data;
    }

    clone(): CreateOrUpdatePersonRelativeDto {
        const json = this.toJSON();
        let result = new CreateOrUpdatePersonRelativeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdatePersonRelativeDto {
    id: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    relationship: string | undefined;
    phoneNumberUser: string;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUpdateAgencyDto implements ICreateUpdateAgencyDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    saleId: number | undefined;
    managerId: number | undefined;
    isActive: boolean;
    storeFeeConfigs: StoreFeeConfigDto[] | undefined;

    constructor(data?: ICreateUpdateAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.saleId = _data["saleId"];
            this.managerId = _data["managerId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["storeFeeConfigs"])) {
                this.storeFeeConfigs = [] as any;
                for (let item of _data["storeFeeConfigs"])
                    this.storeFeeConfigs.push(StoreFeeConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateAgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateAgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["saleId"] = this.saleId;
        data["managerId"] = this.managerId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.storeFeeConfigs)) {
            data["storeFeeConfigs"] = [];
            for (let item of this.storeFeeConfigs)
                data["storeFeeConfigs"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateUpdateAgencyDto {
        const json = this.toJSON();
        let result = new CreateUpdateAgencyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateAgencyDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    saleId: number | undefined;
    managerId: number | undefined;
    isActive: boolean;
    storeFeeConfigs: StoreFeeConfigDto[] | undefined;
}

export class CreateUpdateAgencyHistoryDto implements ICreateUpdateAgencyHistoryDto {
    ownerId: number | undefined;
    saleId: number | undefined;
    agencyCode: string | undefined;
    storeCode: string | undefined;
    orderCode: string | undefined;
    commissionAgency: number | undefined;
    commissionSale: number | undefined;
    commissionSystem: number | undefined;
    commissionStore: number | undefined;
    agencyFeePercent: number | undefined;
    saleFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;

    constructor(data?: ICreateUpdateAgencyHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.saleId = _data["saleId"];
            this.agencyCode = _data["agencyCode"];
            this.storeCode = _data["storeCode"];
            this.orderCode = _data["orderCode"];
            this.commissionAgency = _data["commissionAgency"];
            this.commissionSale = _data["commissionSale"];
            this.commissionSystem = _data["commissionSystem"];
            this.commissionStore = _data["commissionStore"];
            this.agencyFeePercent = _data["agencyFeePercent"];
            this.saleFeePercent = _data["saleFeePercent"];
            this.storeFeePercent = _data["storeFeePercent"];
            this.systemFeePercent = _data["systemFeePercent"];
        }
    }

    static fromJS(data: any): CreateUpdateAgencyHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateAgencyHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["saleId"] = this.saleId;
        data["agencyCode"] = this.agencyCode;
        data["storeCode"] = this.storeCode;
        data["orderCode"] = this.orderCode;
        data["commissionAgency"] = this.commissionAgency;
        data["commissionSale"] = this.commissionSale;
        data["commissionSystem"] = this.commissionSystem;
        data["commissionStore"] = this.commissionStore;
        data["agencyFeePercent"] = this.agencyFeePercent;
        data["saleFeePercent"] = this.saleFeePercent;
        data["storeFeePercent"] = this.storeFeePercent;
        data["systemFeePercent"] = this.systemFeePercent;
        return data;
    }

    clone(): CreateUpdateAgencyHistoryDto {
        const json = this.toJSON();
        let result = new CreateUpdateAgencyHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateAgencyHistoryDto {
    ownerId: number | undefined;
    saleId: number | undefined;
    agencyCode: string | undefined;
    storeCode: string | undefined;
    orderCode: string | undefined;
    commissionAgency: number | undefined;
    commissionSale: number | undefined;
    commissionSystem: number | undefined;
    commissionStore: number | undefined;
    agencyFeePercent: number | undefined;
    saleFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;
}

export class CreateUpdateBankDto implements ICreateUpdateBankDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: ICreateUpdateBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateUpdateBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateUpdateBankDto {
        const json = this.toJSON();
        let result = new CreateUpdateBankDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateBankDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class CreateUpdateCartDto implements ICreateUpdateCartDto {
    quantity: number | undefined;
    productStoreDetailId: number | undefined;

    constructor(data?: ICreateUpdateCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.productStoreDetailId = _data["productStoreDetailId"];
        }
    }

    static fromJS(data: any): CreateUpdateCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["productStoreDetailId"] = this.productStoreDetailId;
        return data;
    }

    clone(): CreateUpdateCartDto {
        const json = this.toJSON();
        let result = new CreateUpdateCartDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateCartDto {
    quantity: number | undefined;
    productStoreDetailId: number | undefined;
}

export class CreateUpdateConfigDto implements ICreateUpdateConfigDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    note: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateUpdateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateUpdateConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateUpdateConfigDto {
        const json = this.toJSON();
        let result = new CreateUpdateConfigDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateConfigDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    note: string | undefined;
    isActive: boolean;
}

export class CreateUpdateHistoryOrder implements ICreateUpdateHistoryOrder {
    action: string | undefined;
    note: string | undefined;
    orderId: number;
    transactionId: number | undefined;

    constructor(data?: ICreateUpdateHistoryOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.note = _data["note"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): CreateUpdateHistoryOrder {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateHistoryOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["note"] = this.note;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): CreateUpdateHistoryOrder {
        const json = this.toJSON();
        let result = new CreateUpdateHistoryOrder();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateHistoryOrder {
    action: string | undefined;
    note: string | undefined;
    orderId: number;
    transactionId: number | undefined;
}

export class CreateUpdateInvestorDto implements ICreateUpdateInvestorDto {
    id: number | undefined;
    userId: number | undefined;
    investorProfit: number | undefined;
    systemProfit: number | undefined;
    saleId: number | undefined;
    saleProfit: number | undefined;
    managerId: number | undefined;
    isActive: boolean;

    constructor(data?: ICreateUpdateInvestorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.investorProfit = _data["investorProfit"];
            this.systemProfit = _data["systemProfit"];
            this.saleId = _data["saleId"];
            this.saleProfit = _data["saleProfit"];
            this.managerId = _data["managerId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateUpdateInvestorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateInvestorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["investorProfit"] = this.investorProfit;
        data["systemProfit"] = this.systemProfit;
        data["saleId"] = this.saleId;
        data["saleProfit"] = this.saleProfit;
        data["managerId"] = this.managerId;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateUpdateInvestorDto {
        const json = this.toJSON();
        let result = new CreateUpdateInvestorDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateInvestorDto {
    id: number | undefined;
    userId: number | undefined;
    investorProfit: number | undefined;
    systemProfit: number | undefined;
    saleId: number | undefined;
    saleProfit: number | undefined;
    managerId: number | undefined;
    isActive: boolean;
}

export class CreateUpdateInvestorHistoryDto implements ICreateUpdateInvestorHistoryDto {
    investorId: number | undefined;
    systemId: number | undefined;
    saleId: number | undefined;
    orderId: number;
    transactionId: number;
    principalInvestor: number | undefined;
    interestInvestor: number | undefined;
    interestSystem: number | undefined;
    interestSale: number | undefined;

    constructor(data?: ICreateUpdateInvestorHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorId = _data["investorId"];
            this.systemId = _data["systemId"];
            this.saleId = _data["saleId"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
            this.principalInvestor = _data["principalInvestor"];
            this.interestInvestor = _data["interestInvestor"];
            this.interestSystem = _data["interestSystem"];
            this.interestSale = _data["interestSale"];
        }
    }

    static fromJS(data: any): CreateUpdateInvestorHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateInvestorHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorId"] = this.investorId;
        data["systemId"] = this.systemId;
        data["saleId"] = this.saleId;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        data["principalInvestor"] = this.principalInvestor;
        data["interestInvestor"] = this.interestInvestor;
        data["interestSystem"] = this.interestSystem;
        data["interestSale"] = this.interestSale;
        return data;
    }

    clone(): CreateUpdateInvestorHistoryDto {
        const json = this.toJSON();
        let result = new CreateUpdateInvestorHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateInvestorHistoryDto {
    investorId: number | undefined;
    systemId: number | undefined;
    saleId: number | undefined;
    orderId: number;
    transactionId: number;
    principalInvestor: number | undefined;
    interestInvestor: number | undefined;
    interestSystem: number | undefined;
    interestSale: number | undefined;
}

export class CreateUpdateMachineConditionDto implements ICreateUpdateMachineConditionDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: ICreateUpdateMachineConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateUpdateMachineConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateMachineConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateUpdateMachineConditionDto {
        const json = this.toJSON();
        let result = new CreateUpdateMachineConditionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateMachineConditionDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
}

export class CreateUpdateProductDto implements ICreateUpdateProductDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    categoryMobileCode: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateUpdateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.categoryMobileCode = _data["categoryMobileCode"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateUpdateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["categoryMobileCode"] = this.categoryMobileCode;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateUpdateProductDto {
        const json = this.toJSON();
        let result = new CreateUpdateProductDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateProductDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    categoryMobileCode: string | undefined;
    isActive: boolean;
}

export class CreateUpdateProductStoreDto implements ICreateUpdateProductStoreDto {
    id: number | undefined;
    code: string | undefined;
    storeCode: string | undefined;
    productCode: string | undefined;
    pathImage: string | undefined;
    price: number;
    stars: number | undefined;
    sold: number | undefined;
    count: number;
    listProductStoreDetailDto: ProductStoreDetailDto[] | undefined;
    isActive: boolean;

    constructor(data?: ICreateUpdateProductStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.storeCode = _data["storeCode"];
            this.productCode = _data["productCode"];
            this.pathImage = _data["pathImage"];
            this.price = _data["price"];
            this.stars = _data["stars"];
            this.sold = _data["sold"];
            this.count = _data["count"];
            if (Array.isArray(_data["listProductStoreDetailDto"])) {
                this.listProductStoreDetailDto = [] as any;
                for (let item of _data["listProductStoreDetailDto"])
                    this.listProductStoreDetailDto.push(ProductStoreDetailDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateUpdateProductStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateProductStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["storeCode"] = this.storeCode;
        data["productCode"] = this.productCode;
        data["pathImage"] = this.pathImage;
        data["price"] = this.price;
        data["stars"] = this.stars;
        data["sold"] = this.sold;
        data["count"] = this.count;
        if (Array.isArray(this.listProductStoreDetailDto)) {
            data["listProductStoreDetailDto"] = [];
            for (let item of this.listProductStoreDetailDto)
                data["listProductStoreDetailDto"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateUpdateProductStoreDto {
        const json = this.toJSON();
        let result = new CreateUpdateProductStoreDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateProductStoreDto {
    id: number | undefined;
    code: string | undefined;
    storeCode: string | undefined;
    productCode: string | undefined;
    pathImage: string | undefined;
    price: number;
    stars: number | undefined;
    sold: number | undefined;
    count: number;
    listProductStoreDetailDto: ProductStoreDetailDto[] | undefined;
    isActive: boolean;
}

export class CreateUpdateStoreDto implements ICreateUpdateStoreDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    address: string | undefined;
    monthlyInterestRate: number;
    leaseTermCode: number;
    isActive: boolean;
    agencyCode: string | undefined;
    files: string[] | undefined;
    listIdDelete: number[] | undefined;
    fileImageStores: string[] | undefined;
    listIdDeleteImageStore: number[] | undefined;
    phoneNumber: string | undefined;
    fileImagePayments: string[] | undefined;
    listIdDeleteImagePayment: number[] | undefined;
    fileIdentityFronts: string[] | undefined;
    listIdDeleteIdentityFront: number[] | undefined;
    fileIdentityBacks: string[] | undefined;
    listIdDeleteIdentityBack: number[] | undefined;
    fileBusinessLicenses: string[] | undefined;
    listIdDeleteBusinessLicense: number[] | undefined;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    accountName: string | undefined;
    shopOwner: string | undefined;
    ownerId: number | undefined;
    prepayPricePercentage: number | undefined;
    email: string | undefined;
    serviceFee: number | undefined;
    saleFeePercent: number | undefined;
    agencyFeePercent: number | undefined;
    storeFeePercent: number | undefined;

    constructor(data?: ICreateUpdateStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.isActive = _data["isActive"];
            this.agencyCode = _data["agencyCode"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            if (Array.isArray(_data["listIdDelete"])) {
                this.listIdDelete = [] as any;
                for (let item of _data["listIdDelete"])
                    this.listIdDelete.push(item);
            }
            if (Array.isArray(_data["fileImageStores"])) {
                this.fileImageStores = [] as any;
                for (let item of _data["fileImageStores"])
                    this.fileImageStores.push(item);
            }
            if (Array.isArray(_data["listIdDeleteImageStore"])) {
                this.listIdDeleteImageStore = [] as any;
                for (let item of _data["listIdDeleteImageStore"])
                    this.listIdDeleteImageStore.push(item);
            }
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["fileImagePayments"])) {
                this.fileImagePayments = [] as any;
                for (let item of _data["fileImagePayments"])
                    this.fileImagePayments.push(item);
            }
            if (Array.isArray(_data["listIdDeleteImagePayment"])) {
                this.listIdDeleteImagePayment = [] as any;
                for (let item of _data["listIdDeleteImagePayment"])
                    this.listIdDeleteImagePayment.push(item);
            }
            if (Array.isArray(_data["fileIdentityFronts"])) {
                this.fileIdentityFronts = [] as any;
                for (let item of _data["fileIdentityFronts"])
                    this.fileIdentityFronts.push(item);
            }
            if (Array.isArray(_data["listIdDeleteIdentityFront"])) {
                this.listIdDeleteIdentityFront = [] as any;
                for (let item of _data["listIdDeleteIdentityFront"])
                    this.listIdDeleteIdentityFront.push(item);
            }
            if (Array.isArray(_data["fileIdentityBacks"])) {
                this.fileIdentityBacks = [] as any;
                for (let item of _data["fileIdentityBacks"])
                    this.fileIdentityBacks.push(item);
            }
            if (Array.isArray(_data["listIdDeleteIdentityBack"])) {
                this.listIdDeleteIdentityBack = [] as any;
                for (let item of _data["listIdDeleteIdentityBack"])
                    this.listIdDeleteIdentityBack.push(item);
            }
            if (Array.isArray(_data["fileBusinessLicenses"])) {
                this.fileBusinessLicenses = [] as any;
                for (let item of _data["fileBusinessLicenses"])
                    this.fileBusinessLicenses.push(item);
            }
            if (Array.isArray(_data["listIdDeleteBusinessLicense"])) {
                this.listIdDeleteBusinessLicense = [] as any;
                for (let item of _data["listIdDeleteBusinessLicense"])
                    this.listIdDeleteBusinessLicense.push(item);
            }
            this.bankAccount = _data["bankAccount"];
            this.bankCode = _data["bankCode"];
            this.accountName = _data["accountName"];
            this.shopOwner = _data["shopOwner"];
            this.ownerId = _data["ownerId"];
            this.prepayPricePercentage = _data["prepayPricePercentage"];
            this.email = _data["email"];
            this.serviceFee = _data["serviceFee"];
            this.saleFeePercent = _data["saleFeePercent"];
            this.agencyFeePercent = _data["agencyFeePercent"];
            this.storeFeePercent = _data["storeFeePercent"];
        }
    }

    static fromJS(data: any): CreateUpdateStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["address"] = this.address;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["leaseTermCode"] = this.leaseTermCode;
        data["isActive"] = this.isActive;
        data["agencyCode"] = this.agencyCode;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        if (Array.isArray(this.listIdDelete)) {
            data["listIdDelete"] = [];
            for (let item of this.listIdDelete)
                data["listIdDelete"].push(item);
        }
        if (Array.isArray(this.fileImageStores)) {
            data["fileImageStores"] = [];
            for (let item of this.fileImageStores)
                data["fileImageStores"].push(item);
        }
        if (Array.isArray(this.listIdDeleteImageStore)) {
            data["listIdDeleteImageStore"] = [];
            for (let item of this.listIdDeleteImageStore)
                data["listIdDeleteImageStore"].push(item);
        }
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.fileImagePayments)) {
            data["fileImagePayments"] = [];
            for (let item of this.fileImagePayments)
                data["fileImagePayments"].push(item);
        }
        if (Array.isArray(this.listIdDeleteImagePayment)) {
            data["listIdDeleteImagePayment"] = [];
            for (let item of this.listIdDeleteImagePayment)
                data["listIdDeleteImagePayment"].push(item);
        }
        if (Array.isArray(this.fileIdentityFronts)) {
            data["fileIdentityFronts"] = [];
            for (let item of this.fileIdentityFronts)
                data["fileIdentityFronts"].push(item);
        }
        if (Array.isArray(this.listIdDeleteIdentityFront)) {
            data["listIdDeleteIdentityFront"] = [];
            for (let item of this.listIdDeleteIdentityFront)
                data["listIdDeleteIdentityFront"].push(item);
        }
        if (Array.isArray(this.fileIdentityBacks)) {
            data["fileIdentityBacks"] = [];
            for (let item of this.fileIdentityBacks)
                data["fileIdentityBacks"].push(item);
        }
        if (Array.isArray(this.listIdDeleteIdentityBack)) {
            data["listIdDeleteIdentityBack"] = [];
            for (let item of this.listIdDeleteIdentityBack)
                data["listIdDeleteIdentityBack"].push(item);
        }
        if (Array.isArray(this.fileBusinessLicenses)) {
            data["fileBusinessLicenses"] = [];
            for (let item of this.fileBusinessLicenses)
                data["fileBusinessLicenses"].push(item);
        }
        if (Array.isArray(this.listIdDeleteBusinessLicense)) {
            data["listIdDeleteBusinessLicense"] = [];
            for (let item of this.listIdDeleteBusinessLicense)
                data["listIdDeleteBusinessLicense"].push(item);
        }
        data["bankAccount"] = this.bankAccount;
        data["bankCode"] = this.bankCode;
        data["accountName"] = this.accountName;
        data["shopOwner"] = this.shopOwner;
        data["ownerId"] = this.ownerId;
        data["prepayPricePercentage"] = this.prepayPricePercentage;
        data["email"] = this.email;
        data["serviceFee"] = this.serviceFee;
        data["saleFeePercent"] = this.saleFeePercent;
        data["agencyFeePercent"] = this.agencyFeePercent;
        data["storeFeePercent"] = this.storeFeePercent;
        return data;
    }

    clone(): CreateUpdateStoreDto {
        const json = this.toJSON();
        let result = new CreateUpdateStoreDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateStoreDto {
    id: number | undefined;
    code: string | undefined;
    name: string | undefined;
    address: string | undefined;
    monthlyInterestRate: number;
    leaseTermCode: number;
    isActive: boolean;
    agencyCode: string | undefined;
    files: string[] | undefined;
    listIdDelete: number[] | undefined;
    fileImageStores: string[] | undefined;
    listIdDeleteImageStore: number[] | undefined;
    phoneNumber: string | undefined;
    fileImagePayments: string[] | undefined;
    listIdDeleteImagePayment: number[] | undefined;
    fileIdentityFronts: string[] | undefined;
    listIdDeleteIdentityFront: number[] | undefined;
    fileIdentityBacks: string[] | undefined;
    listIdDeleteIdentityBack: number[] | undefined;
    fileBusinessLicenses: string[] | undefined;
    listIdDeleteBusinessLicense: number[] | undefined;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    accountName: string | undefined;
    shopOwner: string | undefined;
    ownerId: number | undefined;
    prepayPricePercentage: number | undefined;
    email: string | undefined;
    serviceFee: number | undefined;
    saleFeePercent: number | undefined;
    agencyFeePercent: number | undefined;
    storeFeePercent: number | undefined;
}

export class CreateUpdateTransactionDetailDto implements ICreateUpdateTransactionDetailDto {
    id: number | undefined;
    recallId: number;
    legalStatus: string | undefined;
    note: string | undefined;
    transactionId: number;

    constructor(data?: ICreateUpdateTransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recallId = _data["recallId"];
            this.legalStatus = _data["legalStatus"];
            this.note = _data["note"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): CreateUpdateTransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateTransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recallId"] = this.recallId;
        data["legalStatus"] = this.legalStatus;
        data["note"] = this.note;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): CreateUpdateTransactionDetailDto {
        const json = this.toJSON();
        let result = new CreateUpdateTransactionDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateTransactionDetailDto {
    id: number | undefined;
    recallId: number;
    legalStatus: string | undefined;
    note: string | undefined;
    transactionId: number;
}

export class CreateUpdateUserOrderSplittingDto implements ICreateUpdateUserOrderSplittingDto {
    userId: number;
    isOnline: boolean;
    countOrder: number;
    role: string | undefined;

    constructor(data?: ICreateUpdateUserOrderSplittingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isOnline = _data["isOnline"];
            this.countOrder = _data["countOrder"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CreateUpdateUserOrderSplittingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateUserOrderSplittingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isOnline"] = this.isOnline;
        data["countOrder"] = this.countOrder;
        data["role"] = this.role;
        return data;
    }

    clone(): CreateUpdateUserOrderSplittingDto {
        const json = this.toJSON();
        let result = new CreateUpdateUserOrderSplittingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateUserOrderSplittingDto {
    userId: number;
    isOnline: boolean;
    countOrder: number;
    role: string | undefined;
}

export class CreateUpdateWalletHistoryDto implements ICreateUpdateWalletHistoryDto {
    userId: number;
    action: string | undefined;
    methodPayment: string | undefined;
    status: string | undefined;
    monney: number | undefined;
    note: string | undefined;
    objectId: number | undefined;

    constructor(data?: ICreateUpdateWalletHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.action = _data["action"];
            this.methodPayment = _data["methodPayment"];
            this.status = _data["status"];
            this.monney = _data["monney"];
            this.note = _data["note"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): CreateUpdateWalletHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateWalletHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["action"] = this.action;
        data["methodPayment"] = this.methodPayment;
        data["status"] = this.status;
        data["monney"] = this.monney;
        data["note"] = this.note;
        data["objectId"] = this.objectId;
        return data;
    }

    clone(): CreateUpdateWalletHistoryDto {
        const json = this.toJSON();
        let result = new CreateUpdateWalletHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateWalletHistoryDto {
    userId: number;
    action: string | undefined;
    methodPayment: string | undefined;
    status: string | undefined;
    monney: number | undefined;
    note: string | undefined;
    objectId: number | undefined;
}

export class CreateUpdateWithdrawDto implements ICreateUpdateWithdrawDto {
    id: number | undefined;
    amount: number;
    bankCode: string | undefined;
    bankAccount: string | undefined;
    accountName: string | undefined;
    note: string | undefined;

    constructor(data?: ICreateUpdateWithdrawDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.bankCode = _data["bankCode"];
            this.bankAccount = _data["bankAccount"];
            this.accountName = _data["accountName"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateUpdateWithdrawDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateWithdrawDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["bankCode"] = this.bankCode;
        data["bankAccount"] = this.bankAccount;
        data["accountName"] = this.accountName;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateUpdateWithdrawDto {
        const json = this.toJSON();
        let result = new CreateUpdateWithdrawDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateWithdrawDto {
    id: number | undefined;
    amount: number;
    bankCode: string | undefined;
    bankAccount: string | undefined;
    accountName: string | undefined;
    note: string | undefined;
}

export class CustomerOrderDto implements ICustomerOrderDto {
    orderId: number;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    listFileId: number[] | undefined;
    fileBeforeCCCDCard: FileManagerDto;
    fileAlterCCCDCard: FileManagerDto;
    address: string | undefined;
    cccd: string | undefined;
    issuingAuthority: string | undefined;
    dateIssued: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
    listPersonRelative: PersonRelativeDto[] | undefined;

    constructor(data?: ICustomerOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
            this.fileBeforeCCCDCard = _data["fileBeforeCCCDCard"] ? FileManagerDto.fromJS(_data["fileBeforeCCCDCard"]) : <any>undefined;
            this.fileAlterCCCDCard = _data["fileAlterCCCDCard"] ? FileManagerDto.fromJS(_data["fileAlterCCCDCard"]) : <any>undefined;
            this.address = _data["address"];
            this.cccd = _data["cccd"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateIssued = _data["dateIssued"] ? moment(_data["dateIssued"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            if (Array.isArray(_data["listPersonRelative"])) {
                this.listPersonRelative = [] as any;
                for (let item of _data["listPersonRelative"])
                    this.listPersonRelative.push(PersonRelativeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        data["fileBeforeCCCDCard"] = this.fileBeforeCCCDCard ? this.fileBeforeCCCDCard.toJSON() : <any>undefined;
        data["fileAlterCCCDCard"] = this.fileAlterCCCDCard ? this.fileAlterCCCDCard.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["cccd"] = this.cccd;
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateIssued"] = this.dateIssued ? this.dateIssued.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        if (Array.isArray(this.listPersonRelative)) {
            data["listPersonRelative"] = [];
            for (let item of this.listPersonRelative)
                data["listPersonRelative"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerOrderDto {
        const json = this.toJSON();
        let result = new CustomerOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerOrderDto {
    orderId: number;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    listFileId: number[] | undefined;
    fileBeforeCCCDCard: FileManagerDto;
    fileAlterCCCDCard: FileManagerDto;
    address: string | undefined;
    cccd: string | undefined;
    issuingAuthority: string | undefined;
    dateIssued: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
    listPersonRelative: PersonRelativeDto[] | undefined;
}

export class DashboardAlertDto implements IDashboardAlertDto {
    severity: string | undefined;
    title: string | undefined;
    detail: string | undefined;
    occurredAt: moment.Moment;

    constructor(data?: IDashboardAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.title = _data["title"];
            this.detail = _data["detail"];
            this.occurredAt = _data["occurredAt"] ? moment(_data["occurredAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["title"] = this.title;
        data["detail"] = this.detail;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): DashboardAlertDto {
        const json = this.toJSON();
        let result = new DashboardAlertDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardAlertDto {
    severity: string | undefined;
    title: string | undefined;
    detail: string | undefined;
    occurredAt: moment.Moment;
}

export class DashboardOrderItemDto implements IDashboardOrderItemDto {
    id: number;
    orderCode: string | undefined;
    creationTime: moment.Moment;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    address: string | undefined;
    cccd: string | undefined;
    orderStatus: string | undefined;
    staffOrderStatus: string | undefined;
    price: number;
    storeCode: string | undefined;
    storeName: string | undefined;

    constructor(data?: IDashboardOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderCode = _data["orderCode"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.cccd = _data["cccd"];
            this.orderStatus = _data["orderStatus"];
            this.staffOrderStatus = _data["staffOrderStatus"];
            this.price = _data["price"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): DashboardOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["cccd"] = this.cccd;
        data["orderStatus"] = this.orderStatus;
        data["staffOrderStatus"] = this.staffOrderStatus;
        data["price"] = this.price;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        return data;
    }

    clone(): DashboardOrderItemDto {
        const json = this.toJSON();
        let result = new DashboardOrderItemDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardOrderItemDto {
    id: number;
    orderCode: string | undefined;
    creationTime: moment.Moment;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    address: string | undefined;
    cccd: string | undefined;
    orderStatus: string | undefined;
    staffOrderStatus: string | undefined;
    price: number;
    storeCode: string | undefined;
    storeName: string | undefined;
}

export class DashboardOrderItemDtoPagedResultDto implements IDashboardOrderItemDtoPagedResultDto {
    items: DashboardOrderItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IDashboardOrderItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DashboardOrderItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DashboardOrderItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOrderItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DashboardOrderItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DashboardOrderItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardOrderItemDtoPagedResultDto {
    items: DashboardOrderItemDto[] | undefined;
    totalCount: number;
}

export class DashboardOrderListRequestDto implements IDashboardOrderListRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    statisticType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    orderStatus: string | undefined;
    customerName: string | undefined;
    customerPhone: string | undefined;
    orderCode: string | undefined;
    agencyCode: string | undefined;
    investorId: number | undefined;

    constructor(data?: IDashboardOrderListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.statisticType = _data["statisticType"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.orderStatus = _data["orderStatus"];
            this.customerName = _data["customerName"];
            this.customerPhone = _data["customerPhone"];
            this.orderCode = _data["orderCode"];
            this.agencyCode = _data["agencyCode"];
            this.investorId = _data["investorId"];
        }
    }

    static fromJS(data: any): DashboardOrderListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOrderListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["statisticType"] = this.statisticType;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["orderStatus"] = this.orderStatus;
        data["customerName"] = this.customerName;
        data["customerPhone"] = this.customerPhone;
        data["orderCode"] = this.orderCode;
        data["agencyCode"] = this.agencyCode;
        data["investorId"] = this.investorId;
        return data;
    }

    clone(): DashboardOrderListRequestDto {
        const json = this.toJSON();
        let result = new DashboardOrderListRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardOrderListRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    statisticType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    orderStatus: string | undefined;
    customerName: string | undefined;
    customerPhone: string | undefined;
    orderCode: string | undefined;
    agencyCode: string | undefined;
    investorId: number | undefined;
}

export class DashboardOverviewDto implements IDashboardOverviewDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    previousFromDate: moment.Moment;
    previousToDate: moment.Moment;
    today: TodayMetricsDto;
    performance: PerformanceMetricsDto;
    overdue: OverdueMetricsDto;
    collection: CollectionMetricsDto;
    totalOrdersAllTime: number;
    orderStatusDistribution: OrderStatusDistributionItemDto[] | undefined;
    alerts: DashboardAlertDto[] | undefined;

    constructor(data?: IDashboardOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.previousFromDate = _data["previousFromDate"] ? moment(_data["previousFromDate"].toString()) : <any>undefined;
            this.previousToDate = _data["previousToDate"] ? moment(_data["previousToDate"].toString()) : <any>undefined;
            this.today = _data["today"] ? TodayMetricsDto.fromJS(_data["today"]) : <any>undefined;
            this.performance = _data["performance"] ? PerformanceMetricsDto.fromJS(_data["performance"]) : <any>undefined;
            this.overdue = _data["overdue"] ? OverdueMetricsDto.fromJS(_data["overdue"]) : <any>undefined;
            this.collection = _data["collection"] ? CollectionMetricsDto.fromJS(_data["collection"]) : <any>undefined;
            this.totalOrdersAllTime = _data["totalOrdersAllTime"];
            if (Array.isArray(_data["orderStatusDistribution"])) {
                this.orderStatusDistribution = [] as any;
                for (let item of _data["orderStatusDistribution"])
                    this.orderStatusDistribution.push(OrderStatusDistributionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts.push(DashboardAlertDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["previousFromDate"] = this.previousFromDate ? this.previousFromDate.toISOString() : <any>undefined;
        data["previousToDate"] = this.previousToDate ? this.previousToDate.toISOString() : <any>undefined;
        data["today"] = this.today ? this.today.toJSON() : <any>undefined;
        data["performance"] = this.performance ? this.performance.toJSON() : <any>undefined;
        data["overdue"] = this.overdue ? this.overdue.toJSON() : <any>undefined;
        data["collection"] = this.collection ? this.collection.toJSON() : <any>undefined;
        data["totalOrdersAllTime"] = this.totalOrdersAllTime;
        if (Array.isArray(this.orderStatusDistribution)) {
            data["orderStatusDistribution"] = [];
            for (let item of this.orderStatusDistribution)
                data["orderStatusDistribution"].push(item.toJSON());
        }
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item.toJSON());
        }
        return data;
    }

    clone(): DashboardOverviewDto {
        const json = this.toJSON();
        let result = new DashboardOverviewDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardOverviewDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    previousFromDate: moment.Moment;
    previousToDate: moment.Moment;
    today: TodayMetricsDto;
    performance: PerformanceMetricsDto;
    overdue: OverdueMetricsDto;
    collection: CollectionMetricsDto;
    totalOrdersAllTime: number;
    orderStatusDistribution: OrderStatusDistributionItemDto[] | undefined;
    alerts: DashboardAlertDto[] | undefined;
}

export class DashboardOverviewRequestDto implements IDashboardOverviewRequestDto {
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;

    constructor(data?: IDashboardOverviewRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardOverviewRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverviewRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DashboardOverviewRequestDto {
        const json = this.toJSON();
        let result = new DashboardOverviewRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardOverviewRequestDto {
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
}

export class DashboardTransactionItemDto implements IDashboardTransactionItemDto {
    orderId: number;
    orderCode: string | undefined;
    transactionId: number;
    transactionCode: string | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    principal: number;
    amounToBePaid: number;
    transactionStatus: string | undefined;
    staffOrderStatus: string | undefined;
    storeName: string | undefined;

    constructor(data?: IDashboardTransactionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderCode = _data["orderCode"];
            this.transactionId = _data["transactionId"];
            this.transactionCode = _data["transactionCode"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.principal = _data["principal"];
            this.amounToBePaid = _data["amounToBePaid"];
            this.transactionStatus = _data["transactionStatus"];
            this.staffOrderStatus = _data["staffOrderStatus"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): DashboardTransactionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTransactionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderCode"] = this.orderCode;
        data["transactionId"] = this.transactionId;
        data["transactionCode"] = this.transactionCode;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["principal"] = this.principal;
        data["amounToBePaid"] = this.amounToBePaid;
        data["transactionStatus"] = this.transactionStatus;
        data["staffOrderStatus"] = this.staffOrderStatus;
        data["storeName"] = this.storeName;
        return data;
    }

    clone(): DashboardTransactionItemDto {
        const json = this.toJSON();
        let result = new DashboardTransactionItemDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardTransactionItemDto {
    orderId: number;
    orderCode: string | undefined;
    transactionId: number;
    transactionCode: string | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    principal: number;
    amounToBePaid: number;
    transactionStatus: string | undefined;
    staffOrderStatus: string | undefined;
    storeName: string | undefined;
}

export class DashboardTransactionItemDtoPagedResultDto implements IDashboardTransactionItemDtoPagedResultDto {
    items: DashboardTransactionItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IDashboardTransactionItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DashboardTransactionItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DashboardTransactionItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTransactionItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DashboardTransactionItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DashboardTransactionItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardTransactionItemDtoPagedResultDto {
    items: DashboardTransactionItemDto[] | undefined;
    totalCount: number;
}

export class DashboardTransactionListRequestDto implements IDashboardTransactionListRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    statisticType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    orderStatus: string | undefined;
    transactionStatus: string | undefined;
    customerName: string | undefined;
    customerPhone: string | undefined;
    orderCode: string | undefined;
    transactionCode: string | undefined;
    agencyCode: string | undefined;
    investorId: number | undefined;

    constructor(data?: IDashboardTransactionListRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.statisticType = _data["statisticType"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.orderStatus = _data["orderStatus"];
            this.transactionStatus = _data["transactionStatus"];
            this.customerName = _data["customerName"];
            this.customerPhone = _data["customerPhone"];
            this.orderCode = _data["orderCode"];
            this.transactionCode = _data["transactionCode"];
            this.agencyCode = _data["agencyCode"];
            this.investorId = _data["investorId"];
        }
    }

    static fromJS(data: any): DashboardTransactionListRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTransactionListRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["statisticType"] = this.statisticType;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["orderStatus"] = this.orderStatus;
        data["transactionStatus"] = this.transactionStatus;
        data["customerName"] = this.customerName;
        data["customerPhone"] = this.customerPhone;
        data["orderCode"] = this.orderCode;
        data["transactionCode"] = this.transactionCode;
        data["agencyCode"] = this.agencyCode;
        data["investorId"] = this.investorId;
        return data;
    }

    clone(): DashboardTransactionListRequestDto {
        const json = this.toJSON();
        let result = new DashboardTransactionListRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardTransactionListRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    statisticType: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    orderStatus: string | undefined;
    transactionStatus: string | undefined;
    customerName: string | undefined;
    customerPhone: string | undefined;
    orderCode: string | undefined;
    transactionCode: string | undefined;
    agencyCode: string | undefined;
    investorId: number | undefined;
}

export class DeviceParam implements IDeviceParam {
    deviceName: string | undefined;
    deviceOS: string | undefined;
    location: string | undefined;
    ipAddress: string | undefined;

    constructor(data?: IDeviceParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceName = _data["deviceName"];
            this.deviceOS = _data["deviceOS"];
            this.location = _data["location"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): DeviceParam {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["deviceOS"] = this.deviceOS;
        data["location"] = this.location;
        data["ipAddress"] = this.ipAddress;
        return data;
    }

    clone(): DeviceParam {
        const json = this.toJSON();
        let result = new DeviceParam();
        result.init(json);
        return result;
    }
}

export interface IDeviceParam {
    deviceName: string | undefined;
    deviceOS: string | undefined;
    location: string | undefined;
    ipAddress: string | undefined;
}

export class DisbursementAgentDto implements IDisbursementAgentDto {
    id: number;
    shippingDate: moment.Moment | undefined;
    buyDate: moment.Moment | undefined;
    storeName: string | undefined;
    accountName: string | undefined;
    bankAccount: string | undefined;
    bankName: string | undefined;
    productName: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    price: number | undefined;
    prepayPrice: number | undefined;
    serviceFee: number | undefined;
    amountDisburseed: number | undefined;
    fullName: string | undefined;
    cccd: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IDisbursementAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shippingDate = _data["shippingDate"] ? moment(_data["shippingDate"].toString()) : <any>undefined;
            this.buyDate = _data["buyDate"] ? moment(_data["buyDate"].toString()) : <any>undefined;
            this.storeName = _data["storeName"];
            this.accountName = _data["accountName"];
            this.bankAccount = _data["bankAccount"];
            this.bankName = _data["bankName"];
            this.productName = _data["productName"];
            this.seri = _data["seri"];
            this.imei = _data["imei"];
            this.colorCode = _data["colorCode"];
            this.machineConditionCode = _data["machineConditionCode"];
            this.price = _data["price"];
            this.prepayPrice = _data["prepayPrice"];
            this.serviceFee = _data["serviceFee"];
            this.amountDisburseed = _data["amountDisburseed"];
            this.fullName = _data["fullName"];
            this.cccd = _data["cccd"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): DisbursementAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisbursementAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shippingDate"] = this.shippingDate ? this.shippingDate.toISOString() : <any>undefined;
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["storeName"] = this.storeName;
        data["accountName"] = this.accountName;
        data["bankAccount"] = this.bankAccount;
        data["bankName"] = this.bankName;
        data["productName"] = this.productName;
        data["seri"] = this.seri;
        data["imei"] = this.imei;
        data["colorCode"] = this.colorCode;
        data["machineConditionCode"] = this.machineConditionCode;
        data["price"] = this.price;
        data["prepayPrice"] = this.prepayPrice;
        data["serviceFee"] = this.serviceFee;
        data["amountDisburseed"] = this.amountDisburseed;
        data["fullName"] = this.fullName;
        data["cccd"] = this.cccd;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): DisbursementAgentDto {
        const json = this.toJSON();
        let result = new DisbursementAgentDto();
        result.init(json);
        return result;
    }
}

export interface IDisbursementAgentDto {
    id: number;
    shippingDate: moment.Moment | undefined;
    buyDate: moment.Moment | undefined;
    storeName: string | undefined;
    accountName: string | undefined;
    bankAccount: string | undefined;
    bankName: string | undefined;
    productName: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    price: number | undefined;
    prepayPrice: number | undefined;
    serviceFee: number | undefined;
    amountDisburseed: number | undefined;
    fullName: string | undefined;
    cccd: string | undefined;
    phoneNumber: string | undefined;
}

export class DisbursementAgentDtoPagedResultDto implements IDisbursementAgentDtoPagedResultDto {
    items: DisbursementAgentDto[] | undefined;
    totalCount: number;

    constructor(data?: IDisbursementAgentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DisbursementAgentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DisbursementAgentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisbursementAgentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DisbursementAgentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DisbursementAgentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDisbursementAgentDtoPagedResultDto {
    items: DisbursementAgentDto[] | undefined;
    totalCount: number;
}

export class DisbursementAgentRequestDto implements IDisbursementAgentRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    orderCode: string | undefined;
    storeCode: string | undefined;
    agencyCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    seri: string | undefined;
    imei: string | undefined;

    constructor(data?: IDisbursementAgentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.orderCode = _data["orderCode"];
            this.storeCode = _data["storeCode"];
            this.agencyCode = _data["agencyCode"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.seri = _data["seri"];
            this.imei = _data["imei"];
        }
    }

    static fromJS(data: any): DisbursementAgentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisbursementAgentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["orderCode"] = this.orderCode;
        data["storeCode"] = this.storeCode;
        data["agencyCode"] = this.agencyCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["seri"] = this.seri;
        data["imei"] = this.imei;
        return data;
    }

    clone(): DisbursementAgentRequestDto {
        const json = this.toJSON();
        let result = new DisbursementAgentRequestDto();
        result.init(json);
        return result;
    }
}

export interface IDisbursementAgentRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    orderCode: string | undefined;
    storeCode: string | undefined;
    agencyCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    seri: string | undefined;
    imei: string | undefined;
}

export class DocHistoryByDocIdDto implements IDocHistoryByDocIdDto {
    documentId: string | undefined;
    userId: string | undefined;
    ipAddress: string | undefined;
    location: string | undefined;
    locatonAddress: string | undefined;
    deviceOS: string | undefined;
    deviceName: string | undefined;
    action: number | undefined;
    creationTime: moment.Moment | undefined;

    constructor(data?: IDocHistoryByDocIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.userId = _data["userId"];
            this.ipAddress = _data["ipAddress"];
            this.location = _data["location"];
            this.locatonAddress = _data["locatonAddress"];
            this.deviceOS = _data["deviceOS"];
            this.deviceName = _data["deviceName"];
            this.action = _data["action"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocHistoryByDocIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocHistoryByDocIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["userId"] = this.userId;
        data["ipAddress"] = this.ipAddress;
        data["location"] = this.location;
        data["locatonAddress"] = this.locatonAddress;
        data["deviceOS"] = this.deviceOS;
        data["deviceName"] = this.deviceName;
        data["action"] = this.action;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): DocHistoryByDocIdDto {
        const json = this.toJSON();
        let result = new DocHistoryByDocIdDto();
        result.init(json);
        return result;
    }
}

export interface IDocHistoryByDocIdDto {
    documentId: string | undefined;
    userId: string | undefined;
    ipAddress: string | undefined;
    location: string | undefined;
    locatonAddress: string | undefined;
    deviceOS: string | undefined;
    deviceName: string | undefined;
    action: number | undefined;
    creationTime: moment.Moment | undefined;
}

export class DocumentParticipantDto implements IDocumentParticipantDto {
    typePassword: number;
    participantName: string | undefined;
    participantEmail: string | undefined;
    participantId: string | undefined;
    participantMobile: string | undefined;
    role: number;
    priority: number;
    password: string | undefined;
    phoneNumber: string | undefined;
    jobPosition: string | undefined;
    level: number;
    typeIdentifyEkyc: number;
    infoIdentifyEkyc: string | undefined;

    constructor(data?: IDocumentParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typePassword = _data["typePassword"];
            this.participantName = _data["participantName"];
            this.participantEmail = _data["participantEmail"];
            this.participantId = _data["participantId"];
            this.participantMobile = _data["participantMobile"];
            this.role = _data["role"];
            this.priority = _data["priority"];
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            this.jobPosition = _data["jobPosition"];
            this.level = _data["level"];
            this.typeIdentifyEkyc = _data["typeIdentifyEkyc"];
            this.infoIdentifyEkyc = _data["infoIdentifyEkyc"];
        }
    }

    static fromJS(data: any): DocumentParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typePassword"] = this.typePassword;
        data["participantName"] = this.participantName;
        data["participantEmail"] = this.participantEmail;
        data["participantId"] = this.participantId;
        data["participantMobile"] = this.participantMobile;
        data["role"] = this.role;
        data["priority"] = this.priority;
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        data["jobPosition"] = this.jobPosition;
        data["level"] = this.level;
        data["typeIdentifyEkyc"] = this.typeIdentifyEkyc;
        data["infoIdentifyEkyc"] = this.infoIdentifyEkyc;
        return data;
    }

    clone(): DocumentParticipantDto {
        const json = this.toJSON();
        let result = new DocumentParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentParticipantDto {
    typePassword: number;
    participantName: string | undefined;
    participantEmail: string | undefined;
    participantId: string | undefined;
    participantMobile: string | undefined;
    role: number;
    priority: number;
    password: string | undefined;
    phoneNumber: string | undefined;
    jobPosition: string | undefined;
    level: number;
    typeIdentifyEkyc: number;
    infoIdentifyEkyc: string | undefined;
}

export class DpdDistributionItemDto implements IDpdDistributionItemDto {
    bucket: string | undefined;
    amount: number;
    transactionCount: number;

    constructor(data?: IDpdDistributionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bucket = _data["bucket"];
            this.amount = _data["amount"];
            this.transactionCount = _data["transactionCount"];
        }
    }

    static fromJS(data: any): DpdDistributionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DpdDistributionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bucket"] = this.bucket;
        data["amount"] = this.amount;
        data["transactionCount"] = this.transactionCount;
        return data;
    }

    clone(): DpdDistributionItemDto {
        const json = this.toJSON();
        let result = new DpdDistributionItemDto();
        result.init(json);
        return result;
    }
}

export interface IDpdDistributionItemDto {
    bucket: string | undefined;
    amount: number;
    transactionCount: number;
}

export class EditOrderDetailDto implements IEditOrderDetailDto {
    id: number | undefined;
    leaseTermCode: number;
    price: number;
    prepayPrice: number;
    storeCode: string;

    constructor(data?: IEditOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.price = _data["price"];
            this.prepayPrice = _data["prepayPrice"];
            this.storeCode = _data["storeCode"];
        }
    }

    static fromJS(data: any): EditOrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditOrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leaseTermCode"] = this.leaseTermCode;
        data["price"] = this.price;
        data["prepayPrice"] = this.prepayPrice;
        data["storeCode"] = this.storeCode;
        return data;
    }

    clone(): EditOrderDetailDto {
        const json = this.toJSON();
        let result = new EditOrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IEditOrderDetailDto {
    id: number | undefined;
    leaseTermCode: number;
    price: number;
    prepayPrice: number;
    storeCode: string;
}

export class EditTransactionDto implements IEditTransactionDto {
    id: number;
    fromDate: moment.Moment;
    amounToBePaid: number;

    constructor(data?: IEditTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.amounToBePaid = _data["amounToBePaid"];
        }
    }

    static fromJS(data: any): EditTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["amounToBePaid"] = this.amounToBePaid;
        return data;
    }

    clone(): EditTransactionDto {
        const json = this.toJSON();
        let result = new EditTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IEditTransactionDto {
    id: number;
    fromDate: moment.Moment;
    amounToBePaid: number;
}

export enum EnumDataTypeCallBack {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _5 = 5,
}

export class FileInfoMisaDto implements IFileInfoMisaDto {
    fileId: string | undefined;
    objectId: string | undefined;
    listPositionSignFlow: any | undefined;

    constructor(data?: IFileInfoMisaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.objectId = _data["objectId"];
            this.listPositionSignFlow = _data["listPositionSignFlow"];
        }
    }

    static fromJS(data: any): FileInfoMisaDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileInfoMisaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["objectId"] = this.objectId;
        data["listPositionSignFlow"] = this.listPositionSignFlow;
        return data;
    }

    clone(): FileInfoMisaDto {
        const json = this.toJSON();
        let result = new FileInfoMisaDto();
        result.init(json);
        return result;
    }
}

export interface IFileInfoMisaDto {
    fileId: string | undefined;
    objectId: string | undefined;
    listPositionSignFlow: any | undefined;
}

export class FileManager implements IFileManager {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    path: string;
    name: string;
    extension: string;
    subsystem: string;
    fileType: string | undefined;

    constructor(data?: IFileManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.path = _data["path"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.subsystem = _data["subsystem"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): FileManager {
        data = typeof data === 'object' ? data : {};
        let result = new FileManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["path"] = this.path;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["subsystem"] = this.subsystem;
        data["fileType"] = this.fileType;
        return data;
    }

    clone(): FileManager {
        const json = this.toJSON();
        let result = new FileManager();
        result.init(json);
        return result;
    }
}

export interface IFileManager {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    path: string;
    name: string;
    extension: string;
    subsystem: string;
    fileType: string | undefined;
}

export class FileManagerDto implements IFileManagerDto {
    id: number;
    path: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    fileType: string | undefined;

    constructor(data?: IFileManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.path = _data["path"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.fileType = _data["fileType"];
        }
    }

    static fromJS(data: any): FileManagerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["path"] = this.path;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["fileType"] = this.fileType;
        return data;
    }

    clone(): FileManagerDto {
        const json = this.toJSON();
        let result = new FileManagerDto();
        result.init(json);
        return result;
    }
}

export interface IFileManagerDto {
    id: number;
    path: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    fileType: string | undefined;
}

export class FinalSettlementOrderDto implements IFinalSettlementOrderDto {
    id: number;
    code: string | undefined;
    productName: string | undefined;
    pathImage: string | undefined;
    totalPrincipal: number;
    totalInterest: number;
    penaltyFee: number;
    totalAmount: number;
    listFileFinalSettlement: FileManagerDto[] | undefined;

    constructor(data?: IFinalSettlementOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.productName = _data["productName"];
            this.pathImage = _data["pathImage"];
            this.totalPrincipal = _data["totalPrincipal"];
            this.totalInterest = _data["totalInterest"];
            this.penaltyFee = _data["penaltyFee"];
            this.totalAmount = _data["totalAmount"];
            if (Array.isArray(_data["listFileFinalSettlement"])) {
                this.listFileFinalSettlement = [] as any;
                for (let item of _data["listFileFinalSettlement"])
                    this.listFileFinalSettlement.push(FileManagerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinalSettlementOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinalSettlementOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["productName"] = this.productName;
        data["pathImage"] = this.pathImage;
        data["totalPrincipal"] = this.totalPrincipal;
        data["totalInterest"] = this.totalInterest;
        data["penaltyFee"] = this.penaltyFee;
        data["totalAmount"] = this.totalAmount;
        if (Array.isArray(this.listFileFinalSettlement)) {
            data["listFileFinalSettlement"] = [];
            for (let item of this.listFileFinalSettlement)
                data["listFileFinalSettlement"].push(item.toJSON());
        }
        return data;
    }

    clone(): FinalSettlementOrderDto {
        const json = this.toJSON();
        let result = new FinalSettlementOrderDto();
        result.init(json);
        return result;
    }
}

export interface IFinalSettlementOrderDto {
    id: number;
    code: string | undefined;
    productName: string | undefined;
    pathImage: string | undefined;
    totalPrincipal: number;
    totalInterest: number;
    penaltyFee: number;
    totalAmount: number;
    listFileFinalSettlement: FileManagerDto[] | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetOrdersByInvestorAndStatusRequestDto implements IGetOrdersByInvestorAndStatusRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    statusInvestor: string | undefined;

    constructor(data?: IGetOrdersByInvestorAndStatusRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.statusInvestor = _data["statusInvestor"];
        }
    }

    static fromJS(data: any): GetOrdersByInvestorAndStatusRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersByInvestorAndStatusRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["statusInvestor"] = this.statusInvestor;
        return data;
    }

    clone(): GetOrdersByInvestorAndStatusRequestDto {
        const json = this.toJSON();
        let result = new GetOrdersByInvestorAndStatusRequestDto();
        result.init(json);
        return result;
    }
}

export interface IGetOrdersByInvestorAndStatusRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    statusInvestor: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetStoreFeeRequestDto implements IGetStoreFeeRequestDto {
    agencyId: number | undefined;
    code: string | undefined;

    constructor(data?: IGetStoreFeeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agencyId = _data["agencyId"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): GetStoreFeeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStoreFeeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agencyId"] = this.agencyId;
        data["code"] = this.code;
        return data;
    }

    clone(): GetStoreFeeRequestDto {
        const json = this.toJSON();
        let result = new GetStoreFeeRequestDto();
        result.init(json);
        return result;
    }
}

export interface IGetStoreFeeRequestDto {
    agencyId: number | undefined;
    code: string | undefined;
}

export class GetWalletHistoryInput implements IGetWalletHistoryInput {
    userId: number;
    action: string | undefined;
    search: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IGetWalletHistoryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.action = _data["action"];
            this.search = _data["search"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetWalletHistoryInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetWalletHistoryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["action"] = this.action;
        data["search"] = this.search;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): GetWalletHistoryInput {
        const json = this.toJSON();
        let result = new GetWalletHistoryInput();
        result.init(json);
        return result;
    }
}

export interface IGetWalletHistoryInput {
    userId: number;
    action: string | undefined;
    search: string | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class HistoryOrderDto implements IHistoryOrderDto {
    id: number;
    action: string | undefined;
    note: string | undefined;
    orderId: number;
    orderCode: string | undefined;
    transactionId: number | undefined;
    personId: number;
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    fullName: string | undefined;

    constructor(data?: IHistoryOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.note = _data["note"];
            this.orderId = _data["orderId"];
            this.orderCode = _data["orderCode"];
            this.transactionId = _data["transactionId"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): HistoryOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["note"] = this.note;
        data["orderId"] = this.orderId;
        data["orderCode"] = this.orderCode;
        data["transactionId"] = this.transactionId;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): HistoryOrderDto {
        const json = this.toJSON();
        let result = new HistoryOrderDto();
        result.init(json);
        return result;
    }
}

export interface IHistoryOrderDto {
    id: number;
    action: string | undefined;
    note: string | undefined;
    orderId: number;
    orderCode: string | undefined;
    transactionId: number | undefined;
    personId: number;
    name: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    fullName: string | undefined;
}

export class HistoryOrderDtoPagedResultDto implements IHistoryOrderDtoPagedResultDto {
    items: HistoryOrderDto[] | undefined;
    totalCount: number;

    constructor(data?: IHistoryOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HistoryOrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HistoryOrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryOrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HistoryOrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HistoryOrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHistoryOrderDtoPagedResultDto {
    items: HistoryOrderDto[] | undefined;
    totalCount: number;
}

export class HistoyOrderRequestModel implements IHistoyOrderRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    orderId: number | undefined;

    constructor(data?: IHistoyOrderRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): HistoyOrderRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new HistoyOrderRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): HistoyOrderRequestModel {
        const json = this.toJSON();
        let result = new HistoyOrderRequestModel();
        result.init(json);
        return result;
    }
}

export interface IHistoyOrderRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    orderId: number | undefined;
}

export class IPhoneProductData implements IIPhoneProductData {
    iphone11: IPhoneVariant[] | undefined;
    iphone11Pro: IPhoneVariant[] | undefined;
    iphone11ProMax: IPhoneVariant[] | undefined;
    iphone12: IPhoneVariant[] | undefined;
    iphone12Mini: IPhoneVariant[] | undefined;
    iphone12Pro: IPhoneVariant[] | undefined;
    iphone12Max: IPhoneVariant[] | undefined;
    iphone13: IPhoneVariant[] | undefined;
    iphone13Mini: IPhoneVariant[] | undefined;
    iphone13Pro: IPhoneVariant[] | undefined;
    iphone13ProMax: IPhoneVariant[] | undefined;
    iphone14: IPhoneVariant[] | undefined;
    iphone14Plus: IPhoneVariant[] | undefined;
    iphone14Pro: IPhoneVariant[] | undefined;
    iphone14ProMax: IPhoneVariant[] | undefined;
    iphone15: IPhoneVariant[] | undefined;
    iphone15Plus: IPhoneVariant[] | undefined;
    iphone15Pro: IPhoneVariant[] | undefined;
    iphone15ProMax: IPhoneVariant[] | undefined;
    iPhone16: IPhoneVariant[] | undefined;
    iphone16Plus: IPhoneVariant[] | undefined;
    iphone16Pro: IPhoneVariant[] | undefined;
    iphone16ProMax: IPhoneVariant[] | undefined;
    iphone17: IPhoneVariant[] | undefined;
    iphone17Air: IPhoneVariant[] | undefined;
    iphone17Pro: IPhoneVariant[] | undefined;
    iphone17ProMax: IPhoneVariant[] | undefined;

    constructor(data?: IIPhoneProductData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["iphone11"])) {
                this.iphone11 = [] as any;
                for (let item of _data["iphone11"])
                    this.iphone11.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone11Pro"])) {
                this.iphone11Pro = [] as any;
                for (let item of _data["iphone11Pro"])
                    this.iphone11Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone11ProMax"])) {
                this.iphone11ProMax = [] as any;
                for (let item of _data["iphone11ProMax"])
                    this.iphone11ProMax.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone12"])) {
                this.iphone12 = [] as any;
                for (let item of _data["iphone12"])
                    this.iphone12.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone12Mini"])) {
                this.iphone12Mini = [] as any;
                for (let item of _data["iphone12Mini"])
                    this.iphone12Mini.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone12Pro"])) {
                this.iphone12Pro = [] as any;
                for (let item of _data["iphone12Pro"])
                    this.iphone12Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone12Max"])) {
                this.iphone12Max = [] as any;
                for (let item of _data["iphone12Max"])
                    this.iphone12Max.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone13"])) {
                this.iphone13 = [] as any;
                for (let item of _data["iphone13"])
                    this.iphone13.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone13Mini"])) {
                this.iphone13Mini = [] as any;
                for (let item of _data["iphone13Mini"])
                    this.iphone13Mini.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone13Pro"])) {
                this.iphone13Pro = [] as any;
                for (let item of _data["iphone13Pro"])
                    this.iphone13Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone13ProMax"])) {
                this.iphone13ProMax = [] as any;
                for (let item of _data["iphone13ProMax"])
                    this.iphone13ProMax.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone14"])) {
                this.iphone14 = [] as any;
                for (let item of _data["iphone14"])
                    this.iphone14.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone14Plus"])) {
                this.iphone14Plus = [] as any;
                for (let item of _data["iphone14Plus"])
                    this.iphone14Plus.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone14Pro"])) {
                this.iphone14Pro = [] as any;
                for (let item of _data["iphone14Pro"])
                    this.iphone14Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone14ProMax"])) {
                this.iphone14ProMax = [] as any;
                for (let item of _data["iphone14ProMax"])
                    this.iphone14ProMax.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone15"])) {
                this.iphone15 = [] as any;
                for (let item of _data["iphone15"])
                    this.iphone15.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone15Plus"])) {
                this.iphone15Plus = [] as any;
                for (let item of _data["iphone15Plus"])
                    this.iphone15Plus.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone15Pro"])) {
                this.iphone15Pro = [] as any;
                for (let item of _data["iphone15Pro"])
                    this.iphone15Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone15ProMax"])) {
                this.iphone15ProMax = [] as any;
                for (let item of _data["iphone15ProMax"])
                    this.iphone15ProMax.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iPhone16"])) {
                this.iPhone16 = [] as any;
                for (let item of _data["iPhone16"])
                    this.iPhone16.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone16Plus"])) {
                this.iphone16Plus = [] as any;
                for (let item of _data["iphone16Plus"])
                    this.iphone16Plus.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone16Pro"])) {
                this.iphone16Pro = [] as any;
                for (let item of _data["iphone16Pro"])
                    this.iphone16Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone16ProMax"])) {
                this.iphone16ProMax = [] as any;
                for (let item of _data["iphone16ProMax"])
                    this.iphone16ProMax.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone17"])) {
                this.iphone17 = [] as any;
                for (let item of _data["iphone17"])
                    this.iphone17.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone17Air"])) {
                this.iphone17Air = [] as any;
                for (let item of _data["iphone17Air"])
                    this.iphone17Air.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone17Pro"])) {
                this.iphone17Pro = [] as any;
                for (let item of _data["iphone17Pro"])
                    this.iphone17Pro.push(IPhoneVariant.fromJS(item));
            }
            if (Array.isArray(_data["iphone17ProMax"])) {
                this.iphone17ProMax = [] as any;
                for (let item of _data["iphone17ProMax"])
                    this.iphone17ProMax.push(IPhoneVariant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IPhoneProductData {
        data = typeof data === 'object' ? data : {};
        let result = new IPhoneProductData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.iphone11)) {
            data["iphone11"] = [];
            for (let item of this.iphone11)
                data["iphone11"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone11Pro)) {
            data["iphone11Pro"] = [];
            for (let item of this.iphone11Pro)
                data["iphone11Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone11ProMax)) {
            data["iphone11ProMax"] = [];
            for (let item of this.iphone11ProMax)
                data["iphone11ProMax"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone12)) {
            data["iphone12"] = [];
            for (let item of this.iphone12)
                data["iphone12"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone12Mini)) {
            data["iphone12Mini"] = [];
            for (let item of this.iphone12Mini)
                data["iphone12Mini"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone12Pro)) {
            data["iphone12Pro"] = [];
            for (let item of this.iphone12Pro)
                data["iphone12Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone12Max)) {
            data["iphone12Max"] = [];
            for (let item of this.iphone12Max)
                data["iphone12Max"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone13)) {
            data["iphone13"] = [];
            for (let item of this.iphone13)
                data["iphone13"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone13Mini)) {
            data["iphone13Mini"] = [];
            for (let item of this.iphone13Mini)
                data["iphone13Mini"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone13Pro)) {
            data["iphone13Pro"] = [];
            for (let item of this.iphone13Pro)
                data["iphone13Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone13ProMax)) {
            data["iphone13ProMax"] = [];
            for (let item of this.iphone13ProMax)
                data["iphone13ProMax"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone14)) {
            data["iphone14"] = [];
            for (let item of this.iphone14)
                data["iphone14"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone14Plus)) {
            data["iphone14Plus"] = [];
            for (let item of this.iphone14Plus)
                data["iphone14Plus"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone14Pro)) {
            data["iphone14Pro"] = [];
            for (let item of this.iphone14Pro)
                data["iphone14Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone14ProMax)) {
            data["iphone14ProMax"] = [];
            for (let item of this.iphone14ProMax)
                data["iphone14ProMax"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone15)) {
            data["iphone15"] = [];
            for (let item of this.iphone15)
                data["iphone15"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone15Plus)) {
            data["iphone15Plus"] = [];
            for (let item of this.iphone15Plus)
                data["iphone15Plus"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone15Pro)) {
            data["iphone15Pro"] = [];
            for (let item of this.iphone15Pro)
                data["iphone15Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone15ProMax)) {
            data["iphone15ProMax"] = [];
            for (let item of this.iphone15ProMax)
                data["iphone15ProMax"].push(item.toJSON());
        }
        if (Array.isArray(this.iPhone16)) {
            data["iPhone16"] = [];
            for (let item of this.iPhone16)
                data["iPhone16"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone16Plus)) {
            data["iphone16Plus"] = [];
            for (let item of this.iphone16Plus)
                data["iphone16Plus"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone16Pro)) {
            data["iphone16Pro"] = [];
            for (let item of this.iphone16Pro)
                data["iphone16Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone16ProMax)) {
            data["iphone16ProMax"] = [];
            for (let item of this.iphone16ProMax)
                data["iphone16ProMax"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone17)) {
            data["iphone17"] = [];
            for (let item of this.iphone17)
                data["iphone17"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone17Air)) {
            data["iphone17Air"] = [];
            for (let item of this.iphone17Air)
                data["iphone17Air"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone17Pro)) {
            data["iphone17Pro"] = [];
            for (let item of this.iphone17Pro)
                data["iphone17Pro"].push(item.toJSON());
        }
        if (Array.isArray(this.iphone17ProMax)) {
            data["iphone17ProMax"] = [];
            for (let item of this.iphone17ProMax)
                data["iphone17ProMax"].push(item.toJSON());
        }
        return data;
    }

    clone(): IPhoneProductData {
        const json = this.toJSON();
        let result = new IPhoneProductData();
        result.init(json);
        return result;
    }
}

export interface IIPhoneProductData {
    iphone11: IPhoneVariant[] | undefined;
    iphone11Pro: IPhoneVariant[] | undefined;
    iphone11ProMax: IPhoneVariant[] | undefined;
    iphone12: IPhoneVariant[] | undefined;
    iphone12Mini: IPhoneVariant[] | undefined;
    iphone12Pro: IPhoneVariant[] | undefined;
    iphone12Max: IPhoneVariant[] | undefined;
    iphone13: IPhoneVariant[] | undefined;
    iphone13Mini: IPhoneVariant[] | undefined;
    iphone13Pro: IPhoneVariant[] | undefined;
    iphone13ProMax: IPhoneVariant[] | undefined;
    iphone14: IPhoneVariant[] | undefined;
    iphone14Plus: IPhoneVariant[] | undefined;
    iphone14Pro: IPhoneVariant[] | undefined;
    iphone14ProMax: IPhoneVariant[] | undefined;
    iphone15: IPhoneVariant[] | undefined;
    iphone15Plus: IPhoneVariant[] | undefined;
    iphone15Pro: IPhoneVariant[] | undefined;
    iphone15ProMax: IPhoneVariant[] | undefined;
    iPhone16: IPhoneVariant[] | undefined;
    iphone16Plus: IPhoneVariant[] | undefined;
    iphone16Pro: IPhoneVariant[] | undefined;
    iphone16ProMax: IPhoneVariant[] | undefined;
    iphone17: IPhoneVariant[] | undefined;
    iphone17Air: IPhoneVariant[] | undefined;
    iphone17Pro: IPhoneVariant[] | undefined;
    iphone17ProMax: IPhoneVariant[] | undefined;
}

export class IPhoneVariant implements IIPhoneVariant {
    pathImage: string | undefined;
    capacityCode: string | undefined;
    colorCode: string | undefined;
    leaseTermCode: string | undefined;
    prepayPrice: number;
    price: number;

    constructor(data?: IIPhoneVariant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pathImage = _data["pathImage"];
            this.capacityCode = _data["capacityCode"];
            this.colorCode = _data["colorCode"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.prepayPrice = _data["prepayPrice"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): IPhoneVariant {
        data = typeof data === 'object' ? data : {};
        let result = new IPhoneVariant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pathImage"] = this.pathImage;
        data["capacityCode"] = this.capacityCode;
        data["colorCode"] = this.colorCode;
        data["leaseTermCode"] = this.leaseTermCode;
        data["prepayPrice"] = this.prepayPrice;
        data["price"] = this.price;
        return data;
    }

    clone(): IPhoneVariant {
        const json = this.toJSON();
        let result = new IPhoneVariant();
        result.init(json);
        return result;
    }
}

export interface IIPhoneVariant {
    pathImage: string | undefined;
    capacityCode: string | undefined;
    colorCode: string | undefined;
    leaseTermCode: string | undefined;
    prepayPrice: number;
    price: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class InvestorActionFieldChangeDto implements IInvestorActionFieldChangeDto {
    field: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;

    constructor(data?: IInvestorActionFieldChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): InvestorActionFieldChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorActionFieldChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }

    clone(): InvestorActionFieldChangeDto {
        const json = this.toJSON();
        let result = new InvestorActionFieldChangeDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorActionFieldChangeDto {
    field: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;
}

export class InvestorActionLogDto implements IInvestorActionLogDto {
    id: number;
    action: string | undefined;
    investorId: number | undefined;
    operatorUserId: number | undefined;
    operatorUserName: string | undefined;
    operatorPhoneNumber: string | undefined;
    affectedUserId: number | undefined;
    affectedUserName: string | undefined;
    affectedPhoneNumber: string | undefined;
    note: string | undefined;
    creationTime: moment.Moment;
    changes: InvestorActionFieldChangeDto[] | undefined;

    constructor(data?: IInvestorActionLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.investorId = _data["investorId"];
            this.operatorUserId = _data["operatorUserId"];
            this.operatorUserName = _data["operatorUserName"];
            this.operatorPhoneNumber = _data["operatorPhoneNumber"];
            this.affectedUserId = _data["affectedUserId"];
            this.affectedUserName = _data["affectedUserName"];
            this.affectedPhoneNumber = _data["affectedPhoneNumber"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["changes"])) {
                this.changes = [] as any;
                for (let item of _data["changes"])
                    this.changes.push(InvestorActionFieldChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestorActionLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorActionLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["investorId"] = this.investorId;
        data["operatorUserId"] = this.operatorUserId;
        data["operatorUserName"] = this.operatorUserName;
        data["operatorPhoneNumber"] = this.operatorPhoneNumber;
        data["affectedUserId"] = this.affectedUserId;
        data["affectedUserName"] = this.affectedUserName;
        data["affectedPhoneNumber"] = this.affectedPhoneNumber;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.changes)) {
            data["changes"] = [];
            for (let item of this.changes)
                data["changes"].push(item.toJSON());
        }
        return data;
    }

    clone(): InvestorActionLogDto {
        const json = this.toJSON();
        let result = new InvestorActionLogDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorActionLogDto {
    id: number;
    action: string | undefined;
    investorId: number | undefined;
    operatorUserId: number | undefined;
    operatorUserName: string | undefined;
    operatorPhoneNumber: string | undefined;
    affectedUserId: number | undefined;
    affectedUserName: string | undefined;
    affectedPhoneNumber: string | undefined;
    note: string | undefined;
    creationTime: moment.Moment;
    changes: InvestorActionFieldChangeDto[] | undefined;
}

export class InvestorActionLogDtoPagedResultDto implements IInvestorActionLogDtoPagedResultDto {
    items: InvestorActionLogDto[] | undefined;
    totalCount: number;

    constructor(data?: IInvestorActionLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvestorActionLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvestorActionLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorActionLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvestorActionLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InvestorActionLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorActionLogDtoPagedResultDto {
    items: InvestorActionLogDto[] | undefined;
    totalCount: number;
}

export class InvestorActionLogRequestDto implements IInvestorActionLogRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    investorId: number | undefined;
    affectedUserId: number | undefined;

    constructor(data?: IInvestorActionLogRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.investorId = _data["investorId"];
            this.affectedUserId = _data["affectedUserId"];
        }
    }

    static fromJS(data: any): InvestorActionLogRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorActionLogRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["investorId"] = this.investorId;
        data["affectedUserId"] = this.affectedUserId;
        return data;
    }

    clone(): InvestorActionLogRequestDto {
        const json = this.toJSON();
        let result = new InvestorActionLogRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorActionLogRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    investorId: number | undefined;
    affectedUserId: number | undefined;
}

export class InvestorDetailRequestDto implements IInvestorDetailRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    investorId: number | undefined;

    constructor(data?: IInvestorDetailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.investorId = _data["investorId"];
        }
    }

    static fromJS(data: any): InvestorDetailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDetailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["investorId"] = this.investorId;
        return data;
    }

    clone(): InvestorDetailRequestDto {
        const json = this.toJSON();
        let result = new InvestorDetailRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorDetailRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    investorId: number | undefined;
}

export class InvestorDetailTransactionDto implements IInvestorDetailTransactionDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    amounToBePaid: number;
    transactionStatus: string | undefined;
    methodPayment: string | undefined;
    interestInvestor: number;
    interestSystem: number;
    interestSale: number;

    constructor(data?: IInvestorDetailTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.amounToBePaid = _data["amounToBePaid"];
            this.transactionStatus = _data["transactionStatus"];
            this.methodPayment = _data["methodPayment"];
            this.interestInvestor = _data["interestInvestor"];
            this.interestSystem = _data["interestSystem"];
            this.interestSale = _data["interestSale"];
        }
    }

    static fromJS(data: any): InvestorDetailTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDetailTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["amounToBePaid"] = this.amounToBePaid;
        data["transactionStatus"] = this.transactionStatus;
        data["methodPayment"] = this.methodPayment;
        data["interestInvestor"] = this.interestInvestor;
        data["interestSystem"] = this.interestSystem;
        data["interestSale"] = this.interestSale;
        return data;
    }

    clone(): InvestorDetailTransactionDto {
        const json = this.toJSON();
        let result = new InvestorDetailTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorDetailTransactionDto {
    fromDate: moment.Moment;
    toDate: moment.Moment;
    amounToBePaid: number;
    transactionStatus: string | undefined;
    methodPayment: string | undefined;
    interestInvestor: number;
    interestSystem: number;
    interestSale: number;
}

export class InvestorDetailTransactionRequestDto implements IInvestorDetailTransactionRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    orderId: number | undefined;
    investorId: number | undefined;
    transactionId: number | undefined;

    constructor(data?: IInvestorDetailTransactionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.orderId = _data["orderId"];
            this.investorId = _data["investorId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): InvestorDetailTransactionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDetailTransactionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["orderId"] = this.orderId;
        data["investorId"] = this.investorId;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): InvestorDetailTransactionRequestDto {
        const json = this.toJSON();
        let result = new InvestorDetailTransactionRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorDetailTransactionRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    orderId: number | undefined;
    investorId: number | undefined;
    transactionId: number | undefined;
}

export class InvestorDto implements IInvestorDto {
    id: number | undefined;
    userId: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    monney: number;
    isActive: boolean;
    investorProfit: number | undefined;
    systemProfit: number | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    saleProfit: number | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    countOrder: number;
    countInterestInvestor: number;
    countInterestSystem: number;
    countInterestSale: number;

    constructor(data?: IInvestorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.monney = _data["monney"];
            this.isActive = _data["isActive"];
            this.investorProfit = _data["investorProfit"];
            this.systemProfit = _data["systemProfit"];
            this.saleId = _data["saleId"];
            this.saleName = _data["saleName"];
            this.saleProfit = _data["saleProfit"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
            this.countOrder = _data["countOrder"];
            this.countInterestInvestor = _data["countInterestInvestor"];
            this.countInterestSystem = _data["countInterestSystem"];
            this.countInterestSale = _data["countInterestSale"];
        }
    }

    static fromJS(data: any): InvestorDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["monney"] = this.monney;
        data["isActive"] = this.isActive;
        data["investorProfit"] = this.investorProfit;
        data["systemProfit"] = this.systemProfit;
        data["saleId"] = this.saleId;
        data["saleName"] = this.saleName;
        data["saleProfit"] = this.saleProfit;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        data["countOrder"] = this.countOrder;
        data["countInterestInvestor"] = this.countInterestInvestor;
        data["countInterestSystem"] = this.countInterestSystem;
        data["countInterestSale"] = this.countInterestSale;
        return data;
    }

    clone(): InvestorDto {
        const json = this.toJSON();
        let result = new InvestorDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorDto {
    id: number | undefined;
    userId: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    monney: number;
    isActive: boolean;
    investorProfit: number | undefined;
    systemProfit: number | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    saleProfit: number | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    countOrder: number;
    countInterestInvestor: number;
    countInterestSystem: number;
    countInterestSale: number;
}

export class InvestorDtoPagedResultDto implements IInvestorDtoPagedResultDto {
    items: InvestorDto[] | undefined;
    totalCount: number;

    constructor(data?: IInvestorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvestorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvestorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvestorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InvestorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorDtoPagedResultDto {
    items: InvestorDto[] | undefined;
    totalCount: number;
}

export class InvestorHistoryDto implements IInvestorHistoryDto {
    id: number;
    orderId: number;
    transactionId: number;
    saleId: number | undefined;
    principalInvestor: number | undefined;
    interestInvestor: number | undefined;
    interestSystem: number | undefined;
    interestSale: number | undefined;

    constructor(data?: IInvestorHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
            this.saleId = _data["saleId"];
            this.principalInvestor = _data["principalInvestor"];
            this.interestInvestor = _data["interestInvestor"];
            this.interestSystem = _data["interestSystem"];
            this.interestSale = _data["interestSale"];
        }
    }

    static fromJS(data: any): InvestorHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        data["saleId"] = this.saleId;
        data["principalInvestor"] = this.principalInvestor;
        data["interestInvestor"] = this.interestInvestor;
        data["interestSystem"] = this.interestSystem;
        data["interestSale"] = this.interestSale;
        return data;
    }

    clone(): InvestorHistoryDto {
        const json = this.toJSON();
        let result = new InvestorHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorHistoryDto {
    id: number;
    orderId: number;
    transactionId: number;
    saleId: number | undefined;
    principalInvestor: number | undefined;
    interestInvestor: number | undefined;
    interestSystem: number | undefined;
    interestSale: number | undefined;
}

export class InvestorHistoryDtoPagedResultDto implements IInvestorHistoryDtoPagedResultDto {
    items: InvestorHistoryDto[] | undefined;
    totalCount: number;

    constructor(data?: IInvestorHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InvestorHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InvestorHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InvestorHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InvestorHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorHistoryDtoPagedResultDto {
    items: InvestorHistoryDto[] | undefined;
    totalCount: number;
}

export class InvestorHistoryRequestDto implements IInvestorHistoryRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;

    constructor(data?: IInvestorHistoryRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): InvestorHistoryRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorHistoryRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        return data;
    }

    clone(): InvestorHistoryRequestDto {
        const json = this.toJSON();
        let result = new InvestorHistoryRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorHistoryRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
}

export class InvestorRequestDto implements IInvestorRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    investorId: number | undefined;
    saleId: number | undefined;

    constructor(data?: IInvestorRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.investorId = _data["investorId"];
            this.saleId = _data["saleId"];
        }
    }

    static fromJS(data: any): InvestorRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["investorId"] = this.investorId;
        data["saleId"] = this.saleId;
        return data;
    }

    clone(): InvestorRequestDto {
        const json = this.toJSON();
        let result = new InvestorRequestDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    investorId: number | undefined;
    saleId: number | undefined;
}

export class InvestorSumaryDto implements IInvestorSumaryDto {
    coutOrderInvestoring: number;
    countOrderInvestored: number;
    countOrderWatingApproved: number;
    countMoney: number;

    constructor(data?: IInvestorSumaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coutOrderInvestoring = _data["coutOrderInvestoring"];
            this.countOrderInvestored = _data["countOrderInvestored"];
            this.countOrderWatingApproved = _data["countOrderWatingApproved"];
            this.countMoney = _data["countMoney"];
        }
    }

    static fromJS(data: any): InvestorSumaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorSumaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coutOrderInvestoring"] = this.coutOrderInvestoring;
        data["countOrderInvestored"] = this.countOrderInvestored;
        data["countOrderWatingApproved"] = this.countOrderWatingApproved;
        data["countMoney"] = this.countMoney;
        return data;
    }

    clone(): InvestorSumaryDto {
        const json = this.toJSON();
        let result = new InvestorSumaryDto();
        result.init(json);
        return result;
    }
}

export interface IInvestorSumaryDto {
    coutOrderInvestoring: number;
    countOrderInvestored: number;
    countOrderWatingApproved: number;
    countMoney: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class MachineConditionDto implements IMachineConditionDto {
    id: number;
    code: string | undefined;
    name: string | undefined;

    constructor(data?: IMachineConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MachineConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }

    clone(): MachineConditionDto {
        const json = this.toJSON();
        let result = new MachineConditionDto();
        result.init(json);
        return result;
    }
}

export interface IMachineConditionDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
}

export class MachineConditionDtoPagedResultDto implements IMachineConditionDtoPagedResultDto {
    items: MachineConditionDto[] | undefined;
    totalCount: number;

    constructor(data?: IMachineConditionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MachineConditionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MachineConditionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineConditionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MachineConditionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MachineConditionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMachineConditionDtoPagedResultDto {
    items: MachineConditionDto[] | undefined;
    totalCount: number;
}

export class ManagerAgencyDto implements IManagerAgencyDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    ownerName: string | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    countMoneyAgency: number | undefined;
    countMoneySystem: number | undefined;
    countMoneySale: number | undefined;
    countMoneyStore: number | undefined;
    listStore: StoreAgencyInfoDto[] | undefined;
    isExpanded: boolean;

    constructor(data?: IManagerAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.saleId = _data["saleId"];
            this.saleName = _data["saleName"];
            this.managerId = _data["managerId"];
            this.managerName = _data["managerName"];
            this.countMoneyAgency = _data["countMoneyAgency"];
            this.countMoneySystem = _data["countMoneySystem"];
            this.countMoneySale = _data["countMoneySale"];
            this.countMoneyStore = _data["countMoneyStore"];
            if (Array.isArray(_data["listStore"])) {
                this.listStore = [] as any;
                for (let item of _data["listStore"])
                    this.listStore.push(StoreAgencyInfoDto.fromJS(item));
            }
            this.isExpanded = _data["isExpanded"];
        }
    }

    static fromJS(data: any): ManagerAgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagerAgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["saleId"] = this.saleId;
        data["saleName"] = this.saleName;
        data["managerId"] = this.managerId;
        data["managerName"] = this.managerName;
        data["countMoneyAgency"] = this.countMoneyAgency;
        data["countMoneySystem"] = this.countMoneySystem;
        data["countMoneySale"] = this.countMoneySale;
        data["countMoneyStore"] = this.countMoneyStore;
        if (Array.isArray(this.listStore)) {
            data["listStore"] = [];
            for (let item of this.listStore)
                data["listStore"].push(item.toJSON());
        }
        data["isExpanded"] = this.isExpanded;
        return data;
    }

    clone(): ManagerAgencyDto {
        const json = this.toJSON();
        let result = new ManagerAgencyDto();
        result.init(json);
        return result;
    }
}

export interface IManagerAgencyDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    ownerId: number | undefined;
    ownerName: string | undefined;
    saleId: number | undefined;
    saleName: string | undefined;
    managerId: number | undefined;
    managerName: string | undefined;
    countMoneyAgency: number | undefined;
    countMoneySystem: number | undefined;
    countMoneySale: number | undefined;
    countMoneyStore: number | undefined;
    listStore: StoreAgencyInfoDto[] | undefined;
    isExpanded: boolean;
}

export class ManagerAgencyDtoPagedResultDto implements IManagerAgencyDtoPagedResultDto {
    items: ManagerAgencyDto[] | undefined;
    totalCount: number;

    constructor(data?: IManagerAgencyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ManagerAgencyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ManagerAgencyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagerAgencyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ManagerAgencyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ManagerAgencyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IManagerAgencyDtoPagedResultDto {
    items: ManagerAgencyDto[] | undefined;
    totalCount: number;
}

export class ManagerAgencyRequestDto implements IManagerAgencyRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    ownerId: number | undefined;
    saleId: number | undefined;
    storeId: number | undefined;

    constructor(data?: IManagerAgencyRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.ownerId = _data["ownerId"];
            this.saleId = _data["saleId"];
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): ManagerAgencyRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagerAgencyRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["ownerId"] = this.ownerId;
        data["saleId"] = this.saleId;
        data["storeId"] = this.storeId;
        return data;
    }

    clone(): ManagerAgencyRequestDto {
        const json = this.toJSON();
        let result = new ManagerAgencyRequestDto();
        result.init(json);
        return result;
    }
}

export interface IManagerAgencyRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    ownerId: number | undefined;
    saleId: number | undefined;
    storeId: number | undefined;
}

export class MetricDto implements IMetricDto {
    value: number;
    previousValue: number;
    change: number;
    changePercent: number | undefined;

    constructor(data?: IMetricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.previousValue = _data["previousValue"];
            this.change = _data["change"];
            this.changePercent = _data["changePercent"];
        }
    }

    static fromJS(data: any): MetricDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["previousValue"] = this.previousValue;
        data["change"] = this.change;
        data["changePercent"] = this.changePercent;
        return data;
    }

    clone(): MetricDto {
        const json = this.toJSON();
        let result = new MetricDto();
        result.init(json);
        return result;
    }
}

export interface IMetricDto {
    value: number;
    previousValue: number;
    change: number;
    changePercent: number | undefined;
}

export class MoneyMetricDto implements IMoneyMetricDto {
    value: number;
    previousValue: number;
    change: number;
    changePercent: number | undefined;

    constructor(data?: IMoneyMetricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.previousValue = _data["previousValue"];
            this.change = _data["change"];
            this.changePercent = _data["changePercent"];
        }
    }

    static fromJS(data: any): MoneyMetricDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoneyMetricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["previousValue"] = this.previousValue;
        data["change"] = this.change;
        data["changePercent"] = this.changePercent;
        return data;
    }

    clone(): MoneyMetricDto {
        const json = this.toJSON();
        let result = new MoneyMetricDto();
        result.init(json);
        return result;
    }
}

export interface IMoneyMetricDto {
    value: number;
    previousValue: number;
    change: number;
    changePercent: number | undefined;
}

export class Order implements IOrder {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    count: number;
    price: number;
    userId: number | undefined;
    fullName: string;
    phoneNumber: string;
    email: string | undefined;
    issuingAuthority: string | undefined;
    dateIssued: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
    address: string | undefined;
    note: string | undefined;
    orderStatus: string | undefined;
    fileContractId: string | undefined;
    documentId: string | undefined;
    linkSignContract: string | undefined;
    staffOrderStatus: string | undefined;
    staffTimeUpdateStatus: moment.Moment | undefined;
    staffNote: string | undefined;
    reason: string | undefined;
    staffReason: string | undefined;
    storeCode: string | undefined;
    fileCCCDId: string | undefined;
    cccd: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
    fileInfoDeviceId: string | undefined;
    fileInfoHandOverId: string | undefined;
    fileSeriId: string | undefined;
    fileImeiId: string | undefined;
    noteAdmin: string | undefined;
    fileNoteAdminId: string | undefined;
    investorId: number | undefined;
    statusInvestor: string | undefined;
    productStoreDetailCode: string;
    productStoreCode: string;
    monthlyInterestRate: number;
    detailPrice: string | undefined;
    orderDetailStatus: string | undefined;
    productName: string | undefined;
    leaseTermCode: number | undefined;
    prepayPrice: number | undefined;
    filePaymentId: string | undefined;
    fileVideoId: string | undefined;
    processedById: number | undefined;
    fileFinalSettlementId: string | undefined;
    finalSettlementPenaltyFee: number | undefined;
    finalSettlementAmount: number | undefined;
    paymentApplicationFeeTarget: string | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateIssued = _data["dateIssued"] ? moment(_data["dateIssued"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.note = _data["note"];
            this.orderStatus = _data["orderStatus"];
            this.fileContractId = _data["fileContractId"];
            this.documentId = _data["documentId"];
            this.linkSignContract = _data["linkSignContract"];
            this.staffOrderStatus = _data["staffOrderStatus"];
            this.staffTimeUpdateStatus = _data["staffTimeUpdateStatus"] ? moment(_data["staffTimeUpdateStatus"].toString()) : <any>undefined;
            this.staffNote = _data["staffNote"];
            this.reason = _data["reason"];
            this.staffReason = _data["staffReason"];
            this.storeCode = _data["storeCode"];
            this.fileCCCDId = _data["fileCCCDId"];
            this.cccd = _data["cccd"];
            this.seri = _data["seri"];
            this.imei = _data["imei"];
            this.fileInfoDeviceId = _data["fileInfoDeviceId"];
            this.fileInfoHandOverId = _data["fileInfoHandOverId"];
            this.fileSeriId = _data["fileSeriId"];
            this.fileImeiId = _data["fileImeiId"];
            this.noteAdmin = _data["noteAdmin"];
            this.fileNoteAdminId = _data["fileNoteAdminId"];
            this.investorId = _data["investorId"];
            this.statusInvestor = _data["statusInvestor"];
            this.productStoreDetailCode = _data["productStoreDetailCode"];
            this.productStoreCode = _data["productStoreCode"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.detailPrice = _data["detailPrice"];
            this.orderDetailStatus = _data["orderDetailStatus"];
            this.productName = _data["productName"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.prepayPrice = _data["prepayPrice"];
            this.filePaymentId = _data["filePaymentId"];
            this.fileVideoId = _data["fileVideoId"];
            this.processedById = _data["processedById"];
            this.fileFinalSettlementId = _data["fileFinalSettlementId"];
            this.finalSettlementPenaltyFee = _data["finalSettlementPenaltyFee"];
            this.finalSettlementAmount = _data["finalSettlementAmount"];
            this.paymentApplicationFeeTarget = _data["paymentApplicationFeeTarget"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["count"] = this.count;
        data["price"] = this.price;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateIssued"] = this.dateIssued ? this.dateIssued.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["note"] = this.note;
        data["orderStatus"] = this.orderStatus;
        data["fileContractId"] = this.fileContractId;
        data["documentId"] = this.documentId;
        data["linkSignContract"] = this.linkSignContract;
        data["staffOrderStatus"] = this.staffOrderStatus;
        data["staffTimeUpdateStatus"] = this.staffTimeUpdateStatus ? this.staffTimeUpdateStatus.toISOString() : <any>undefined;
        data["staffNote"] = this.staffNote;
        data["reason"] = this.reason;
        data["staffReason"] = this.staffReason;
        data["storeCode"] = this.storeCode;
        data["fileCCCDId"] = this.fileCCCDId;
        data["cccd"] = this.cccd;
        data["seri"] = this.seri;
        data["imei"] = this.imei;
        data["fileInfoDeviceId"] = this.fileInfoDeviceId;
        data["fileInfoHandOverId"] = this.fileInfoHandOverId;
        data["fileSeriId"] = this.fileSeriId;
        data["fileImeiId"] = this.fileImeiId;
        data["noteAdmin"] = this.noteAdmin;
        data["fileNoteAdminId"] = this.fileNoteAdminId;
        data["investorId"] = this.investorId;
        data["statusInvestor"] = this.statusInvestor;
        data["productStoreDetailCode"] = this.productStoreDetailCode;
        data["productStoreCode"] = this.productStoreCode;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["detailPrice"] = this.detailPrice;
        data["orderDetailStatus"] = this.orderDetailStatus;
        data["productName"] = this.productName;
        data["leaseTermCode"] = this.leaseTermCode;
        data["prepayPrice"] = this.prepayPrice;
        data["filePaymentId"] = this.filePaymentId;
        data["fileVideoId"] = this.fileVideoId;
        data["processedById"] = this.processedById;
        data["fileFinalSettlementId"] = this.fileFinalSettlementId;
        data["finalSettlementPenaltyFee"] = this.finalSettlementPenaltyFee;
        data["finalSettlementAmount"] = this.finalSettlementAmount;
        data["paymentApplicationFeeTarget"] = this.paymentApplicationFeeTarget;
        return data;
    }

    clone(): Order {
        const json = this.toJSON();
        let result = new Order();
        result.init(json);
        return result;
    }
}

export interface IOrder {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    count: number;
    price: number;
    userId: number | undefined;
    fullName: string;
    phoneNumber: string;
    email: string | undefined;
    issuingAuthority: string | undefined;
    dateIssued: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
    address: string | undefined;
    note: string | undefined;
    orderStatus: string | undefined;
    fileContractId: string | undefined;
    documentId: string | undefined;
    linkSignContract: string | undefined;
    staffOrderStatus: string | undefined;
    staffTimeUpdateStatus: moment.Moment | undefined;
    staffNote: string | undefined;
    reason: string | undefined;
    staffReason: string | undefined;
    storeCode: string | undefined;
    fileCCCDId: string | undefined;
    cccd: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
    fileInfoDeviceId: string | undefined;
    fileInfoHandOverId: string | undefined;
    fileSeriId: string | undefined;
    fileImeiId: string | undefined;
    noteAdmin: string | undefined;
    fileNoteAdminId: string | undefined;
    investorId: number | undefined;
    statusInvestor: string | undefined;
    productStoreDetailCode: string;
    productStoreCode: string;
    monthlyInterestRate: number;
    detailPrice: string | undefined;
    orderDetailStatus: string | undefined;
    productName: string | undefined;
    leaseTermCode: number | undefined;
    prepayPrice: number | undefined;
    filePaymentId: string | undefined;
    fileVideoId: string | undefined;
    processedById: number | undefined;
    fileFinalSettlementId: string | undefined;
    finalSettlementPenaltyFee: number | undefined;
    finalSettlementAmount: number | undefined;
    paymentApplicationFeeTarget: string | undefined;
}

export class OrderDetailDto implements IOrderDetailDto {
    id: number | undefined;
    orderId: number | undefined;
    productStoreDetailCode: string | undefined;
    productStoreCode: string | undefined;
    productName: string | undefined;
    storeName: string | undefined;
    count: number;
    price: number;
    detailPrice: string | undefined;
    pathImage: string | undefined;
    isExpanded: boolean;
    leaseTermCode: number | undefined;
    prepayPrice: number | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    capacityCode: string | undefined;
    storeCode: string | undefined;
    staffOrderStatus: string | undefined;

    constructor(data?: IOrderDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.productStoreDetailCode = _data["productStoreDetailCode"];
            this.productStoreCode = _data["productStoreCode"];
            this.productName = _data["productName"];
            this.storeName = _data["storeName"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.detailPrice = _data["detailPrice"];
            this.pathImage = _data["pathImage"];
            this.isExpanded = _data["isExpanded"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.prepayPrice = _data["prepayPrice"];
            this.colorCode = _data["colorCode"];
            this.machineConditionCode = _data["machineConditionCode"];
            this.capacityCode = _data["capacityCode"];
            this.storeCode = _data["storeCode"];
            this.staffOrderStatus = _data["staffOrderStatus"];
        }
    }

    static fromJS(data: any): OrderDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["productStoreDetailCode"] = this.productStoreDetailCode;
        data["productStoreCode"] = this.productStoreCode;
        data["productName"] = this.productName;
        data["storeName"] = this.storeName;
        data["count"] = this.count;
        data["price"] = this.price;
        data["detailPrice"] = this.detailPrice;
        data["pathImage"] = this.pathImage;
        data["isExpanded"] = this.isExpanded;
        data["leaseTermCode"] = this.leaseTermCode;
        data["prepayPrice"] = this.prepayPrice;
        data["colorCode"] = this.colorCode;
        data["machineConditionCode"] = this.machineConditionCode;
        data["capacityCode"] = this.capacityCode;
        data["storeCode"] = this.storeCode;
        data["staffOrderStatus"] = this.staffOrderStatus;
        return data;
    }

    clone(): OrderDetailDto {
        const json = this.toJSON();
        let result = new OrderDetailDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDto {
    id: number | undefined;
    orderId: number | undefined;
    productStoreDetailCode: string | undefined;
    productStoreCode: string | undefined;
    productName: string | undefined;
    storeName: string | undefined;
    count: number;
    price: number;
    detailPrice: string | undefined;
    pathImage: string | undefined;
    isExpanded: boolean;
    leaseTermCode: number | undefined;
    prepayPrice: number | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    capacityCode: string | undefined;
    storeCode: string | undefined;
    staffOrderStatus: string | undefined;
}

export class OrderDetailDtoPagedResultDto implements IOrderDetailDtoPagedResultDto {
    items: OrderDetailDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrderDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderDetailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailDtoPagedResultDto {
    items: OrderDetailDto[] | undefined;
    totalCount: number;
}

export class OrderDetailRequestModel implements IOrderDetailRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    orderId: number | undefined;

    constructor(data?: IOrderDetailRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): OrderDetailRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): OrderDetailRequestModel {
        const json = this.toJSON();
        let result = new OrderDetailRequestModel();
        result.init(json);
        return result;
    }
}

export interface IOrderDetailRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    orderId: number | undefined;
}

export class OrderDto implements IOrderDto {
    id: number | undefined;
    code: string | undefined;
    count: number;
    price: number;
    personId: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    note: string | undefined;
    orderStatus: string | undefined;
    staffOrderStatus: string | undefined;
    staffNote: string | undefined;
    isExpanded: boolean;
    storeCode: string | undefined;
    storeName: string | undefined;
    listFileContractId: number[] | undefined;
    listFileContract: FileManagerDto[] | undefined;
    staffTimeUpdateStatus: moment.Moment | undefined;
    listFileCCCDId: number[] | undefined;
    listFileCCCD: FileManagerDto[] | undefined;
    listFileInfoDeviceId: number[] | undefined;
    listFileInfoDevice: FileManagerDto[] | undefined;
    listFileInfoHandOverId: number[] | undefined;
    listFileInfoHandOver: FileManagerDto[] | undefined;
    cccd: string | undefined;
    creationTime: moment.Moment;
    imei: string | undefined;
    seri: string | undefined;
    staffReason: string | undefined;
    reason: string | undefined;
    listFileSeriId: number[] | undefined;
    listFileSeri: FileManagerDto[] | undefined;
    listFileImeiId: number[] | undefined;
    listFileImei: FileManagerDto[] | undefined;
    listPersonRelative: PersonRelativeDto[] | undefined;
    noteAdmin: string | undefined;
    listFileNoteAdminId: number[] | undefined;
    listFileNoteAdmin: FileManagerDto[] | undefined;
    linkSignContract: string | undefined;
    investorId: number | undefined;
    investor: InvestorDto;
    pathImage: string | undefined;
    productStoreDetailCode: string | undefined;
    productStoreCode: string | undefined;
    productName: string | undefined;
    leaseTermCode: number | undefined;
    prepayPrice: number | undefined;
    listPaymentId: number[] | undefined;
    listPayment: FileManagerDto[] | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    capacityCode: string | undefined;
    listVideoId: number[] | undefined;
    listVideo: FileManagerDto[] | undefined;
    processedById: number | undefined;
    processedByName: string | undefined;
    statusInvestor: string | undefined;
    investmentStatus: string | undefined;
    listFileFinalSettlementId: number[] | undefined;
    listFileFinalSettlement: FileManagerDto[] | undefined;
    finalSettlementPenaltyFee: number | undefined;
    finalSettlementAmount: number | undefined;
    paymentApplicationFeeTarget: string | undefined;
    finalSettlementTotalAmount: number | undefined;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.count = _data["count"];
            this.price = _data["price"];
            this.personId = _data["personId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.note = _data["note"];
            this.orderStatus = _data["orderStatus"];
            this.staffOrderStatus = _data["staffOrderStatus"];
            this.staffNote = _data["staffNote"];
            this.isExpanded = _data["isExpanded"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
            if (Array.isArray(_data["listFileContractId"])) {
                this.listFileContractId = [] as any;
                for (let item of _data["listFileContractId"])
                    this.listFileContractId.push(item);
            }
            if (Array.isArray(_data["listFileContract"])) {
                this.listFileContract = [] as any;
                for (let item of _data["listFileContract"])
                    this.listFileContract.push(FileManagerDto.fromJS(item));
            }
            this.staffTimeUpdateStatus = _data["staffTimeUpdateStatus"] ? moment(_data["staffTimeUpdateStatus"].toString()) : <any>undefined;
            if (Array.isArray(_data["listFileCCCDId"])) {
                this.listFileCCCDId = [] as any;
                for (let item of _data["listFileCCCDId"])
                    this.listFileCCCDId.push(item);
            }
            if (Array.isArray(_data["listFileCCCD"])) {
                this.listFileCCCD = [] as any;
                for (let item of _data["listFileCCCD"])
                    this.listFileCCCD.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileInfoDeviceId"])) {
                this.listFileInfoDeviceId = [] as any;
                for (let item of _data["listFileInfoDeviceId"])
                    this.listFileInfoDeviceId.push(item);
            }
            if (Array.isArray(_data["listFileInfoDevice"])) {
                this.listFileInfoDevice = [] as any;
                for (let item of _data["listFileInfoDevice"])
                    this.listFileInfoDevice.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileInfoHandOverId"])) {
                this.listFileInfoHandOverId = [] as any;
                for (let item of _data["listFileInfoHandOverId"])
                    this.listFileInfoHandOverId.push(item);
            }
            if (Array.isArray(_data["listFileInfoHandOver"])) {
                this.listFileInfoHandOver = [] as any;
                for (let item of _data["listFileInfoHandOver"])
                    this.listFileInfoHandOver.push(FileManagerDto.fromJS(item));
            }
            this.cccd = _data["cccd"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.imei = _data["imei"];
            this.seri = _data["seri"];
            this.staffReason = _data["staffReason"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["listFileSeriId"])) {
                this.listFileSeriId = [] as any;
                for (let item of _data["listFileSeriId"])
                    this.listFileSeriId.push(item);
            }
            if (Array.isArray(_data["listFileSeri"])) {
                this.listFileSeri = [] as any;
                for (let item of _data["listFileSeri"])
                    this.listFileSeri.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileImeiId"])) {
                this.listFileImeiId = [] as any;
                for (let item of _data["listFileImeiId"])
                    this.listFileImeiId.push(item);
            }
            if (Array.isArray(_data["listFileImei"])) {
                this.listFileImei = [] as any;
                for (let item of _data["listFileImei"])
                    this.listFileImei.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listPersonRelative"])) {
                this.listPersonRelative = [] as any;
                for (let item of _data["listPersonRelative"])
                    this.listPersonRelative.push(PersonRelativeDto.fromJS(item));
            }
            this.noteAdmin = _data["noteAdmin"];
            if (Array.isArray(_data["listFileNoteAdminId"])) {
                this.listFileNoteAdminId = [] as any;
                for (let item of _data["listFileNoteAdminId"])
                    this.listFileNoteAdminId.push(item);
            }
            if (Array.isArray(_data["listFileNoteAdmin"])) {
                this.listFileNoteAdmin = [] as any;
                for (let item of _data["listFileNoteAdmin"])
                    this.listFileNoteAdmin.push(FileManagerDto.fromJS(item));
            }
            this.linkSignContract = _data["linkSignContract"];
            this.investorId = _data["investorId"];
            this.investor = _data["investor"] ? InvestorDto.fromJS(_data["investor"]) : <any>undefined;
            this.pathImage = _data["pathImage"];
            this.productStoreDetailCode = _data["productStoreDetailCode"];
            this.productStoreCode = _data["productStoreCode"];
            this.productName = _data["productName"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.prepayPrice = _data["prepayPrice"];
            if (Array.isArray(_data["listPaymentId"])) {
                this.listPaymentId = [] as any;
                for (let item of _data["listPaymentId"])
                    this.listPaymentId.push(item);
            }
            if (Array.isArray(_data["listPayment"])) {
                this.listPayment = [] as any;
                for (let item of _data["listPayment"])
                    this.listPayment.push(FileManagerDto.fromJS(item));
            }
            this.colorCode = _data["colorCode"];
            this.machineConditionCode = _data["machineConditionCode"];
            this.capacityCode = _data["capacityCode"];
            if (Array.isArray(_data["listVideoId"])) {
                this.listVideoId = [] as any;
                for (let item of _data["listVideoId"])
                    this.listVideoId.push(item);
            }
            if (Array.isArray(_data["listVideo"])) {
                this.listVideo = [] as any;
                for (let item of _data["listVideo"])
                    this.listVideo.push(FileManagerDto.fromJS(item));
            }
            this.processedById = _data["processedById"];
            this.processedByName = _data["processedByName"];
            this.statusInvestor = _data["statusInvestor"];
            this.investmentStatus = _data["investmentStatus"];
            if (Array.isArray(_data["listFileFinalSettlementId"])) {
                this.listFileFinalSettlementId = [] as any;
                for (let item of _data["listFileFinalSettlementId"])
                    this.listFileFinalSettlementId.push(item);
            }
            if (Array.isArray(_data["listFileFinalSettlement"])) {
                this.listFileFinalSettlement = [] as any;
                for (let item of _data["listFileFinalSettlement"])
                    this.listFileFinalSettlement.push(FileManagerDto.fromJS(item));
            }
            this.finalSettlementPenaltyFee = _data["finalSettlementPenaltyFee"];
            this.finalSettlementAmount = _data["finalSettlementAmount"];
            this.paymentApplicationFeeTarget = _data["paymentApplicationFeeTarget"];
            this.finalSettlementTotalAmount = _data["finalSettlementTotalAmount"];
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["count"] = this.count;
        data["price"] = this.price;
        data["personId"] = this.personId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["address"] = this.address;
        data["note"] = this.note;
        data["orderStatus"] = this.orderStatus;
        data["staffOrderStatus"] = this.staffOrderStatus;
        data["staffNote"] = this.staffNote;
        data["isExpanded"] = this.isExpanded;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        if (Array.isArray(this.listFileContractId)) {
            data["listFileContractId"] = [];
            for (let item of this.listFileContractId)
                data["listFileContractId"].push(item);
        }
        if (Array.isArray(this.listFileContract)) {
            data["listFileContract"] = [];
            for (let item of this.listFileContract)
                data["listFileContract"].push(item.toJSON());
        }
        data["staffTimeUpdateStatus"] = this.staffTimeUpdateStatus ? this.staffTimeUpdateStatus.toISOString() : <any>undefined;
        if (Array.isArray(this.listFileCCCDId)) {
            data["listFileCCCDId"] = [];
            for (let item of this.listFileCCCDId)
                data["listFileCCCDId"].push(item);
        }
        if (Array.isArray(this.listFileCCCD)) {
            data["listFileCCCD"] = [];
            for (let item of this.listFileCCCD)
                data["listFileCCCD"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileInfoDeviceId)) {
            data["listFileInfoDeviceId"] = [];
            for (let item of this.listFileInfoDeviceId)
                data["listFileInfoDeviceId"].push(item);
        }
        if (Array.isArray(this.listFileInfoDevice)) {
            data["listFileInfoDevice"] = [];
            for (let item of this.listFileInfoDevice)
                data["listFileInfoDevice"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileInfoHandOverId)) {
            data["listFileInfoHandOverId"] = [];
            for (let item of this.listFileInfoHandOverId)
                data["listFileInfoHandOverId"].push(item);
        }
        if (Array.isArray(this.listFileInfoHandOver)) {
            data["listFileInfoHandOver"] = [];
            for (let item of this.listFileInfoHandOver)
                data["listFileInfoHandOver"].push(item.toJSON());
        }
        data["cccd"] = this.cccd;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["imei"] = this.imei;
        data["seri"] = this.seri;
        data["staffReason"] = this.staffReason;
        data["reason"] = this.reason;
        if (Array.isArray(this.listFileSeriId)) {
            data["listFileSeriId"] = [];
            for (let item of this.listFileSeriId)
                data["listFileSeriId"].push(item);
        }
        if (Array.isArray(this.listFileSeri)) {
            data["listFileSeri"] = [];
            for (let item of this.listFileSeri)
                data["listFileSeri"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileImeiId)) {
            data["listFileImeiId"] = [];
            for (let item of this.listFileImeiId)
                data["listFileImeiId"].push(item);
        }
        if (Array.isArray(this.listFileImei)) {
            data["listFileImei"] = [];
            for (let item of this.listFileImei)
                data["listFileImei"].push(item.toJSON());
        }
        if (Array.isArray(this.listPersonRelative)) {
            data["listPersonRelative"] = [];
            for (let item of this.listPersonRelative)
                data["listPersonRelative"].push(item.toJSON());
        }
        data["noteAdmin"] = this.noteAdmin;
        if (Array.isArray(this.listFileNoteAdminId)) {
            data["listFileNoteAdminId"] = [];
            for (let item of this.listFileNoteAdminId)
                data["listFileNoteAdminId"].push(item);
        }
        if (Array.isArray(this.listFileNoteAdmin)) {
            data["listFileNoteAdmin"] = [];
            for (let item of this.listFileNoteAdmin)
                data["listFileNoteAdmin"].push(item.toJSON());
        }
        data["linkSignContract"] = this.linkSignContract;
        data["investorId"] = this.investorId;
        data["investor"] = this.investor ? this.investor.toJSON() : <any>undefined;
        data["pathImage"] = this.pathImage;
        data["productStoreDetailCode"] = this.productStoreDetailCode;
        data["productStoreCode"] = this.productStoreCode;
        data["productName"] = this.productName;
        data["leaseTermCode"] = this.leaseTermCode;
        data["prepayPrice"] = this.prepayPrice;
        if (Array.isArray(this.listPaymentId)) {
            data["listPaymentId"] = [];
            for (let item of this.listPaymentId)
                data["listPaymentId"].push(item);
        }
        if (Array.isArray(this.listPayment)) {
            data["listPayment"] = [];
            for (let item of this.listPayment)
                data["listPayment"].push(item.toJSON());
        }
        data["colorCode"] = this.colorCode;
        data["machineConditionCode"] = this.machineConditionCode;
        data["capacityCode"] = this.capacityCode;
        if (Array.isArray(this.listVideoId)) {
            data["listVideoId"] = [];
            for (let item of this.listVideoId)
                data["listVideoId"].push(item);
        }
        if (Array.isArray(this.listVideo)) {
            data["listVideo"] = [];
            for (let item of this.listVideo)
                data["listVideo"].push(item.toJSON());
        }
        data["processedById"] = this.processedById;
        data["processedByName"] = this.processedByName;
        data["statusInvestor"] = this.statusInvestor;
        data["investmentStatus"] = this.investmentStatus;
        if (Array.isArray(this.listFileFinalSettlementId)) {
            data["listFileFinalSettlementId"] = [];
            for (let item of this.listFileFinalSettlementId)
                data["listFileFinalSettlementId"].push(item);
        }
        if (Array.isArray(this.listFileFinalSettlement)) {
            data["listFileFinalSettlement"] = [];
            for (let item of this.listFileFinalSettlement)
                data["listFileFinalSettlement"].push(item.toJSON());
        }
        data["finalSettlementPenaltyFee"] = this.finalSettlementPenaltyFee;
        data["finalSettlementAmount"] = this.finalSettlementAmount;
        data["paymentApplicationFeeTarget"] = this.paymentApplicationFeeTarget;
        data["finalSettlementTotalAmount"] = this.finalSettlementTotalAmount;
        return data;
    }

    clone(): OrderDto {
        const json = this.toJSON();
        let result = new OrderDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDto {
    id: number | undefined;
    code: string | undefined;
    count: number;
    price: number;
    personId: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: string | undefined;
    note: string | undefined;
    orderStatus: string | undefined;
    staffOrderStatus: string | undefined;
    staffNote: string | undefined;
    isExpanded: boolean;
    storeCode: string | undefined;
    storeName: string | undefined;
    listFileContractId: number[] | undefined;
    listFileContract: FileManagerDto[] | undefined;
    staffTimeUpdateStatus: moment.Moment | undefined;
    listFileCCCDId: number[] | undefined;
    listFileCCCD: FileManagerDto[] | undefined;
    listFileInfoDeviceId: number[] | undefined;
    listFileInfoDevice: FileManagerDto[] | undefined;
    listFileInfoHandOverId: number[] | undefined;
    listFileInfoHandOver: FileManagerDto[] | undefined;
    cccd: string | undefined;
    creationTime: moment.Moment;
    imei: string | undefined;
    seri: string | undefined;
    staffReason: string | undefined;
    reason: string | undefined;
    listFileSeriId: number[] | undefined;
    listFileSeri: FileManagerDto[] | undefined;
    listFileImeiId: number[] | undefined;
    listFileImei: FileManagerDto[] | undefined;
    listPersonRelative: PersonRelativeDto[] | undefined;
    noteAdmin: string | undefined;
    listFileNoteAdminId: number[] | undefined;
    listFileNoteAdmin: FileManagerDto[] | undefined;
    linkSignContract: string | undefined;
    investorId: number | undefined;
    investor: InvestorDto;
    pathImage: string | undefined;
    productStoreDetailCode: string | undefined;
    productStoreCode: string | undefined;
    productName: string | undefined;
    leaseTermCode: number | undefined;
    prepayPrice: number | undefined;
    listPaymentId: number[] | undefined;
    listPayment: FileManagerDto[] | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    capacityCode: string | undefined;
    listVideoId: number[] | undefined;
    listVideo: FileManagerDto[] | undefined;
    processedById: number | undefined;
    processedByName: string | undefined;
    statusInvestor: string | undefined;
    investmentStatus: string | undefined;
    listFileFinalSettlementId: number[] | undefined;
    listFileFinalSettlement: FileManagerDto[] | undefined;
    finalSettlementPenaltyFee: number | undefined;
    finalSettlementAmount: number | undefined;
    paymentApplicationFeeTarget: string | undefined;
    finalSettlementTotalAmount: number | undefined;
}

export class OrderDtoPagedResultDto implements IOrderDtoPagedResultDto {
    items: OrderDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrderDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderDtoPagedResultDto {
    items: OrderDto[] | undefined;
    totalCount: number;
}

export class OrderInvestorDto implements IOrderInvestorDto {
    id: number | undefined;
    code: string | undefined;
    productName: string | undefined;
    statusInvestor: string | undefined;
    investorId: number | undefined;
    totalCurrentInterest: number;
    profit: number;
    pathImage: string | undefined;
    productStoreDetailCode: string | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    seri: string | undefined;
    price: number;
    prepayPrice: number | undefined;

    constructor(data?: IOrderInvestorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.productName = _data["productName"];
            this.statusInvestor = _data["statusInvestor"];
            this.investorId = _data["investorId"];
            this.totalCurrentInterest = _data["totalCurrentInterest"];
            this.profit = _data["profit"];
            this.pathImage = _data["pathImage"];
            this.productStoreDetailCode = _data["productStoreDetailCode"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.seri = _data["seri"];
            this.price = _data["price"];
            this.prepayPrice = _data["prepayPrice"];
        }
    }

    static fromJS(data: any): OrderInvestorDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInvestorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["productName"] = this.productName;
        data["statusInvestor"] = this.statusInvestor;
        data["investorId"] = this.investorId;
        data["totalCurrentInterest"] = this.totalCurrentInterest;
        data["profit"] = this.profit;
        data["pathImage"] = this.pathImage;
        data["productStoreDetailCode"] = this.productStoreDetailCode;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["seri"] = this.seri;
        data["price"] = this.price;
        data["prepayPrice"] = this.prepayPrice;
        return data;
    }

    clone(): OrderInvestorDto {
        const json = this.toJSON();
        let result = new OrderInvestorDto();
        result.init(json);
        return result;
    }
}

export interface IOrderInvestorDto {
    id: number | undefined;
    code: string | undefined;
    productName: string | undefined;
    statusInvestor: string | undefined;
    investorId: number | undefined;
    totalCurrentInterest: number;
    profit: number;
    pathImage: string | undefined;
    productStoreDetailCode: string | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    seri: string | undefined;
    price: number;
    prepayPrice: number | undefined;
}

export class OrderInvestorDtoPagedResultDto implements IOrderInvestorDtoPagedResultDto {
    items: OrderInvestorDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrderInvestorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderInvestorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderInvestorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInvestorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderInvestorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderInvestorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderInvestorDtoPagedResultDto {
    items: OrderInvestorDto[] | undefined;
    totalCount: number;
}

export class OrderPaymentResponseDto implements IOrderPaymentResponseDto {
    qrCode: string | undefined;
    orderUrl: string | undefined;

    constructor(data?: IOrderPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCode = _data["qrCode"];
            this.orderUrl = _data["orderUrl"];
        }
    }

    static fromJS(data: any): OrderPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCode"] = this.qrCode;
        data["orderUrl"] = this.orderUrl;
        return data;
    }

    clone(): OrderPaymentResponseDto {
        const json = this.toJSON();
        let result = new OrderPaymentResponseDto();
        result.init(json);
        return result;
    }
}

export interface IOrderPaymentResponseDto {
    qrCode: string | undefined;
    orderUrl: string | undefined;
}

export class OrderPaymentTopPayCallbackDto implements IOrderPaymentTopPayCallbackDto {
    msg: string | undefined;
    merchant_no: string | undefined;
    amount: string | undefined;
    tran_flow: string | undefined;
    pay_serial_no: string | undefined;
    sign: string | undefined;
    fee: string | undefined;
    status: string | undefined;

    constructor(data?: IOrderPaymentTopPayCallbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msg = _data["msg"];
            this.merchant_no = _data["merchant_no"];
            this.amount = _data["amount"];
            this.tran_flow = _data["tran_flow"];
            this.pay_serial_no = _data["pay_serial_no"];
            this.sign = _data["sign"];
            this.fee = _data["fee"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OrderPaymentTopPayCallbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPaymentTopPayCallbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msg"] = this.msg;
        data["merchant_no"] = this.merchant_no;
        data["amount"] = this.amount;
        data["tran_flow"] = this.tran_flow;
        data["pay_serial_no"] = this.pay_serial_no;
        data["sign"] = this.sign;
        data["fee"] = this.fee;
        data["status"] = this.status;
        return data;
    }

    clone(): OrderPaymentTopPayCallbackDto {
        const json = this.toJSON();
        let result = new OrderPaymentTopPayCallbackDto();
        result.init(json);
        return result;
    }
}

export interface IOrderPaymentTopPayCallbackDto {
    msg: string | undefined;
    merchant_no: string | undefined;
    amount: string | undefined;
    tran_flow: string | undefined;
    pay_serial_no: string | undefined;
    sign: string | undefined;
    fee: string | undefined;
    status: string | undefined;
}

export class OrderReportDto implements IOrderReportDto {
    id: number;
    depositDate: moment.Moment | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    productName: string | undefined;
    orderCode: string | undefined;
    price: number | undefined;
    prepayPrice: number | undefined;
    serviceFee: number | undefined;
    loanAmount: number | undefined;
    monthlyInterestRate: number;
    leaseTermCode: number | undefined;
    totalProfit: number;
    amountPaid: number | undefined;
    numberOfInstallmentsPaid: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    statusPayment: string | undefined;
    numberOfOverdueInstallments: number;
    totalOverdueAmount: number | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    angencyCode: string | undefined;
    agencyName: string | undefined;
    note: string | undefined;
    processedByName: string | undefined;
    capitalSponsor: string | undefined;

    constructor(data?: IOrderReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.depositDate = _data["depositDate"] ? moment(_data["depositDate"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.productName = _data["productName"];
            this.orderCode = _data["orderCode"];
            this.price = _data["price"];
            this.prepayPrice = _data["prepayPrice"];
            this.serviceFee = _data["serviceFee"];
            this.loanAmount = _data["loanAmount"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.totalProfit = _data["totalProfit"];
            this.amountPaid = _data["amountPaid"];
            this.numberOfInstallmentsPaid = _data["numberOfInstallmentsPaid"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.statusPayment = _data["statusPayment"];
            this.numberOfOverdueInstallments = _data["numberOfOverdueInstallments"];
            this.totalOverdueAmount = _data["totalOverdueAmount"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
            this.angencyCode = _data["angencyCode"];
            this.agencyName = _data["agencyName"];
            this.note = _data["note"];
            this.processedByName = _data["processedByName"];
            this.capitalSponsor = _data["capitalSponsor"];
        }
    }

    static fromJS(data: any): OrderReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["depositDate"] = this.depositDate ? this.depositDate.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["productName"] = this.productName;
        data["orderCode"] = this.orderCode;
        data["price"] = this.price;
        data["prepayPrice"] = this.prepayPrice;
        data["serviceFee"] = this.serviceFee;
        data["loanAmount"] = this.loanAmount;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["leaseTermCode"] = this.leaseTermCode;
        data["totalProfit"] = this.totalProfit;
        data["amountPaid"] = this.amountPaid;
        data["numberOfInstallmentsPaid"] = this.numberOfInstallmentsPaid;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["statusPayment"] = this.statusPayment;
        data["numberOfOverdueInstallments"] = this.numberOfOverdueInstallments;
        data["totalOverdueAmount"] = this.totalOverdueAmount;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["angencyCode"] = this.angencyCode;
        data["agencyName"] = this.agencyName;
        data["note"] = this.note;
        data["processedByName"] = this.processedByName;
        data["capitalSponsor"] = this.capitalSponsor;
        return data;
    }

    clone(): OrderReportDto {
        const json = this.toJSON();
        let result = new OrderReportDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReportDto {
    id: number;
    depositDate: moment.Moment | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    productName: string | undefined;
    orderCode: string | undefined;
    price: number | undefined;
    prepayPrice: number | undefined;
    serviceFee: number | undefined;
    loanAmount: number | undefined;
    monthlyInterestRate: number;
    leaseTermCode: number | undefined;
    totalProfit: number;
    amountPaid: number | undefined;
    numberOfInstallmentsPaid: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    statusPayment: string | undefined;
    numberOfOverdueInstallments: number;
    totalOverdueAmount: number | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    angencyCode: string | undefined;
    agencyName: string | undefined;
    note: string | undefined;
    processedByName: string | undefined;
    capitalSponsor: string | undefined;
}

export class OrderReportDtoPagedResultDto implements IOrderReportDtoPagedResultDto {
    items: OrderReportDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrderReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReportDtoPagedResultDto {
    items: OrderReportDto[] | undefined;
    totalCount: number;
}

export class OrderReportRequestDto implements IOrderReportRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    fromDepositDate: moment.Moment | undefined;
    toDepositDate: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    orderCode: string | undefined;
    leaseTermCode: number | undefined;
    transactionPaymentStatus: string | undefined;
    storeCode: string | undefined;
    agencyCode: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
    investorId: number | undefined;

    constructor(data?: IOrderReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.fromDepositDate = _data["fromDepositDate"] ? moment(_data["fromDepositDate"].toString()) : <any>undefined;
            this.toDepositDate = _data["toDepositDate"] ? moment(_data["toDepositDate"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.orderCode = _data["orderCode"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.transactionPaymentStatus = _data["transactionPaymentStatus"];
            this.storeCode = _data["storeCode"];
            this.agencyCode = _data["agencyCode"];
            this.seri = _data["seri"];
            this.imei = _data["imei"];
            this.investorId = _data["investorId"];
        }
    }

    static fromJS(data: any): OrderReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["fromDepositDate"] = this.fromDepositDate ? this.fromDepositDate.toISOString() : <any>undefined;
        data["toDepositDate"] = this.toDepositDate ? this.toDepositDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["orderCode"] = this.orderCode;
        data["leaseTermCode"] = this.leaseTermCode;
        data["transactionPaymentStatus"] = this.transactionPaymentStatus;
        data["storeCode"] = this.storeCode;
        data["agencyCode"] = this.agencyCode;
        data["seri"] = this.seri;
        data["imei"] = this.imei;
        data["investorId"] = this.investorId;
        return data;
    }

    clone(): OrderReportRequestDto {
        const json = this.toJSON();
        let result = new OrderReportRequestDto();
        result.init(json);
        return result;
    }
}

export interface IOrderReportRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    fromDepositDate: moment.Moment | undefined;
    toDepositDate: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    orderCode: string | undefined;
    leaseTermCode: number | undefined;
    transactionPaymentStatus: string | undefined;
    storeCode: string | undefined;
    agencyCode: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
    investorId: number | undefined;
}

export class OrderRequestDto implements IOrderRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    listStaffOrderStatus: string[] | undefined;
    storeCode: string | undefined;
    orderId: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    productCode: string | undefined;
    machineConditionCode: string | undefined;
    capacityCode: string | undefined;
    leaseTermCode: number | undefined;
    agencyCode: string | undefined;
    statusCode: string | undefined;
    investorId: number | undefined;
    statusInvestor: string | undefined;
    investmentStatus: string | undefined;
    isSettlement: boolean | undefined;

    constructor(data?: IOrderRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            if (Array.isArray(_data["listStaffOrderStatus"])) {
                this.listStaffOrderStatus = [] as any;
                for (let item of _data["listStaffOrderStatus"])
                    this.listStaffOrderStatus.push(item);
            }
            this.storeCode = _data["storeCode"];
            this.orderId = _data["orderId"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.productCode = _data["productCode"];
            this.machineConditionCode = _data["machineConditionCode"];
            this.capacityCode = _data["capacityCode"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.agencyCode = _data["agencyCode"];
            this.statusCode = _data["statusCode"];
            this.investorId = _data["investorId"];
            this.statusInvestor = _data["statusInvestor"];
            this.investmentStatus = _data["investmentStatus"];
            this.isSettlement = _data["isSettlement"];
        }
    }

    static fromJS(data: any): OrderRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        if (Array.isArray(this.listStaffOrderStatus)) {
            data["listStaffOrderStatus"] = [];
            for (let item of this.listStaffOrderStatus)
                data["listStaffOrderStatus"].push(item);
        }
        data["storeCode"] = this.storeCode;
        data["orderId"] = this.orderId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["machineConditionCode"] = this.machineConditionCode;
        data["capacityCode"] = this.capacityCode;
        data["leaseTermCode"] = this.leaseTermCode;
        data["agencyCode"] = this.agencyCode;
        data["statusCode"] = this.statusCode;
        data["investorId"] = this.investorId;
        data["statusInvestor"] = this.statusInvestor;
        data["investmentStatus"] = this.investmentStatus;
        data["isSettlement"] = this.isSettlement;
        return data;
    }

    clone(): OrderRequestDto {
        const json = this.toJSON();
        let result = new OrderRequestDto();
        result.init(json);
        return result;
    }
}

export interface IOrderRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    listStaffOrderStatus: string[] | undefined;
    storeCode: string | undefined;
    orderId: number | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
    productCode: string | undefined;
    machineConditionCode: string | undefined;
    capacityCode: string | undefined;
    leaseTermCode: number | undefined;
    agencyCode: string | undefined;
    statusCode: string | undefined;
    investorId: number | undefined;
    statusInvestor: string | undefined;
    investmentStatus: string | undefined;
    isSettlement: boolean | undefined;
}

export class OrderStatusDistributionItemDto implements IOrderStatusDistributionItemDto {
    status: string | undefined;
    count: number;
    percentage: number;

    constructor(data?: IOrderStatusDistributionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.count = _data["count"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): OrderStatusDistributionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusDistributionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["count"] = this.count;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): OrderStatusDistributionItemDto {
        const json = this.toJSON();
        let result = new OrderStatusDistributionItemDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStatusDistributionItemDto {
    status: string | undefined;
    count: number;
    percentage: number;
}

export class OverdueMetricsDto implements IOverdueMetricsDto {
    overdueOrders: MetricDto;
    overdueAmount: MoneyMetricDto;
    dpd1Plus: MetricDto;
    dpd7Plus: MetricDto;
    dpd30Plus: MetricDto;
    dpd90Plus: MetricDto;
    overdueOrderRate: number;
    overdueCustomerRate: number;
    billOverdueRate: number;
    dpdDistribution: DpdDistributionItemDto[] | undefined;
    dueCustomersUnpaid: MetricDto;
    dueAmountUnpaid: MoneyMetricDto;

    constructor(data?: IOverdueMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overdueOrders = _data["overdueOrders"] ? MetricDto.fromJS(_data["overdueOrders"]) : <any>undefined;
            this.overdueAmount = _data["overdueAmount"] ? MoneyMetricDto.fromJS(_data["overdueAmount"]) : <any>undefined;
            this.dpd1Plus = _data["dpd1Plus"] ? MetricDto.fromJS(_data["dpd1Plus"]) : <any>undefined;
            this.dpd7Plus = _data["dpd7Plus"] ? MetricDto.fromJS(_data["dpd7Plus"]) : <any>undefined;
            this.dpd30Plus = _data["dpd30Plus"] ? MetricDto.fromJS(_data["dpd30Plus"]) : <any>undefined;
            this.dpd90Plus = _data["dpd90Plus"] ? MetricDto.fromJS(_data["dpd90Plus"]) : <any>undefined;
            this.overdueOrderRate = _data["overdueOrderRate"];
            this.overdueCustomerRate = _data["overdueCustomerRate"];
            this.billOverdueRate = _data["billOverdueRate"];
            if (Array.isArray(_data["dpdDistribution"])) {
                this.dpdDistribution = [] as any;
                for (let item of _data["dpdDistribution"])
                    this.dpdDistribution.push(DpdDistributionItemDto.fromJS(item));
            }
            this.dueCustomersUnpaid = _data["dueCustomersUnpaid"] ? MetricDto.fromJS(_data["dueCustomersUnpaid"]) : <any>undefined;
            this.dueAmountUnpaid = _data["dueAmountUnpaid"] ? MoneyMetricDto.fromJS(_data["dueAmountUnpaid"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OverdueMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OverdueMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overdueOrders"] = this.overdueOrders ? this.overdueOrders.toJSON() : <any>undefined;
        data["overdueAmount"] = this.overdueAmount ? this.overdueAmount.toJSON() : <any>undefined;
        data["dpd1Plus"] = this.dpd1Plus ? this.dpd1Plus.toJSON() : <any>undefined;
        data["dpd7Plus"] = this.dpd7Plus ? this.dpd7Plus.toJSON() : <any>undefined;
        data["dpd30Plus"] = this.dpd30Plus ? this.dpd30Plus.toJSON() : <any>undefined;
        data["dpd90Plus"] = this.dpd90Plus ? this.dpd90Plus.toJSON() : <any>undefined;
        data["overdueOrderRate"] = this.overdueOrderRate;
        data["overdueCustomerRate"] = this.overdueCustomerRate;
        data["billOverdueRate"] = this.billOverdueRate;
        if (Array.isArray(this.dpdDistribution)) {
            data["dpdDistribution"] = [];
            for (let item of this.dpdDistribution)
                data["dpdDistribution"].push(item.toJSON());
        }
        data["dueCustomersUnpaid"] = this.dueCustomersUnpaid ? this.dueCustomersUnpaid.toJSON() : <any>undefined;
        data["dueAmountUnpaid"] = this.dueAmountUnpaid ? this.dueAmountUnpaid.toJSON() : <any>undefined;
        return data;
    }

    clone(): OverdueMetricsDto {
        const json = this.toJSON();
        let result = new OverdueMetricsDto();
        result.init(json);
        return result;
    }
}

export interface IOverdueMetricsDto {
    overdueOrders: MetricDto;
    overdueAmount: MoneyMetricDto;
    dpd1Plus: MetricDto;
    dpd7Plus: MetricDto;
    dpd30Plus: MetricDto;
    dpd90Plus: MetricDto;
    overdueOrderRate: number;
    overdueCustomerRate: number;
    billOverdueRate: number;
    dpdDistribution: DpdDistributionItemDto[] | undefined;
    dueCustomersUnpaid: MetricDto;
    dueAmountUnpaid: MoneyMetricDto;
}

export class ParticipantSignLinkDto implements IParticipantSignLinkDto {
    participantName: string | undefined;
    participantEmail: string | undefined;
    participantLink: string | undefined;

    constructor(data?: IParticipantSignLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.participantName = _data["participantName"];
            this.participantEmail = _data["participantEmail"];
            this.participantLink = _data["participantLink"];
        }
    }

    static fromJS(data: any): ParticipantSignLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantSignLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["participantName"] = this.participantName;
        data["participantEmail"] = this.participantEmail;
        data["participantLink"] = this.participantLink;
        return data;
    }

    clone(): ParticipantSignLinkDto {
        const json = this.toJSON();
        let result = new ParticipantSignLinkDto();
        result.init(json);
        return result;
    }
}

export interface IParticipantSignLinkDto {
    participantName: string | undefined;
    participantEmail: string | undefined;
    participantLink: string | undefined;
}

export class PerformanceMetricsDto implements IPerformanceMetricsDto {
    activeRentingOrders: MetricDto;
    totalCustomers: MetricDto;
    totalReceivable: MoneyMetricDto;
    totalCollected: MoneyMetricDto;
    totalUncollected: MoneyMetricDto;
    disbursedCapital: MoneyMetricDto;
    principalCollected: MoneyMetricDto;
    principalUncollected: MoneyMetricDto;
    interestCollected: MoneyMetricDto;
    interestUncollected: MoneyMetricDto;
    firstPeriodRentAmount: MoneyMetricDto;
    completedOrders: MetricDto;

    constructor(data?: IPerformanceMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeRentingOrders = _data["activeRentingOrders"] ? MetricDto.fromJS(_data["activeRentingOrders"]) : <any>undefined;
            this.totalCustomers = _data["totalCustomers"] ? MetricDto.fromJS(_data["totalCustomers"]) : <any>undefined;
            this.totalReceivable = _data["totalReceivable"] ? MoneyMetricDto.fromJS(_data["totalReceivable"]) : <any>undefined;
            this.totalCollected = _data["totalCollected"] ? MoneyMetricDto.fromJS(_data["totalCollected"]) : <any>undefined;
            this.totalUncollected = _data["totalUncollected"] ? MoneyMetricDto.fromJS(_data["totalUncollected"]) : <any>undefined;
            this.disbursedCapital = _data["disbursedCapital"] ? MoneyMetricDto.fromJS(_data["disbursedCapital"]) : <any>undefined;
            this.principalCollected = _data["principalCollected"] ? MoneyMetricDto.fromJS(_data["principalCollected"]) : <any>undefined;
            this.principalUncollected = _data["principalUncollected"] ? MoneyMetricDto.fromJS(_data["principalUncollected"]) : <any>undefined;
            this.interestCollected = _data["interestCollected"] ? MoneyMetricDto.fromJS(_data["interestCollected"]) : <any>undefined;
            this.interestUncollected = _data["interestUncollected"] ? MoneyMetricDto.fromJS(_data["interestUncollected"]) : <any>undefined;
            this.firstPeriodRentAmount = _data["firstPeriodRentAmount"] ? MoneyMetricDto.fromJS(_data["firstPeriodRentAmount"]) : <any>undefined;
            this.completedOrders = _data["completedOrders"] ? MetricDto.fromJS(_data["completedOrders"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PerformanceMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PerformanceMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeRentingOrders"] = this.activeRentingOrders ? this.activeRentingOrders.toJSON() : <any>undefined;
        data["totalCustomers"] = this.totalCustomers ? this.totalCustomers.toJSON() : <any>undefined;
        data["totalReceivable"] = this.totalReceivable ? this.totalReceivable.toJSON() : <any>undefined;
        data["totalCollected"] = this.totalCollected ? this.totalCollected.toJSON() : <any>undefined;
        data["totalUncollected"] = this.totalUncollected ? this.totalUncollected.toJSON() : <any>undefined;
        data["disbursedCapital"] = this.disbursedCapital ? this.disbursedCapital.toJSON() : <any>undefined;
        data["principalCollected"] = this.principalCollected ? this.principalCollected.toJSON() : <any>undefined;
        data["principalUncollected"] = this.principalUncollected ? this.principalUncollected.toJSON() : <any>undefined;
        data["interestCollected"] = this.interestCollected ? this.interestCollected.toJSON() : <any>undefined;
        data["interestUncollected"] = this.interestUncollected ? this.interestUncollected.toJSON() : <any>undefined;
        data["firstPeriodRentAmount"] = this.firstPeriodRentAmount ? this.firstPeriodRentAmount.toJSON() : <any>undefined;
        data["completedOrders"] = this.completedOrders ? this.completedOrders.toJSON() : <any>undefined;
        return data;
    }

    clone(): PerformanceMetricsDto {
        const json = this.toJSON();
        let result = new PerformanceMetricsDto();
        result.init(json);
        return result;
    }
}

export interface IPerformanceMetricsDto {
    activeRentingOrders: MetricDto;
    totalCustomers: MetricDto;
    totalReceivable: MoneyMetricDto;
    totalCollected: MoneyMetricDto;
    totalUncollected: MoneyMetricDto;
    disbursedCapital: MoneyMetricDto;
    principalCollected: MoneyMetricDto;
    principalUncollected: MoneyMetricDto;
    interestCollected: MoneyMetricDto;
    interestUncollected: MoneyMetricDto;
    firstPeriodRentAmount: MoneyMetricDto;
    completedOrders: MetricDto;
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PersonDto implements IPersonDto {
    id: number | undefined;
    name: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    userId: number;
    listFileId: number[] | undefined;
    fileBeforeCCCDCard: FileManagerDto;
    fileAlterCCCDCard: FileManagerDto;
    address: string | undefined;
    cccd: string | undefined;
    listPersonRelativeDto: PersonRelativeDto[] | undefined;
    issuingAuthority: string | undefined;
    dateIssued: moment.Moment | undefined;
    birthday: moment.Moment | undefined;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
            this.fileBeforeCCCDCard = _data["fileBeforeCCCDCard"] ? FileManagerDto.fromJS(_data["fileBeforeCCCDCard"]) : <any>undefined;
            this.fileAlterCCCDCard = _data["fileAlterCCCDCard"] ? FileManagerDto.fromJS(_data["fileAlterCCCDCard"]) : <any>undefined;
            this.address = _data["address"];
            this.cccd = _data["cccd"];
            if (Array.isArray(_data["listPersonRelativeDto"])) {
                this.listPersonRelativeDto = [] as any;
                for (let item of _data["listPersonRelativeDto"])
                    this.listPersonRelativeDto.push(PersonRelativeDto.fromJS(item));
            }
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateIssued = _data["dateIssued"] ? moment(_data["dateIssued"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["userId"] = this.userId;
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        data["fileBeforeCCCDCard"] = this.fileBeforeCCCDCard ? this.fileBeforeCCCDCard.toJSON() : <any>undefined;
        data["fileAlterCCCDCard"] = this.fileAlterCCCDCard ? this.fileAlterCCCDCard.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["cccd"] = this.cccd;
        if (Array.isArray(this.listPersonRelativeDto)) {
            data["listPersonRelativeDto"] = [];
            for (let item of this.listPersonRelativeDto)
                data["listPersonRelativeDto"].push(item.toJSON());
        }
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateIssued"] = this.dateIssued ? this.dateIssued.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        return data;
    }

    clone(): PersonDto {
        const json = this.toJSON();
        let result = new PersonDto();
        result.init(json);
        return result;
    }
}

export interface IPersonDto {
    id: number | undefined;
    name: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    userId: number;
    listFileId: number[] | undefined;
    fileBeforeCCCDCard: FileManagerDto;
    fileAlterCCCDCard: FileManagerDto;
    address: string | undefined;
    cccd: string | undefined;
    listPersonRelativeDto: PersonRelativeDto[] | undefined;
    issuingAuthority: string | undefined;
    dateIssued: moment.Moment | undefined;
    birthday: moment.Moment | undefined;
}

export class PersonRelativeDto implements IPersonRelativeDto {
    id: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    relationship: string | undefined;
    phoneNumberUser: string;

    constructor(data?: IPersonRelativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.relationship = _data["relationship"];
            this.phoneNumberUser = _data["phoneNumberUser"];
        }
    }

    static fromJS(data: any): PersonRelativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRelativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["relationship"] = this.relationship;
        data["phoneNumberUser"] = this.phoneNumberUser;
        return data;
    }

    clone(): PersonRelativeDto {
        const json = this.toJSON();
        let result = new PersonRelativeDto();
        result.init(json);
        return result;
    }
}

export interface IPersonRelativeDto {
    id: number | undefined;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    relationship: string | undefined;
    phoneNumberUser: string;
}

export class PersonRequestModel implements IPersonRequestModel {
    isGetFile: boolean;

    constructor(data?: IPersonRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGetFile = _data["isGetFile"];
        }
    }

    static fromJS(data: any): PersonRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGetFile"] = this.isGetFile;
        return data;
    }

    clone(): PersonRequestModel {
        const json = this.toJSON();
        let result = new PersonRequestModel();
        result.init(json);
        return result;
    }
}

export interface IPersonRequestModel {
    isGetFile: boolean;
}

export class PersonSelectDto implements IPersonSelectDto {
    userId: number;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    monney: number | undefined;

    constructor(data?: IPersonSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.monney = _data["monney"];
        }
    }

    static fromJS(data: any): PersonSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["monney"] = this.monney;
        return data;
    }

    clone(): PersonSelectDto {
        const json = this.toJSON();
        let result = new PersonSelectDto();
        result.init(json);
        return result;
    }
}

export interface IPersonSelectDto {
    userId: number;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    monney: number | undefined;
}

export class ProductDto implements IProductDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    categoryMobileCode: string | undefined;
    categoryMobileName: string | undefined;
    isActive: boolean;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.categoryMobileCode = _data["categoryMobileCode"];
            this.categoryMobileName = _data["categoryMobileName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["categoryMobileCode"] = this.categoryMobileCode;
        data["categoryMobileName"] = this.categoryMobileName;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

export interface IProductDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    categoryMobileCode: string | undefined;
    categoryMobileName: string | undefined;
    isActive: boolean;
}

export class ProductDtoPagedResultDto implements IProductDtoPagedResultDto {
    items: ProductDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductDtoPagedResultDto {
    items: ProductDto[] | undefined;
    totalCount: number;
}

export class ProductStoreDetailDto implements IProductStoreDetailDto {
    id: number;
    code: string | undefined;
    productId: number | undefined;
    productStoreId: number | undefined;
    productStoreCode: string | undefined;
    listFile: string[] | undefined;
    listFileDelete: string[] | undefined;
    pathImage: string | undefined;
    fileManager: FileManagerDto;
    capacityCode: string | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    packageCode: string | undefined;
    prepayPrice: number | undefined;
    price: number | undefined;
    count: number;
    isSelected: boolean;
    productName: string | undefined;
    productCode: string | undefined;
    storeName: string | undefined;
    storeCode: string | undefined;
    isActive: boolean;
    expanded: boolean;
    isRent: boolean;
    productStoreDto: ProductStoreDto;

    constructor(data?: IProductStoreDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.productId = _data["productId"];
            this.productStoreId = _data["productStoreId"];
            this.productStoreCode = _data["productStoreCode"];
            if (Array.isArray(_data["listFile"])) {
                this.listFile = [] as any;
                for (let item of _data["listFile"])
                    this.listFile.push(item);
            }
            if (Array.isArray(_data["listFileDelete"])) {
                this.listFileDelete = [] as any;
                for (let item of _data["listFileDelete"])
                    this.listFileDelete.push(item);
            }
            this.pathImage = _data["pathImage"];
            this.fileManager = _data["fileManager"] ? FileManagerDto.fromJS(_data["fileManager"]) : <any>undefined;
            this.capacityCode = _data["capacityCode"];
            this.colorCode = _data["colorCode"];
            this.machineConditionCode = _data["machineConditionCode"];
            this.packageCode = _data["packageCode"];
            this.prepayPrice = _data["prepayPrice"];
            this.price = _data["price"];
            this.count = _data["count"];
            this.isSelected = _data["isSelected"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.storeName = _data["storeName"];
            this.storeCode = _data["storeCode"];
            this.isActive = _data["isActive"];
            this.expanded = _data["expanded"];
            this.isRent = _data["isRent"];
            this.productStoreDto = _data["productStoreDto"] ? ProductStoreDto.fromJS(_data["productStoreDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductStoreDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStoreDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["productId"] = this.productId;
        data["productStoreId"] = this.productStoreId;
        data["productStoreCode"] = this.productStoreCode;
        if (Array.isArray(this.listFile)) {
            data["listFile"] = [];
            for (let item of this.listFile)
                data["listFile"].push(item);
        }
        if (Array.isArray(this.listFileDelete)) {
            data["listFileDelete"] = [];
            for (let item of this.listFileDelete)
                data["listFileDelete"].push(item);
        }
        data["pathImage"] = this.pathImage;
        data["fileManager"] = this.fileManager ? this.fileManager.toJSON() : <any>undefined;
        data["capacityCode"] = this.capacityCode;
        data["colorCode"] = this.colorCode;
        data["machineConditionCode"] = this.machineConditionCode;
        data["packageCode"] = this.packageCode;
        data["prepayPrice"] = this.prepayPrice;
        data["price"] = this.price;
        data["count"] = this.count;
        data["isSelected"] = this.isSelected;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["storeName"] = this.storeName;
        data["storeCode"] = this.storeCode;
        data["isActive"] = this.isActive;
        data["expanded"] = this.expanded;
        data["isRent"] = this.isRent;
        data["productStoreDto"] = this.productStoreDto ? this.productStoreDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProductStoreDetailDto {
        const json = this.toJSON();
        let result = new ProductStoreDetailDto();
        result.init(json);
        return result;
    }
}

export interface IProductStoreDetailDto {
    id: number;
    code: string | undefined;
    productId: number | undefined;
    productStoreId: number | undefined;
    productStoreCode: string | undefined;
    listFile: string[] | undefined;
    listFileDelete: string[] | undefined;
    pathImage: string | undefined;
    fileManager: FileManagerDto;
    capacityCode: string | undefined;
    colorCode: string | undefined;
    machineConditionCode: string | undefined;
    packageCode: string | undefined;
    prepayPrice: number | undefined;
    price: number | undefined;
    count: number;
    isSelected: boolean;
    productName: string | undefined;
    productCode: string | undefined;
    storeName: string | undefined;
    storeCode: string | undefined;
    isActive: boolean;
    expanded: boolean;
    isRent: boolean;
    productStoreDto: ProductStoreDto;
}

export class ProductStoreDto implements IProductStoreDto {
    id: number;
    code: string | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    pathImage: string | undefined;
    price: number | undefined;
    stars: number | undefined;
    sold: number | undefined;
    categoryMobileCode: string | undefined;
    isActive: boolean;
    listProductStoreDetailDto: ProductStoreDetailDto[] | undefined;
    expanded: boolean;
    capacityCode: string | undefined;
    colorCode: string | undefined;

    constructor(data?: IProductStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.pathImage = _data["pathImage"];
            this.price = _data["price"];
            this.stars = _data["stars"];
            this.sold = _data["sold"];
            this.categoryMobileCode = _data["categoryMobileCode"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["listProductStoreDetailDto"])) {
                this.listProductStoreDetailDto = [] as any;
                for (let item of _data["listProductStoreDetailDto"])
                    this.listProductStoreDetailDto.push(ProductStoreDetailDto.fromJS(item));
            }
            this.expanded = _data["expanded"];
            this.capacityCode = _data["capacityCode"];
            this.colorCode = _data["colorCode"];
        }
    }

    static fromJS(data: any): ProductStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["pathImage"] = this.pathImage;
        data["price"] = this.price;
        data["stars"] = this.stars;
        data["sold"] = this.sold;
        data["categoryMobileCode"] = this.categoryMobileCode;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.listProductStoreDetailDto)) {
            data["listProductStoreDetailDto"] = [];
            for (let item of this.listProductStoreDetailDto)
                data["listProductStoreDetailDto"].push(item.toJSON());
        }
        data["expanded"] = this.expanded;
        data["capacityCode"] = this.capacityCode;
        data["colorCode"] = this.colorCode;
        return data;
    }

    clone(): ProductStoreDto {
        const json = this.toJSON();
        let result = new ProductStoreDto();
        result.init(json);
        return result;
    }
}

export interface IProductStoreDto {
    id: number;
    code: string | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    pathImage: string | undefined;
    price: number | undefined;
    stars: number | undefined;
    sold: number | undefined;
    categoryMobileCode: string | undefined;
    isActive: boolean;
    listProductStoreDetailDto: ProductStoreDetailDto[] | undefined;
    expanded: boolean;
    capacityCode: string | undefined;
    colorCode: string | undefined;
}

export class ProductStoreDtoPagedResultDto implements IProductStoreDtoPagedResultDto {
    items: ProductStoreDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductStoreDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductStoreDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductStoreDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStoreDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductStoreDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductStoreDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductStoreDtoPagedResultDto {
    items: ProductStoreDto[] | undefined;
    totalCount: number;
}

export class ProductStoreRequestModel implements IProductStoreRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    categoryMobileCode: string | undefined;
    storeCode: string | undefined;

    constructor(data?: IProductStoreRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.categoryMobileCode = _data["categoryMobileCode"];
            this.storeCode = _data["storeCode"];
        }
    }

    static fromJS(data: any): ProductStoreRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStoreRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["categoryMobileCode"] = this.categoryMobileCode;
        data["storeCode"] = this.storeCode;
        return data;
    }

    clone(): ProductStoreRequestModel {
        const json = this.toJSON();
        let result = new ProductStoreRequestModel();
        result.init(json);
        return result;
    }
}

export interface IProductStoreRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    categoryMobileCode: string | undefined;
    storeCode: string | undefined;
}

export class ProductStoreWrapDto implements IProductStoreWrapDto {
    listProductStoreDetail: ProductStoreDetailDto[] | undefined;
    listCategoryMobile: CategoryMobileDto[] | undefined;
    listProductDto: ProductDto[] | undefined;

    constructor(data?: IProductStoreWrapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["listProductStoreDetail"])) {
                this.listProductStoreDetail = [] as any;
                for (let item of _data["listProductStoreDetail"])
                    this.listProductStoreDetail.push(ProductStoreDetailDto.fromJS(item));
            }
            if (Array.isArray(_data["listCategoryMobile"])) {
                this.listCategoryMobile = [] as any;
                for (let item of _data["listCategoryMobile"])
                    this.listCategoryMobile.push(CategoryMobileDto.fromJS(item));
            }
            if (Array.isArray(_data["listProductDto"])) {
                this.listProductDto = [] as any;
                for (let item of _data["listProductDto"])
                    this.listProductDto.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductStoreWrapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStoreWrapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.listProductStoreDetail)) {
            data["listProductStoreDetail"] = [];
            for (let item of this.listProductStoreDetail)
                data["listProductStoreDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.listCategoryMobile)) {
            data["listCategoryMobile"] = [];
            for (let item of this.listCategoryMobile)
                data["listCategoryMobile"].push(item.toJSON());
        }
        if (Array.isArray(this.listProductDto)) {
            data["listProductDto"] = [];
            for (let item of this.listProductDto)
                data["listProductDto"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductStoreWrapDto {
        const json = this.toJSON();
        let result = new ProductStoreWrapDto();
        result.init(json);
        return result;
    }
}

export interface IProductStoreWrapDto {
    listProductStoreDetail: ProductStoreDetailDto[] | undefined;
    listCategoryMobile: CategoryMobileDto[] | undefined;
    listProductDto: ProductDto[] | undefined;
}

export class ProvinceDto implements IProvinceDto {
    id: string | undefined;
    code: string | undefined;
    parentId: number;
    name: string | undefined;

    constructor(data?: IProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        return data;
    }

    clone(): ProvinceDto {
        const json = this.toJSON();
        let result = new ProvinceDto();
        result.init(json);
        return result;
    }
}

export interface IProvinceDto {
    id: string | undefined;
    code: string | undefined;
    parentId: number;
    name: string | undefined;
}

export class PublicFileInfo implements IPublicFileInfo {
    id: string | undefined;
    objectId: string | undefined;
    fileName: string | undefined;
    urlDownload: string | undefined;
    contentType: string | undefined;

    constructor(data?: IPublicFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectId = _data["objectId"];
            this.fileName = _data["fileName"];
            this.urlDownload = _data["urlDownload"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): PublicFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PublicFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectId"] = this.objectId;
        data["fileName"] = this.fileName;
        data["urlDownload"] = this.urlDownload;
        data["contentType"] = this.contentType;
        return data;
    }

    clone(): PublicFileInfo {
        const json = this.toJSON();
        let result = new PublicFileInfo();
        result.init(json);
        return result;
    }
}

export interface IPublicFileInfo {
    id: string | undefined;
    objectId: string | undefined;
    fileName: string | undefined;
    urlDownload: string | undefined;
    contentType: string | undefined;
}

export class PublicTemplateDocument implements IPublicTemplateDocument {
    document: TemplateDocument;
    listDocumentParticipant: DocumentParticipantDto[] | undefined;
    listDocumentHistory: DocHistoryByDocIdDto[] | undefined;
    validateResults: ValidateResult[] | undefined;
    device: DeviceParam;
    success: boolean | undefined;
    appCode: string | undefined;
    appName: string | undefined;
    documentBatchName: string | undefined;
    templateId: string | undefined;
    typeCallBack: EnumDataTypeCallBack;

    constructor(data?: IPublicTemplateDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? TemplateDocument.fromJS(_data["document"]) : <any>undefined;
            if (Array.isArray(_data["listDocumentParticipant"])) {
                this.listDocumentParticipant = [] as any;
                for (let item of _data["listDocumentParticipant"])
                    this.listDocumentParticipant.push(DocumentParticipantDto.fromJS(item));
            }
            if (Array.isArray(_data["listDocumentHistory"])) {
                this.listDocumentHistory = [] as any;
                for (let item of _data["listDocumentHistory"])
                    this.listDocumentHistory.push(DocHistoryByDocIdDto.fromJS(item));
            }
            if (Array.isArray(_data["validateResults"])) {
                this.validateResults = [] as any;
                for (let item of _data["validateResults"])
                    this.validateResults.push(ValidateResult.fromJS(item));
            }
            this.device = _data["device"] ? DeviceParam.fromJS(_data["device"]) : <any>undefined;
            this.success = _data["success"];
            this.appCode = _data["appCode"];
            this.appName = _data["appName"];
            this.documentBatchName = _data["documentBatchName"];
            this.templateId = _data["templateId"];
            this.typeCallBack = _data["typeCallBack"];
        }
    }

    static fromJS(data: any): PublicTemplateDocument {
        data = typeof data === 'object' ? data : {};
        let result = new PublicTemplateDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        if (Array.isArray(this.listDocumentParticipant)) {
            data["listDocumentParticipant"] = [];
            for (let item of this.listDocumentParticipant)
                data["listDocumentParticipant"].push(item.toJSON());
        }
        if (Array.isArray(this.listDocumentHistory)) {
            data["listDocumentHistory"] = [];
            for (let item of this.listDocumentHistory)
                data["listDocumentHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.validateResults)) {
            data["validateResults"] = [];
            for (let item of this.validateResults)
                data["validateResults"].push(item.toJSON());
        }
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["appCode"] = this.appCode;
        data["appName"] = this.appName;
        data["documentBatchName"] = this.documentBatchName;
        data["templateId"] = this.templateId;
        data["typeCallBack"] = this.typeCallBack;
        return data;
    }

    clone(): PublicTemplateDocument {
        const json = this.toJSON();
        let result = new PublicTemplateDocument();
        result.init(json);
        return result;
    }
}

export interface IPublicTemplateDocument {
    document: TemplateDocument;
    listDocumentParticipant: DocumentParticipantDto[] | undefined;
    listDocumentHistory: DocHistoryByDocIdDto[] | undefined;
    validateResults: ValidateResult[] | undefined;
    device: DeviceParam;
    success: boolean | undefined;
    appCode: string | undefined;
    appName: string | undefined;
    documentBatchName: string | undefined;
    templateId: string | undefined;
    typeCallBack: EnumDataTypeCallBack;
}

export class RegisterInput implements IRegisterInput {
    emailAddress: string | undefined;
    password: string;
    captchaResponse: string | undefined;
    phoneNumber: string;
    otp: string;
    fullName: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
            this.phoneNumber = _data["phoneNumber"];
            this.otp = _data["otp"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        data["phoneNumber"] = this.phoneNumber;
        data["otp"] = this.otp;
        data["fullName"] = this.fullName;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    emailAddress: string | undefined;
    password: string;
    captchaResponse: string | undefined;
    phoneNumber: string;
    otp: string;
    fullName: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RejectConfirmDto implements IRejectConfirmDto {
    orderId: number | undefined;
    staffReason: string | undefined;

    constructor(data?: IRejectConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.staffReason = _data["staffReason"];
        }
    }

    static fromJS(data: any): RejectConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["staffReason"] = this.staffReason;
        return data;
    }

    clone(): RejectConfirmDto {
        const json = this.toJSON();
        let result = new RejectConfirmDto();
        result.init(json);
        return result;
    }
}

export interface IRejectConfirmDto {
    orderId: number | undefined;
    staffReason: string | undefined;
}

export class ReportUserRentingDto implements IReportUserRentingDto {
    buyDate: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    cccd: string | undefined;
    address: string | undefined;

    constructor(data?: IReportUserRentingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buyDate = _data["buyDate"] ? moment(_data["buyDate"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.cccd = _data["cccd"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): ReportUserRentingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserRentingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buyDate"] = this.buyDate ? this.buyDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["cccd"] = this.cccd;
        data["address"] = this.address;
        return data;
    }

    clone(): ReportUserRentingDto {
        const json = this.toJSON();
        let result = new ReportUserRentingDto();
        result.init(json);
        return result;
    }
}

export interface IReportUserRentingDto {
    buyDate: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    cccd: string | undefined;
    address: string | undefined;
}

export class ReportUserRentingDtoPagedResultDto implements IReportUserRentingDtoPagedResultDto {
    items: ReportUserRentingDto[] | undefined;
    totalCount: number;

    constructor(data?: IReportUserRentingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReportUserRentingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReportUserRentingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserRentingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReportUserRentingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReportUserRentingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReportUserRentingDtoPagedResultDto {
    items: ReportUserRentingDto[] | undefined;
    totalCount: number;
}

export class ReportUserRentingRequestDto implements IReportUserRentingRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;

    constructor(data?: IReportUserRentingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportUserRentingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserRentingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ReportUserRentingRequestDto {
        const json = this.toJSON();
        let result = new ReportUserRentingRequestDto();
        result.init(json);
        return result;
    }
}

export interface IReportUserRentingRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
}

export class RequestForSettlementDto implements IRequestForSettlementDto {
    orderId: number | undefined;
    penaltyFee: number;
    totalAmount: number;

    constructor(data?: IRequestForSettlementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.penaltyFee = _data["penaltyFee"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): RequestForSettlementDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestForSettlementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["penaltyFee"] = this.penaltyFee;
        data["totalAmount"] = this.totalAmount;
        return data;
    }

    clone(): RequestForSettlementDto {
        const json = this.toJSON();
        let result = new RequestForSettlementDto();
        result.init(json);
        return result;
    }
}

export interface IRequestForSettlementDto {
    orderId: number | undefined;
    penaltyFee: number;
    totalAmount: number;
}

export class ResendContractDto implements IResendContractDto {
    sid: string | undefined;
    orderId: number | undefined;
    note: string | undefined;

    constructor(data?: IResendContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sid = _data["sid"];
            this.orderId = _data["orderId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ResendContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResendContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sid"] = this.sid;
        data["orderId"] = this.orderId;
        data["note"] = this.note;
        return data;
    }

    clone(): ResendContractDto {
        const json = this.toJSON();
        let result = new ResendContractDto();
        result.init(json);
        return result;
    }
}

export interface IResendContractDto {
    sid: string | undefined;
    orderId: number | undefined;
    note: string | undefined;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SaleCommissionSumaryDto implements ISaleCommissionSumaryDto {
    countAgency: number;
    countStore: number;
    commissionSale: number;

    constructor(data?: ISaleCommissionSumaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countAgency = _data["countAgency"];
            this.countStore = _data["countStore"];
            this.commissionSale = _data["commissionSale"];
        }
    }

    static fromJS(data: any): SaleCommissionSumaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleCommissionSumaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countAgency"] = this.countAgency;
        data["countStore"] = this.countStore;
        data["commissionSale"] = this.commissionSale;
        return data;
    }

    clone(): SaleCommissionSumaryDto {
        const json = this.toJSON();
        let result = new SaleCommissionSumaryDto();
        result.init(json);
        return result;
    }
}

export interface ISaleCommissionSumaryDto {
    countAgency: number;
    countStore: number;
    commissionSale: number;
}

export class SaleInvestorCommissionSumaryDto implements ISaleInvestorCommissionSumaryDto {
    countInvestor: number;
    totalInterestSale: number;

    constructor(data?: ISaleInvestorCommissionSumaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countInvestor = _data["countInvestor"];
            this.totalInterestSale = _data["totalInterestSale"];
        }
    }

    static fromJS(data: any): SaleInvestorCommissionSumaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvestorCommissionSumaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countInvestor"] = this.countInvestor;
        data["totalInterestSale"] = this.totalInterestSale;
        return data;
    }

    clone(): SaleInvestorCommissionSumaryDto {
        const json = this.toJSON();
        let result = new SaleInvestorCommissionSumaryDto();
        result.init(json);
        return result;
    }
}

export interface ISaleInvestorCommissionSumaryDto {
    countInvestor: number;
    totalInterestSale: number;
}

export class SaleInvestorHistoryDto implements ISaleInvestorHistoryDto {
    id: number;
    investorId: number;
    investorName: string | undefined;
    investorPhone: string | undefined;
    orderId: number;
    orderCode: string | undefined;
    transactionId: number;
    interestInvestor: number | undefined;
    interestSystem: number | undefined;
    interestSale: number | undefined;
    creationTime: moment.Moment;

    constructor(data?: ISaleInvestorHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.investorId = _data["investorId"];
            this.investorName = _data["investorName"];
            this.investorPhone = _data["investorPhone"];
            this.orderId = _data["orderId"];
            this.orderCode = _data["orderCode"];
            this.transactionId = _data["transactionId"];
            this.interestInvestor = _data["interestInvestor"];
            this.interestSystem = _data["interestSystem"];
            this.interestSale = _data["interestSale"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaleInvestorHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvestorHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["investorId"] = this.investorId;
        data["investorName"] = this.investorName;
        data["investorPhone"] = this.investorPhone;
        data["orderId"] = this.orderId;
        data["orderCode"] = this.orderCode;
        data["transactionId"] = this.transactionId;
        data["interestInvestor"] = this.interestInvestor;
        data["interestSystem"] = this.interestSystem;
        data["interestSale"] = this.interestSale;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): SaleInvestorHistoryDto {
        const json = this.toJSON();
        let result = new SaleInvestorHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ISaleInvestorHistoryDto {
    id: number;
    investorId: number;
    investorName: string | undefined;
    investorPhone: string | undefined;
    orderId: number;
    orderCode: string | undefined;
    transactionId: number;
    interestInvestor: number | undefined;
    interestSystem: number | undefined;
    interestSale: number | undefined;
    creationTime: moment.Moment;
}

export class SaleInvestorHistoryDtoPagedResultDto implements ISaleInvestorHistoryDtoPagedResultDto {
    items: SaleInvestorHistoryDto[] | undefined;
    totalCount: number;

    constructor(data?: ISaleInvestorHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SaleInvestorHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SaleInvestorHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInvestorHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SaleInvestorHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SaleInvestorHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISaleInvestorHistoryDtoPagedResultDto {
    items: SaleInvestorHistoryDto[] | undefined;
    totalCount: number;
}

export class SettlementProfitDto implements ISettlementProfitDto {
    investorProfit: number;
    systemProfit: number;
    saleProfit: number;

    constructor(data?: ISettlementProfitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.investorProfit = _data["investorProfit"];
            this.systemProfit = _data["systemProfit"];
            this.saleProfit = _data["saleProfit"];
        }
    }

    static fromJS(data: any): SettlementProfitDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettlementProfitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["investorProfit"] = this.investorProfit;
        data["systemProfit"] = this.systemProfit;
        data["saleProfit"] = this.saleProfit;
        return data;
    }

    clone(): SettlementProfitDto {
        const json = this.toJSON();
        let result = new SettlementProfitDto();
        result.init(json);
        return result;
    }
}

export interface ISettlementProfitDto {
    investorProfit: number;
    systemProfit: number;
    saleProfit: number;
}

export class SignFlowResultDto implements ISignFlowResultDto {
    index: number;
    isSuccess: boolean;
    fileInfos: FileInfoMisaDto[] | undefined;
    documentId: string | undefined;
    validateResult: any | undefined;
    participantSignLinks: ParticipantSignLinkDto[] | undefined;

    constructor(data?: ISignFlowResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["fileInfos"])) {
                this.fileInfos = [] as any;
                for (let item of _data["fileInfos"])
                    this.fileInfos.push(FileInfoMisaDto.fromJS(item));
            }
            this.documentId = _data["documentId"];
            this.validateResult = _data["validateResult"];
            if (Array.isArray(_data["participantSignLinks"])) {
                this.participantSignLinks = [] as any;
                for (let item of _data["participantSignLinks"])
                    this.participantSignLinks.push(ParticipantSignLinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignFlowResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignFlowResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.fileInfos)) {
            data["fileInfos"] = [];
            for (let item of this.fileInfos)
                data["fileInfos"].push(item.toJSON());
        }
        data["documentId"] = this.documentId;
        data["validateResult"] = this.validateResult;
        if (Array.isArray(this.participantSignLinks)) {
            data["participantSignLinks"] = [];
            for (let item of this.participantSignLinks)
                data["participantSignLinks"].push(item.toJSON());
        }
        return data;
    }

    clone(): SignFlowResultDto {
        const json = this.toJSON();
        let result = new SignFlowResultDto();
        result.init(json);
        return result;
    }
}

export interface ISignFlowResultDto {
    index: number;
    isSuccess: boolean;
    fileInfos: FileInfoMisaDto[] | undefined;
    documentId: string | undefined;
    validateResult: any | undefined;
    participantSignLinks: ParticipantSignLinkDto[] | undefined;
}

export class StatusOrderDto implements IStatusOrderDto {
    code: string | undefined;
    name: string | undefined;
    countOrder: string | undefined;

    constructor(data?: IStatusOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.countOrder = _data["countOrder"];
        }
    }

    static fromJS(data: any): StatusOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["countOrder"] = this.countOrder;
        return data;
    }

    clone(): StatusOrderDto {
        const json = this.toJSON();
        let result = new StatusOrderDto();
        result.init(json);
        return result;
    }
}

export interface IStatusOrderDto {
    code: string | undefined;
    name: string | undefined;
    countOrder: string | undefined;
}

export class Store implements IStore {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    provinceId: number | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    storeType: string | undefined;
    monthlyInterestRate: number | undefined;
    leaseTermCode: number;
    isActive: boolean;
    agencyCode: string | undefined;
    statusApproved: string | undefined;
    userIdCreate: number | undefined;
    ownerId: number | undefined;
    fileId: string | undefined;
    fileImageStoreId: string | undefined;
    fileImagePaymentId: string | undefined;
    fileIdentityFrontId: string | undefined;
    fileIdentityBackId: string | undefined;
    fileBusinessLicenseId: string | undefined;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    accountName: string | undefined;
    shopOwner: string | undefined;
    prepayPricePercentage: number | undefined;
    email: string | undefined;
    serviceFee: number | undefined;

    constructor(data?: IStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.provinceId = _data["provinceId"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.storeType = _data["storeType"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.isActive = _data["isActive"];
            this.agencyCode = _data["agencyCode"];
            this.statusApproved = _data["statusApproved"];
            this.userIdCreate = _data["userIdCreate"];
            this.ownerId = _data["ownerId"];
            this.fileId = _data["fileId"];
            this.fileImageStoreId = _data["fileImageStoreId"];
            this.fileImagePaymentId = _data["fileImagePaymentId"];
            this.fileIdentityFrontId = _data["fileIdentityFrontId"];
            this.fileIdentityBackId = _data["fileIdentityBackId"];
            this.fileBusinessLicenseId = _data["fileBusinessLicenseId"];
            this.bankAccount = _data["bankAccount"];
            this.bankCode = _data["bankCode"];
            this.accountName = _data["accountName"];
            this.shopOwner = _data["shopOwner"];
            this.prepayPricePercentage = _data["prepayPricePercentage"];
            this.email = _data["email"];
            this.serviceFee = _data["serviceFee"];
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["provinceId"] = this.provinceId;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["storeType"] = this.storeType;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["leaseTermCode"] = this.leaseTermCode;
        data["isActive"] = this.isActive;
        data["agencyCode"] = this.agencyCode;
        data["statusApproved"] = this.statusApproved;
        data["userIdCreate"] = this.userIdCreate;
        data["ownerId"] = this.ownerId;
        data["fileId"] = this.fileId;
        data["fileImageStoreId"] = this.fileImageStoreId;
        data["fileImagePaymentId"] = this.fileImagePaymentId;
        data["fileIdentityFrontId"] = this.fileIdentityFrontId;
        data["fileIdentityBackId"] = this.fileIdentityBackId;
        data["fileBusinessLicenseId"] = this.fileBusinessLicenseId;
        data["bankAccount"] = this.bankAccount;
        data["bankCode"] = this.bankCode;
        data["accountName"] = this.accountName;
        data["shopOwner"] = this.shopOwner;
        data["prepayPricePercentage"] = this.prepayPricePercentage;
        data["email"] = this.email;
        data["serviceFee"] = this.serviceFee;
        return data;
    }

    clone(): Store {
        const json = this.toJSON();
        let result = new Store();
        result.init(json);
        return result;
    }
}

export interface IStore {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    provinceId: number | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    storeType: string | undefined;
    monthlyInterestRate: number | undefined;
    leaseTermCode: number;
    isActive: boolean;
    agencyCode: string | undefined;
    statusApproved: string | undefined;
    userIdCreate: number | undefined;
    ownerId: number | undefined;
    fileId: string | undefined;
    fileImageStoreId: string | undefined;
    fileImagePaymentId: string | undefined;
    fileIdentityFrontId: string | undefined;
    fileIdentityBackId: string | undefined;
    fileBusinessLicenseId: string | undefined;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    accountName: string | undefined;
    shopOwner: string | undefined;
    prepayPricePercentage: number | undefined;
    email: string | undefined;
    serviceFee: number | undefined;
}

export class StoreAgencyInfoDto implements IStoreAgencyInfoDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    countMoneyAgency: number | undefined;
    countMoneySystem: number | undefined;
    countMoneySale: number | undefined;
    countMoneyStore: number | undefined;
    saleFeePercent: number | undefined;
    agencyFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;

    constructor(data?: IStoreAgencyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.countMoneyAgency = _data["countMoneyAgency"];
            this.countMoneySystem = _data["countMoneySystem"];
            this.countMoneySale = _data["countMoneySale"];
            this.countMoneyStore = _data["countMoneyStore"];
            this.saleFeePercent = _data["saleFeePercent"];
            this.agencyFeePercent = _data["agencyFeePercent"];
            this.storeFeePercent = _data["storeFeePercent"];
            this.systemFeePercent = _data["systemFeePercent"];
        }
    }

    static fromJS(data: any): StoreAgencyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreAgencyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["countMoneyAgency"] = this.countMoneyAgency;
        data["countMoneySystem"] = this.countMoneySystem;
        data["countMoneySale"] = this.countMoneySale;
        data["countMoneyStore"] = this.countMoneyStore;
        data["saleFeePercent"] = this.saleFeePercent;
        data["agencyFeePercent"] = this.agencyFeePercent;
        data["storeFeePercent"] = this.storeFeePercent;
        data["systemFeePercent"] = this.systemFeePercent;
        return data;
    }

    clone(): StoreAgencyInfoDto {
        const json = this.toJSON();
        let result = new StoreAgencyInfoDto();
        result.init(json);
        return result;
    }
}

export interface IStoreAgencyInfoDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    countMoneyAgency: number | undefined;
    countMoneySystem: number | undefined;
    countMoneySale: number | undefined;
    countMoneyStore: number | undefined;
    saleFeePercent: number | undefined;
    agencyFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;
}

export class StoreDto implements IStoreDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    address: string | undefined;
    monthlyInterestRate: number | undefined;
    leaseTermCode: number;
    isActive: boolean;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    statusApproved: string | undefined;
    listProductStore: ProductStoreDto[] | undefined;
    listFileId: number[] | undefined;
    listFile: FileManagerDto[] | undefined;
    qrCode: string | undefined;
    listFileImageStoreId: number[] | undefined;
    listFileImageStore: FileManagerDto[] | undefined;
    listFileImagePaymentId: number[] | undefined;
    listFileImagePayment: FileManagerDto[] | undefined;
    listFileIdentityFrontId: number[] | undefined;
    listFileIdentityFront: FileManagerDto[] | undefined;
    listFileIdentityBackId: number[] | undefined;
    listFileIdentityBack: FileManagerDto[] | undefined;
    listFileBusinessLicenseId: number[] | undefined;
    listFileBusinessLicense: FileManagerDto[] | undefined;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    bankName: string | undefined;
    accountName: string | undefined;
    shopOwner: string | undefined;
    ownerId: number | undefined;
    prepayPricePercentage: number | undefined;
    creationTime: moment.Moment | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    serviceFee: number | undefined;
    saleFeePercent: number | undefined;
    agencyFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;

    constructor(data?: IStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.leaseTermCode = _data["leaseTermCode"];
            this.isActive = _data["isActive"];
            this.agencyCode = _data["agencyCode"];
            this.agencyName = _data["agencyName"];
            this.statusApproved = _data["statusApproved"];
            if (Array.isArray(_data["listProductStore"])) {
                this.listProductStore = [] as any;
                for (let item of _data["listProductStore"])
                    this.listProductStore.push(ProductStoreDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
            if (Array.isArray(_data["listFile"])) {
                this.listFile = [] as any;
                for (let item of _data["listFile"])
                    this.listFile.push(FileManagerDto.fromJS(item));
            }
            this.qrCode = _data["qrCode"];
            if (Array.isArray(_data["listFileImageStoreId"])) {
                this.listFileImageStoreId = [] as any;
                for (let item of _data["listFileImageStoreId"])
                    this.listFileImageStoreId.push(item);
            }
            if (Array.isArray(_data["listFileImageStore"])) {
                this.listFileImageStore = [] as any;
                for (let item of _data["listFileImageStore"])
                    this.listFileImageStore.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileImagePaymentId"])) {
                this.listFileImagePaymentId = [] as any;
                for (let item of _data["listFileImagePaymentId"])
                    this.listFileImagePaymentId.push(item);
            }
            if (Array.isArray(_data["listFileImagePayment"])) {
                this.listFileImagePayment = [] as any;
                for (let item of _data["listFileImagePayment"])
                    this.listFileImagePayment.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileIdentityFrontId"])) {
                this.listFileIdentityFrontId = [] as any;
                for (let item of _data["listFileIdentityFrontId"])
                    this.listFileIdentityFrontId.push(item);
            }
            if (Array.isArray(_data["listFileIdentityFront"])) {
                this.listFileIdentityFront = [] as any;
                for (let item of _data["listFileIdentityFront"])
                    this.listFileIdentityFront.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileIdentityBackId"])) {
                this.listFileIdentityBackId = [] as any;
                for (let item of _data["listFileIdentityBackId"])
                    this.listFileIdentityBackId.push(item);
            }
            if (Array.isArray(_data["listFileIdentityBack"])) {
                this.listFileIdentityBack = [] as any;
                for (let item of _data["listFileIdentityBack"])
                    this.listFileIdentityBack.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileBusinessLicenseId"])) {
                this.listFileBusinessLicenseId = [] as any;
                for (let item of _data["listFileBusinessLicenseId"])
                    this.listFileBusinessLicenseId.push(item);
            }
            if (Array.isArray(_data["listFileBusinessLicense"])) {
                this.listFileBusinessLicense = [] as any;
                for (let item of _data["listFileBusinessLicense"])
                    this.listFileBusinessLicense.push(FileManagerDto.fromJS(item));
            }
            this.bankAccount = _data["bankAccount"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.accountName = _data["accountName"];
            this.shopOwner = _data["shopOwner"];
            this.ownerId = _data["ownerId"];
            this.prepayPricePercentage = _data["prepayPricePercentage"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.serviceFee = _data["serviceFee"];
            this.saleFeePercent = _data["saleFeePercent"];
            this.agencyFeePercent = _data["agencyFeePercent"];
            this.storeFeePercent = _data["storeFeePercent"];
            this.systemFeePercent = _data["systemFeePercent"];
        }
    }

    static fromJS(data: any): StoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["address"] = this.address;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["leaseTermCode"] = this.leaseTermCode;
        data["isActive"] = this.isActive;
        data["agencyCode"] = this.agencyCode;
        data["agencyName"] = this.agencyName;
        data["statusApproved"] = this.statusApproved;
        if (Array.isArray(this.listProductStore)) {
            data["listProductStore"] = [];
            for (let item of this.listProductStore)
                data["listProductStore"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        if (Array.isArray(this.listFile)) {
            data["listFile"] = [];
            for (let item of this.listFile)
                data["listFile"].push(item.toJSON());
        }
        data["qrCode"] = this.qrCode;
        if (Array.isArray(this.listFileImageStoreId)) {
            data["listFileImageStoreId"] = [];
            for (let item of this.listFileImageStoreId)
                data["listFileImageStoreId"].push(item);
        }
        if (Array.isArray(this.listFileImageStore)) {
            data["listFileImageStore"] = [];
            for (let item of this.listFileImageStore)
                data["listFileImageStore"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileImagePaymentId)) {
            data["listFileImagePaymentId"] = [];
            for (let item of this.listFileImagePaymentId)
                data["listFileImagePaymentId"].push(item);
        }
        if (Array.isArray(this.listFileImagePayment)) {
            data["listFileImagePayment"] = [];
            for (let item of this.listFileImagePayment)
                data["listFileImagePayment"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileIdentityFrontId)) {
            data["listFileIdentityFrontId"] = [];
            for (let item of this.listFileIdentityFrontId)
                data["listFileIdentityFrontId"].push(item);
        }
        if (Array.isArray(this.listFileIdentityFront)) {
            data["listFileIdentityFront"] = [];
            for (let item of this.listFileIdentityFront)
                data["listFileIdentityFront"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileIdentityBackId)) {
            data["listFileIdentityBackId"] = [];
            for (let item of this.listFileIdentityBackId)
                data["listFileIdentityBackId"].push(item);
        }
        if (Array.isArray(this.listFileIdentityBack)) {
            data["listFileIdentityBack"] = [];
            for (let item of this.listFileIdentityBack)
                data["listFileIdentityBack"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileBusinessLicenseId)) {
            data["listFileBusinessLicenseId"] = [];
            for (let item of this.listFileBusinessLicenseId)
                data["listFileBusinessLicenseId"].push(item);
        }
        if (Array.isArray(this.listFileBusinessLicense)) {
            data["listFileBusinessLicense"] = [];
            for (let item of this.listFileBusinessLicense)
                data["listFileBusinessLicense"].push(item.toJSON());
        }
        data["bankAccount"] = this.bankAccount;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["accountName"] = this.accountName;
        data["shopOwner"] = this.shopOwner;
        data["ownerId"] = this.ownerId;
        data["prepayPricePercentage"] = this.prepayPricePercentage;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["serviceFee"] = this.serviceFee;
        data["saleFeePercent"] = this.saleFeePercent;
        data["agencyFeePercent"] = this.agencyFeePercent;
        data["storeFeePercent"] = this.storeFeePercent;
        data["systemFeePercent"] = this.systemFeePercent;
        return data;
    }

    clone(): StoreDto {
        const json = this.toJSON();
        let result = new StoreDto();
        result.init(json);
        return result;
    }
}

export interface IStoreDto {
    id: number;
    code: string | undefined;
    name: string | undefined;
    address: string | undefined;
    monthlyInterestRate: number | undefined;
    leaseTermCode: number;
    isActive: boolean;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    statusApproved: string | undefined;
    listProductStore: ProductStoreDto[] | undefined;
    listFileId: number[] | undefined;
    listFile: FileManagerDto[] | undefined;
    qrCode: string | undefined;
    listFileImageStoreId: number[] | undefined;
    listFileImageStore: FileManagerDto[] | undefined;
    listFileImagePaymentId: number[] | undefined;
    listFileImagePayment: FileManagerDto[] | undefined;
    listFileIdentityFrontId: number[] | undefined;
    listFileIdentityFront: FileManagerDto[] | undefined;
    listFileIdentityBackId: number[] | undefined;
    listFileIdentityBack: FileManagerDto[] | undefined;
    listFileBusinessLicenseId: number[] | undefined;
    listFileBusinessLicense: FileManagerDto[] | undefined;
    bankAccount: string | undefined;
    bankCode: string | undefined;
    bankName: string | undefined;
    accountName: string | undefined;
    shopOwner: string | undefined;
    ownerId: number | undefined;
    prepayPricePercentage: number | undefined;
    creationTime: moment.Moment | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    serviceFee: number | undefined;
    saleFeePercent: number | undefined;
    agencyFeePercent: number | undefined;
    storeFeePercent: number | undefined;
    systemFeePercent: number | undefined;
}

export class StoreDtoPagedResultDto implements IStoreDtoPagedResultDto {
    items: StoreDto[] | undefined;
    totalCount: number;

    constructor(data?: IStoreDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(StoreDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StoreDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StoreDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StoreDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStoreDtoPagedResultDto {
    items: StoreDto[] | undefined;
    totalCount: number;
}

export class StoreFeeConfigDto implements IStoreFeeConfigDto {
    storeId: number;
    storeCode: string | undefined;
    storeName: string | undefined;
    saleFeePercent: number;
    agencyFeePercent: number;
    storeFeePercent: number;
    systemFeePercent: number;

    constructor(data?: IStoreFeeConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
            this.saleFeePercent = _data["saleFeePercent"];
            this.agencyFeePercent = _data["agencyFeePercent"];
            this.storeFeePercent = _data["storeFeePercent"];
            this.systemFeePercent = _data["systemFeePercent"];
        }
    }

    static fromJS(data: any): StoreFeeConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreFeeConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["saleFeePercent"] = this.saleFeePercent;
        data["agencyFeePercent"] = this.agencyFeePercent;
        data["storeFeePercent"] = this.storeFeePercent;
        data["systemFeePercent"] = this.systemFeePercent;
        return data;
    }

    clone(): StoreFeeConfigDto {
        const json = this.toJSON();
        let result = new StoreFeeConfigDto();
        result.init(json);
        return result;
    }
}

export interface IStoreFeeConfigDto {
    storeId: number;
    storeCode: string | undefined;
    storeName: string | undefined;
    saleFeePercent: number;
    agencyFeePercent: number;
    storeFeePercent: number;
    systemFeePercent: number;
}

export class StoreRequestDto implements IStoreRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;

    constructor(data?: IStoreRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.agencyCode = _data["agencyCode"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["agencyCode"] = this.agencyCode;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): StoreRequestDto {
        const json = this.toJSON();
        let result = new StoreRequestDto();
        result.init(json);
        return result;
    }
}

export interface IStoreRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    agencyCode: string | undefined;
    fromDate: moment.Moment | undefined;
    toDate: moment.Moment | undefined;
}

export class Stream implements IStream {
    readonly canRead: boolean;
    readonly canWrite: boolean;
    readonly canSeek: boolean;
    readonly canTimeout: boolean;
    readonly length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }

    clone(): Stream {
        const json = this.toJSON();
        let result = new Stream();
        result.init(json);
        return result;
    }
}

export interface IStream {
    canRead: boolean;
    canWrite: boolean;
    canSeek: boolean;
    canTimeout: boolean;
    length: number;
    position: number;
    readTimeout: number;
    writeTimeout: number;
}

export class TemplateDocument implements ITemplateDocument {
    id: string | undefined;
    name: string | undefined;
    status: number | undefined;
    syncDocumentID: string | undefined;
    tenantId: string | undefined;
    appCode: string | undefined;
    appSubSystem: string | undefined;
    extraData: string | undefined;
    listFileInfo: PublicFileInfo[] | undefined;

    constructor(data?: ITemplateDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.syncDocumentID = _data["syncDocumentID"];
            this.tenantId = _data["tenantId"];
            this.appCode = _data["appCode"];
            this.appSubSystem = _data["appSubSystem"];
            this.extraData = _data["extraData"];
            if (Array.isArray(_data["listFileInfo"])) {
                this.listFileInfo = [] as any;
                for (let item of _data["listFileInfo"])
                    this.listFileInfo.push(PublicFileInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateDocument {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["syncDocumentID"] = this.syncDocumentID;
        data["tenantId"] = this.tenantId;
        data["appCode"] = this.appCode;
        data["appSubSystem"] = this.appSubSystem;
        data["extraData"] = this.extraData;
        if (Array.isArray(this.listFileInfo)) {
            data["listFileInfo"] = [];
            for (let item of this.listFileInfo)
                data["listFileInfo"].push(item.toJSON());
        }
        return data;
    }

    clone(): TemplateDocument {
        const json = this.toJSON();
        let result = new TemplateDocument();
        result.init(json);
        return result;
    }
}

export interface ITemplateDocument {
    id: string | undefined;
    name: string | undefined;
    status: number | undefined;
    syncDocumentID: string | undefined;
    tenantId: string | undefined;
    appCode: string | undefined;
    appSubSystem: string | undefined;
    extraData: string | undefined;
    listFileInfo: PublicFileInfo[] | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TodayMetricsDto implements ITodayMetricsDto {
    newOrders: MetricDto;
    approvedOrders: MetricDto;
    newOrdersAmount: MoneyMetricDto;
    disbursedAmount: MoneyMetricDto;
    documentFee: MoneyMetricDto;

    constructor(data?: ITodayMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOrders = _data["newOrders"] ? MetricDto.fromJS(_data["newOrders"]) : <any>undefined;
            this.approvedOrders = _data["approvedOrders"] ? MetricDto.fromJS(_data["approvedOrders"]) : <any>undefined;
            this.newOrdersAmount = _data["newOrdersAmount"] ? MoneyMetricDto.fromJS(_data["newOrdersAmount"]) : <any>undefined;
            this.disbursedAmount = _data["disbursedAmount"] ? MoneyMetricDto.fromJS(_data["disbursedAmount"]) : <any>undefined;
            this.documentFee = _data["documentFee"] ? MoneyMetricDto.fromJS(_data["documentFee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TodayMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodayMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newOrders"] = this.newOrders ? this.newOrders.toJSON() : <any>undefined;
        data["approvedOrders"] = this.approvedOrders ? this.approvedOrders.toJSON() : <any>undefined;
        data["newOrdersAmount"] = this.newOrdersAmount ? this.newOrdersAmount.toJSON() : <any>undefined;
        data["disbursedAmount"] = this.disbursedAmount ? this.disbursedAmount.toJSON() : <any>undefined;
        data["documentFee"] = this.documentFee ? this.documentFee.toJSON() : <any>undefined;
        return data;
    }

    clone(): TodayMetricsDto {
        const json = this.toJSON();
        let result = new TodayMetricsDto();
        result.init(json);
        return result;
    }
}

export interface ITodayMetricsDto {
    newOrders: MetricDto;
    approvedOrders: MetricDto;
    newOrdersAmount: MoneyMetricDto;
    disbursedAmount: MoneyMetricDto;
    documentFee: MoneyMetricDto;
}

export class TopPayCreateOrderResponse implements ITopPayCreateOrderResponse {
    code: number | undefined;
    status: string | undefined;
    message: string | undefined;
    emojiMessage: string | undefined;
    tranFlow: string | undefined;
    paySerialNo: string | undefined;
    sysTime: string | undefined;
    amount: number | undefined;
    payUrl: string | undefined;
    qrCode: string | undefined;
    beneficiaryName: string | undefined;
    beneficiaryAccount: string | undefined;
    beneficiaryBankCode: string | undefined;
    readonly isSuccess: boolean;

    constructor(data?: ITopPayCreateOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.emojiMessage = _data["emojiMessage"];
            this.tranFlow = _data["tranFlow"];
            this.paySerialNo = _data["paySerialNo"];
            this.sysTime = _data["sysTime"];
            this.amount = _data["amount"];
            this.payUrl = _data["payUrl"];
            this.qrCode = _data["qrCode"];
            this.beneficiaryName = _data["beneficiaryName"];
            this.beneficiaryAccount = _data["beneficiaryAccount"];
            this.beneficiaryBankCode = _data["beneficiaryBankCode"];
            (<any>this).isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): TopPayCreateOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TopPayCreateOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["status"] = this.status;
        data["message"] = this.message;
        data["emojiMessage"] = this.emojiMessage;
        data["tranFlow"] = this.tranFlow;
        data["paySerialNo"] = this.paySerialNo;
        data["sysTime"] = this.sysTime;
        data["amount"] = this.amount;
        data["payUrl"] = this.payUrl;
        data["qrCode"] = this.qrCode;
        data["beneficiaryName"] = this.beneficiaryName;
        data["beneficiaryAccount"] = this.beneficiaryAccount;
        data["beneficiaryBankCode"] = this.beneficiaryBankCode;
        data["isSuccess"] = this.isSuccess;
        return data;
    }

    clone(): TopPayCreateOrderResponse {
        const json = this.toJSON();
        let result = new TopPayCreateOrderResponse();
        result.init(json);
        return result;
    }
}

export interface ITopPayCreateOrderResponse {
    code: number | undefined;
    status: string | undefined;
    message: string | undefined;
    emojiMessage: string | undefined;
    tranFlow: string | undefined;
    paySerialNo: string | undefined;
    sysTime: string | undefined;
    amount: number | undefined;
    payUrl: string | undefined;
    qrCode: string | undefined;
    beneficiaryName: string | undefined;
    beneficiaryAccount: string | undefined;
    beneficiaryBankCode: string | undefined;
    isSuccess: boolean;
}

export class TopUpWalletDto implements ITopUpWalletDto {
    money: number | undefined;
    bankCode: string | undefined;

    constructor(data?: ITopUpWalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.money = _data["money"];
            this.bankCode = _data["bankCode"];
        }
    }

    static fromJS(data: any): TopUpWalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopUpWalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["money"] = this.money;
        data["bankCode"] = this.bankCode;
        return data;
    }

    clone(): TopUpWalletDto {
        const json = this.toJSON();
        let result = new TopUpWalletDto();
        result.init(json);
        return result;
    }
}

export interface ITopUpWalletDto {
    money: number | undefined;
    bankCode: string | undefined;
}

export class Transaction implements ITransaction {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    orderId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    principal: number;
    amounToBePaid: number;
    transactionStatus: string | undefined;
    reason: string | undefined;
    fileId: string | undefined;
    appTransId: string | undefined;
    methodPayment: string | undefined;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.orderId = _data["orderId"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.principal = _data["principal"];
            this.amounToBePaid = _data["amounToBePaid"];
            this.transactionStatus = _data["transactionStatus"];
            this.reason = _data["reason"];
            this.fileId = _data["fileId"];
            this.appTransId = _data["appTransId"];
            this.methodPayment = _data["methodPayment"];
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["orderId"] = this.orderId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["principal"] = this.principal;
        data["amounToBePaid"] = this.amounToBePaid;
        data["transactionStatus"] = this.transactionStatus;
        data["reason"] = this.reason;
        data["fileId"] = this.fileId;
        data["appTransId"] = this.appTransId;
        data["methodPayment"] = this.methodPayment;
        return data;
    }

    clone(): Transaction {
        const json = this.toJSON();
        let result = new Transaction();
        result.init(json);
        return result;
    }
}

export interface ITransaction {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    orderId: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    principal: number;
    amounToBePaid: number;
    transactionStatus: string | undefined;
    reason: string | undefined;
    fileId: string | undefined;
    appTransId: string | undefined;
    methodPayment: string | undefined;
}

export class TransactionDetailDto implements ITransactionDetailDto {
    id: number;
    recallId: number;
    recallName: string | undefined;
    legalStatus: string | undefined;
    note: string | undefined;
    transactionId: number;

    constructor(data?: ITransactionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.recallId = _data["recallId"];
            this.recallName = _data["recallName"];
            this.legalStatus = _data["legalStatus"];
            this.note = _data["note"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): TransactionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recallId"] = this.recallId;
        data["recallName"] = this.recallName;
        data["legalStatus"] = this.legalStatus;
        data["note"] = this.note;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): TransactionDetailDto {
        const json = this.toJSON();
        let result = new TransactionDetailDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDetailDto {
    id: number;
    recallId: number;
    recallName: string | undefined;
    legalStatus: string | undefined;
    note: string | undefined;
    transactionId: number;
}

export class TransactionDetailDtoPagedResultDto implements ITransactionDetailDtoPagedResultDto {
    items: TransactionDetailDto[] | undefined;
    totalCount: number;

    constructor(data?: ITransactionDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionDetailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TransactionDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TransactionDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDetailDtoPagedResultDto {
    items: TransactionDetailDto[] | undefined;
    totalCount: number;
}

export class TransactionDetailRequestDto implements ITransactionDetailRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    recallId: number | undefined;
    legalStatus: string | undefined;
    note: string | undefined;
    transactionId: number;

    constructor(data?: ITransactionDetailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.recallId = _data["recallId"];
            this.legalStatus = _data["legalStatus"];
            this.note = _data["note"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): TransactionDetailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDetailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["recallId"] = this.recallId;
        data["legalStatus"] = this.legalStatus;
        data["note"] = this.note;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): TransactionDetailRequestDto {
        const json = this.toJSON();
        let result = new TransactionDetailRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDetailRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    recallId: number | undefined;
    legalStatus: string | undefined;
    note: string | undefined;
    transactionId: number;
}

export class TransactionDto implements ITransactionDto {
    id: number;
    code: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    amounToBePaid: number;
    principalAmount: number;
    monthlyInterestRate: number;
    transactionStatus: string | undefined;
    reason: string | undefined;
    listFile: FileManagerDto[] | undefined;
    listFileId: number[] | undefined;
    staffOrderStatus: string | undefined;
    orderId: number;
    methodPayment: string | undefined;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.amounToBePaid = _data["amounToBePaid"];
            this.principalAmount = _data["principalAmount"];
            this.monthlyInterestRate = _data["monthlyInterestRate"];
            this.transactionStatus = _data["transactionStatus"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["listFile"])) {
                this.listFile = [] as any;
                for (let item of _data["listFile"])
                    this.listFile.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
            this.staffOrderStatus = _data["staffOrderStatus"];
            this.orderId = _data["orderId"];
            this.methodPayment = _data["methodPayment"];
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["amounToBePaid"] = this.amounToBePaid;
        data["principalAmount"] = this.principalAmount;
        data["monthlyInterestRate"] = this.monthlyInterestRate;
        data["transactionStatus"] = this.transactionStatus;
        data["reason"] = this.reason;
        if (Array.isArray(this.listFile)) {
            data["listFile"] = [];
            for (let item of this.listFile)
                data["listFile"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        data["staffOrderStatus"] = this.staffOrderStatus;
        data["orderId"] = this.orderId;
        data["methodPayment"] = this.methodPayment;
        return data;
    }

    clone(): TransactionDto {
        const json = this.toJSON();
        let result = new TransactionDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDto {
    id: number;
    code: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    amounToBePaid: number;
    principalAmount: number;
    monthlyInterestRate: number;
    transactionStatus: string | undefined;
    reason: string | undefined;
    listFile: FileManagerDto[] | undefined;
    listFileId: number[] | undefined;
    staffOrderStatus: string | undefined;
    orderId: number;
    methodPayment: string | undefined;
}

export class TransactionDtoPagedResultDto implements ITransactionDtoPagedResultDto {
    items: TransactionDto[] | undefined;
    totalCount: number;

    constructor(data?: ITransactionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TransactionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TransactionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDtoPagedResultDto {
    items: TransactionDto[] | undefined;
    totalCount: number;
}

export class TransactionInvestorDto implements ITransactionInvestorDto {
    id: number;
    code: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    amounToBePaid: number;
    principal: number;
    transactionStatus: string | undefined;
    countMoneyInvestor: number;
    orderId: number;
    isPaidInterest: boolean;
    moneyInvestor: number | undefined;

    constructor(data?: ITransactionInvestorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>undefined;
            this.amounToBePaid = _data["amounToBePaid"];
            this.principal = _data["principal"];
            this.transactionStatus = _data["transactionStatus"];
            this.countMoneyInvestor = _data["countMoneyInvestor"];
            this.orderId = _data["orderId"];
            this.isPaidInterest = _data["isPaidInterest"];
            this.moneyInvestor = _data["moneyInvestor"];
        }
    }

    static fromJS(data: any): TransactionInvestorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionInvestorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["amounToBePaid"] = this.amounToBePaid;
        data["principal"] = this.principal;
        data["transactionStatus"] = this.transactionStatus;
        data["countMoneyInvestor"] = this.countMoneyInvestor;
        data["orderId"] = this.orderId;
        data["isPaidInterest"] = this.isPaidInterest;
        data["moneyInvestor"] = this.moneyInvestor;
        return data;
    }

    clone(): TransactionInvestorDto {
        const json = this.toJSON();
        let result = new TransactionInvestorDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionInvestorDto {
    id: number;
    code: string | undefined;
    fromDate: moment.Moment;
    toDate: moment.Moment;
    amounToBePaid: number;
    principal: number;
    transactionStatus: string | undefined;
    countMoneyInvestor: number;
    orderId: number;
    isPaidInterest: boolean;
    moneyInvestor: number | undefined;
}

export class TransactionInvestorDtoPagedResultDto implements ITransactionInvestorDtoPagedResultDto {
    items: TransactionInvestorDto[] | undefined;
    totalCount: number;

    constructor(data?: ITransactionInvestorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionInvestorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TransactionInvestorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionInvestorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TransactionInvestorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionInvestorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionInvestorDtoPagedResultDto {
    items: TransactionInvestorDto[] | undefined;
    totalCount: number;
}

export class TransactionPaymentDto implements ITransactionPaymentDto {
    id: number;
    orderCode: string | undefined;
    price: number | undefined;
    listFile: FileManagerDto[] | undefined;
    listFileId: number[] | undefined;

    constructor(data?: ITransactionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderCode = _data["orderCode"];
            this.price = _data["price"];
            if (Array.isArray(_data["listFile"])) {
                this.listFile = [] as any;
                for (let item of _data["listFile"])
                    this.listFile.push(FileManagerDto.fromJS(item));
            }
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
        }
    }

    static fromJS(data: any): TransactionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["price"] = this.price;
        if (Array.isArray(this.listFile)) {
            data["listFile"] = [];
            for (let item of this.listFile)
                data["listFile"].push(item.toJSON());
        }
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        return data;
    }

    clone(): TransactionPaymentDto {
        const json = this.toJSON();
        let result = new TransactionPaymentDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionPaymentDto {
    id: number;
    orderCode: string | undefined;
    price: number | undefined;
    listFile: FileManagerDto[] | undefined;
    listFileId: number[] | undefined;
}

export class TransactionReportDto implements ITransactionReportDto {
    orderId: number;
    transactionId: number;
    date: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    productName: string | undefined;
    orderCode: string | undefined;
    seri: string | undefined;
    transactionCode: string | undefined;
    currentPaymentPeriod: string | undefined;
    amounToBePaid: number;
    amoundHasPay: number;
    interest: number;
    transactionStatus: string | undefined;
    legalStatus: string | undefined;
    note: string | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    fundingAgency: string | undefined;
    recall: string | undefined;

    constructor(data?: ITransactionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.productName = _data["productName"];
            this.orderCode = _data["orderCode"];
            this.seri = _data["seri"];
            this.transactionCode = _data["transactionCode"];
            this.currentPaymentPeriod = _data["currentPaymentPeriod"];
            this.amounToBePaid = _data["amounToBePaid"];
            this.amoundHasPay = _data["amoundHasPay"];
            this.interest = _data["interest"];
            this.transactionStatus = _data["transactionStatus"];
            this.legalStatus = _data["legalStatus"];
            this.note = _data["note"];
            this.storeCode = _data["storeCode"];
            this.storeName = _data["storeName"];
            this.agencyCode = _data["agencyCode"];
            this.agencyName = _data["agencyName"];
            this.fundingAgency = _data["fundingAgency"];
            this.recall = _data["recall"];
        }
    }

    static fromJS(data: any): TransactionReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["productName"] = this.productName;
        data["orderCode"] = this.orderCode;
        data["seri"] = this.seri;
        data["transactionCode"] = this.transactionCode;
        data["currentPaymentPeriod"] = this.currentPaymentPeriod;
        data["amounToBePaid"] = this.amounToBePaid;
        data["amoundHasPay"] = this.amoundHasPay;
        data["interest"] = this.interest;
        data["transactionStatus"] = this.transactionStatus;
        data["legalStatus"] = this.legalStatus;
        data["note"] = this.note;
        data["storeCode"] = this.storeCode;
        data["storeName"] = this.storeName;
        data["agencyCode"] = this.agencyCode;
        data["agencyName"] = this.agencyName;
        data["fundingAgency"] = this.fundingAgency;
        data["recall"] = this.recall;
        return data;
    }

    clone(): TransactionReportDto {
        const json = this.toJSON();
        let result = new TransactionReportDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionReportDto {
    orderId: number;
    transactionId: number;
    date: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    productName: string | undefined;
    orderCode: string | undefined;
    seri: string | undefined;
    transactionCode: string | undefined;
    currentPaymentPeriod: string | undefined;
    amounToBePaid: number;
    amoundHasPay: number;
    interest: number;
    transactionStatus: string | undefined;
    legalStatus: string | undefined;
    note: string | undefined;
    storeCode: string | undefined;
    storeName: string | undefined;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    fundingAgency: string | undefined;
    recall: string | undefined;
}

export class TransactionReportDtoPagedResultDto implements ITransactionReportDtoPagedResultDto {
    items: TransactionReportDto[] | undefined;
    totalCount: number;

    constructor(data?: ITransactionReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TransactionReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TransactionReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionReportDtoPagedResultDto {
    items: TransactionReportDto[] | undefined;
    totalCount: number;
}

export class TransactionReportRequestDto implements ITransactionReportRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    orderCode: string | undefined;
    transactionStatus: string | undefined;
    legalStatus: string | undefined;
    storeCode: string | undefined;
    agencyCode: string | undefined;
    fundingAgency: string | undefined;
    recall: string | undefined;
    seri: string | undefined;
    imei: string | undefined;

    constructor(data?: ITransactionReportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.orderCode = _data["orderCode"];
            this.transactionStatus = _data["transactionStatus"];
            this.legalStatus = _data["legalStatus"];
            this.storeCode = _data["storeCode"];
            this.agencyCode = _data["agencyCode"];
            this.fundingAgency = _data["fundingAgency"];
            this.recall = _data["recall"];
            this.seri = _data["seri"];
            this.imei = _data["imei"];
        }
    }

    static fromJS(data: any): TransactionReportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionReportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["orderCode"] = this.orderCode;
        data["transactionStatus"] = this.transactionStatus;
        data["legalStatus"] = this.legalStatus;
        data["storeCode"] = this.storeCode;
        data["agencyCode"] = this.agencyCode;
        data["fundingAgency"] = this.fundingAgency;
        data["recall"] = this.recall;
        data["seri"] = this.seri;
        data["imei"] = this.imei;
        return data;
    }

    clone(): TransactionReportRequestDto {
        const json = this.toJSON();
        let result = new TransactionReportRequestDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionReportRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    orderCode: string | undefined;
    transactionStatus: string | undefined;
    legalStatus: string | undefined;
    storeCode: string | undefined;
    agencyCode: string | undefined;
    fundingAgency: string | undefined;
    recall: string | undefined;
    seri: string | undefined;
    imei: string | undefined;
}

export class TransactionRequestModel implements ITransactionRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    transactionStatus: string | undefined;
    orderId: number | undefined;
    transactionId: number | undefined;

    constructor(data?: ITransactionRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
            this.transactionStatus = _data["transactionStatus"];
            this.orderId = _data["orderId"];
            this.transactionId = _data["transactionId"];
        }
    }

    static fromJS(data: any): TransactionRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        data["transactionStatus"] = this.transactionStatus;
        data["orderId"] = this.orderId;
        data["transactionId"] = this.transactionId;
        return data;
    }

    clone(): TransactionRequestModel {
        const json = this.toJSON();
        let result = new TransactionRequestModel();
        result.init(json);
        return result;
    }
}

export interface ITransactionRequestModel {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
    transactionStatus: string | undefined;
    orderId: number | undefined;
    transactionId: number | undefined;
}

export enum TypeToppic {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UpdatePostLeaseManagement implements IUpdatePostLeaseManagement {
    orderId: number | undefined;
    investorId: number;

    constructor(data?: IUpdatePostLeaseManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.investorId = _data["investorId"];
        }
    }

    static fromJS(data: any): UpdatePostLeaseManagement {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePostLeaseManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["investorId"] = this.investorId;
        return data;
    }

    clone(): UpdatePostLeaseManagement {
        const json = this.toJSON();
        let result = new UpdatePostLeaseManagement();
        result.init(json);
        return result;
    }
}

export interface IUpdatePostLeaseManagement {
    orderId: number | undefined;
    investorId: number;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    emailAddress: string | undefined;
    phoneNumber: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    storeCodes: string | undefined;
    agencyCodes: string | undefined;
    fileBefore: string | undefined;
    fileAlter: string | undefined;
    address: string | undefined;
    cccd: string | undefined;
    listIdDelete: number[] | undefined;
    fileBeforeCCCDCard: FileManagerDto;
    fileAlterCCCDCard: FileManagerDto;
    listFileId: number[] | undefined;
    issuingAuthority: string | undefined;
    dateIssued: string | undefined;
    birthday: string | undefined;
    bankCode: string | undefined;
    accountName: string | undefined;
    bankAccount: string | undefined;
    fileImagePayment: string[] | undefined;
    listIdPaymentDelete: number[] | undefined;
    money: number | undefined;
    creationTime: moment.Moment;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.storeCodes = _data["storeCodes"];
            this.agencyCodes = _data["agencyCodes"];
            this.fileBefore = _data["fileBefore"];
            this.fileAlter = _data["fileAlter"];
            this.address = _data["address"];
            this.cccd = _data["cccd"];
            if (Array.isArray(_data["listIdDelete"])) {
                this.listIdDelete = [] as any;
                for (let item of _data["listIdDelete"])
                    this.listIdDelete.push(item);
            }
            this.fileBeforeCCCDCard = _data["fileBeforeCCCDCard"] ? FileManagerDto.fromJS(_data["fileBeforeCCCDCard"]) : <any>undefined;
            this.fileAlterCCCDCard = _data["fileAlterCCCDCard"] ? FileManagerDto.fromJS(_data["fileAlterCCCDCard"]) : <any>undefined;
            if (Array.isArray(_data["listFileId"])) {
                this.listFileId = [] as any;
                for (let item of _data["listFileId"])
                    this.listFileId.push(item);
            }
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateIssued = _data["dateIssued"];
            this.birthday = _data["birthday"];
            this.bankCode = _data["bankCode"];
            this.accountName = _data["accountName"];
            this.bankAccount = _data["bankAccount"];
            if (Array.isArray(_data["fileImagePayment"])) {
                this.fileImagePayment = [] as any;
                for (let item of _data["fileImagePayment"])
                    this.fileImagePayment.push(item);
            }
            if (Array.isArray(_data["listIdPaymentDelete"])) {
                this.listIdPaymentDelete = [] as any;
                for (let item of _data["listIdPaymentDelete"])
                    this.listIdPaymentDelete.push(item);
            }
            this.money = _data["money"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["storeCodes"] = this.storeCodes;
        data["agencyCodes"] = this.agencyCodes;
        data["fileBefore"] = this.fileBefore;
        data["fileAlter"] = this.fileAlter;
        data["address"] = this.address;
        data["cccd"] = this.cccd;
        if (Array.isArray(this.listIdDelete)) {
            data["listIdDelete"] = [];
            for (let item of this.listIdDelete)
                data["listIdDelete"].push(item);
        }
        data["fileBeforeCCCDCard"] = this.fileBeforeCCCDCard ? this.fileBeforeCCCDCard.toJSON() : <any>undefined;
        data["fileAlterCCCDCard"] = this.fileAlterCCCDCard ? this.fileAlterCCCDCard.toJSON() : <any>undefined;
        if (Array.isArray(this.listFileId)) {
            data["listFileId"] = [];
            for (let item of this.listFileId)
                data["listFileId"].push(item);
        }
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateIssued"] = this.dateIssued;
        data["birthday"] = this.birthday;
        data["bankCode"] = this.bankCode;
        data["accountName"] = this.accountName;
        data["bankAccount"] = this.bankAccount;
        if (Array.isArray(this.fileImagePayment)) {
            data["fileImagePayment"] = [];
            for (let item of this.fileImagePayment)
                data["fileImagePayment"].push(item);
        }
        if (Array.isArray(this.listIdPaymentDelete)) {
            data["listIdPaymentDelete"] = [];
            for (let item of this.listIdPaymentDelete)
                data["listIdPaymentDelete"].push(item);
        }
        data["money"] = this.money;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    emailAddress: string | undefined;
    phoneNumber: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    storeCodes: string | undefined;
    agencyCodes: string | undefined;
    fileBefore: string | undefined;
    fileAlter: string | undefined;
    address: string | undefined;
    cccd: string | undefined;
    listIdDelete: number[] | undefined;
    fileBeforeCCCDCard: FileManagerDto;
    fileAlterCCCDCard: FileManagerDto;
    listFileId: number[] | undefined;
    issuingAuthority: string | undefined;
    dateIssued: string | undefined;
    birthday: string | undefined;
    bankCode: string | undefined;
    accountName: string | undefined;
    bankAccount: string | undefined;
    fileImagePayment: string[] | undefined;
    listIdPaymentDelete: number[] | undefined;
    money: number | undefined;
    creationTime: moment.Moment;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    roles: string[] | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    roles: string[] | undefined;
}

export class UserOrderSplittingDto implements IUserOrderSplittingDto {
    id: number;
    userId: number;
    isOnline: boolean;
    countOrder: number;
    role: string | undefined;

    constructor(data?: IUserOrderSplittingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.isOnline = _data["isOnline"];
            this.countOrder = _data["countOrder"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UserOrderSplittingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrderSplittingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["isOnline"] = this.isOnline;
        data["countOrder"] = this.countOrder;
        data["role"] = this.role;
        return data;
    }

    clone(): UserOrderSplittingDto {
        const json = this.toJSON();
        let result = new UserOrderSplittingDto();
        result.init(json);
        return result;
    }
}

export interface IUserOrderSplittingDto {
    id: number;
    userId: number;
    isOnline: boolean;
    countOrder: number;
    role: string | undefined;
}

export class VNPayResponseDto implements IVNPayResponseDto {
    appTransId: string | undefined;
    url: string | undefined;

    constructor(data?: IVNPayResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appTransId = _data["appTransId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): VNPayResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VNPayResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appTransId"] = this.appTransId;
        data["url"] = this.url;
        return data;
    }

    clone(): VNPayResponseDto {
        const json = this.toJSON();
        let result = new VNPayResponseDto();
        result.init(json);
        return result;
    }
}

export interface IVNPayResponseDto {
    appTransId: string | undefined;
    url: string | undefined;
}

export class ValidateResult implements IValidateResult {
    id: any | undefined;
    code: string | undefined;
    errorMessage: string | undefined;
    additionInfo: any | undefined;
    validateType: number;

    constructor(data?: IValidateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.errorMessage = _data["errorMessage"];
            this.additionInfo = _data["additionInfo"];
            this.validateType = _data["validateType"];
        }
    }

    static fromJS(data: any): ValidateResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["errorMessage"] = this.errorMessage;
        data["additionInfo"] = this.additionInfo;
        data["validateType"] = this.validateType;
        return data;
    }

    clone(): ValidateResult {
        const json = this.toJSON();
        let result = new ValidateResult();
        result.init(json);
        return result;
    }
}

export interface IValidateResult {
    id: any | undefined;
    code: string | undefined;
    errorMessage: string | undefined;
    additionInfo: any | undefined;
    validateType: number;
}

export class WalletAdminDto implements IWalletAdminDto {
    id: number;
    userId: number;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    monney: number | undefined;
    countTopUp: number | undefined;
    countWithdraw: number | undefined;

    constructor(data?: IWalletAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.monney = _data["monney"];
            this.countTopUp = _data["countTopUp"];
            this.countWithdraw = _data["countWithdraw"];
        }
    }

    static fromJS(data: any): WalletAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["monney"] = this.monney;
        data["countTopUp"] = this.countTopUp;
        data["countWithdraw"] = this.countWithdraw;
        return data;
    }

    clone(): WalletAdminDto {
        const json = this.toJSON();
        let result = new WalletAdminDto();
        result.init(json);
        return result;
    }
}

export interface IWalletAdminDto {
    id: number;
    userId: number;
    fullName: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    monney: number | undefined;
    countTopUp: number | undefined;
    countWithdraw: number | undefined;
}

export class WalletAdminDtoPagedResultDto implements IWalletAdminDtoPagedResultDto {
    items: WalletAdminDto[] | undefined;
    totalCount: number;

    constructor(data?: IWalletAdminDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WalletAdminDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WalletAdminDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletAdminDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WalletAdminDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WalletAdminDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWalletAdminDtoPagedResultDto {
    items: WalletAdminDto[] | undefined;
    totalCount: number;
}

export class WalletDto implements IWalletDto {
    id: number;
    userId: number;
    monney: number | undefined;
    countTopUp: number | undefined;
    countWithdraw: number | undefined;

    constructor(data?: IWalletDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.monney = _data["monney"];
            this.countTopUp = _data["countTopUp"];
            this.countWithdraw = _data["countWithdraw"];
        }
    }

    static fromJS(data: any): WalletDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["monney"] = this.monney;
        data["countTopUp"] = this.countTopUp;
        data["countWithdraw"] = this.countWithdraw;
        return data;
    }

    clone(): WalletDto {
        const json = this.toJSON();
        let result = new WalletDto();
        result.init(json);
        return result;
    }
}

export interface IWalletDto {
    id: number;
    userId: number;
    monney: number | undefined;
    countTopUp: number | undefined;
    countWithdraw: number | undefined;
}

export class WalletHistoryDto implements IWalletHistoryDto {
    id: number;
    userId: number;
    action: string | undefined;
    isAdd: boolean;
    methodPayment: string | undefined;
    status: string | undefined;
    monney: number | undefined;
    walletBalance: number;
    creationTime: moment.Moment;
    note: string | undefined;

    constructor(data?: IWalletHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.action = _data["action"];
            this.isAdd = _data["isAdd"];
            this.methodPayment = _data["methodPayment"];
            this.status = _data["status"];
            this.monney = _data["monney"];
            this.walletBalance = _data["walletBalance"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): WalletHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["action"] = this.action;
        data["isAdd"] = this.isAdd;
        data["methodPayment"] = this.methodPayment;
        data["status"] = this.status;
        data["monney"] = this.monney;
        data["walletBalance"] = this.walletBalance;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["note"] = this.note;
        return data;
    }

    clone(): WalletHistoryDto {
        const json = this.toJSON();
        let result = new WalletHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IWalletHistoryDto {
    id: number;
    userId: number;
    action: string | undefined;
    isAdd: boolean;
    methodPayment: string | undefined;
    status: string | undefined;
    monney: number | undefined;
    walletBalance: number;
    creationTime: moment.Moment;
    note: string | undefined;
}

export class WalletHistoryDtoPagedResultDto implements IWalletHistoryDtoPagedResultDto {
    items: WalletHistoryDto[] | undefined;
    totalCount: number;

    constructor(data?: IWalletHistoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WalletHistoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WalletHistoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletHistoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WalletHistoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WalletHistoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWalletHistoryDtoPagedResultDto {
    items: WalletHistoryDto[] | undefined;
    totalCount: number;
}

export class WithdrawDto implements IWithdrawDto {
    id: number | undefined;
    userId: number;
    fullName: string | undefined;
    amount: number;
    bankCode: string | undefined;
    bankName: string | undefined;
    bankAccount: string | undefined;
    accountName: string | undefined;
    status: string | undefined;
    note: string | undefined;

    constructor(data?: IWithdrawDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
            this.amount = _data["amount"];
            this.bankCode = _data["bankCode"];
            this.bankName = _data["bankName"];
            this.bankAccount = _data["bankAccount"];
            this.accountName = _data["accountName"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): WithdrawDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        data["amount"] = this.amount;
        data["bankCode"] = this.bankCode;
        data["bankName"] = this.bankName;
        data["bankAccount"] = this.bankAccount;
        data["accountName"] = this.accountName;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }

    clone(): WithdrawDto {
        const json = this.toJSON();
        let result = new WithdrawDto();
        result.init(json);
        return result;
    }
}

export interface IWithdrawDto {
    id: number | undefined;
    userId: number;
    fullName: string | undefined;
    amount: number;
    bankCode: string | undefined;
    bankName: string | undefined;
    bankAccount: string | undefined;
    accountName: string | undefined;
    status: string | undefined;
    note: string | undefined;
}

export class WithdrawDtoPagedResultDto implements IWithdrawDtoPagedResultDto {
    items: WithdrawDto[] | undefined;
    totalCount: number;

    constructor(data?: IWithdrawDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WithdrawDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WithdrawDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WithdrawDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WithdrawDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWithdrawDtoPagedResultDto {
    items: WithdrawDto[] | undefined;
    totalCount: number;
}

export class WithdrawRequestDto implements IWithdrawRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;

    constructor(data?: IWithdrawRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.search = _data["search"];
        }
    }

    static fromJS(data: any): WithdrawRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["search"] = this.search;
        return data;
    }

    clone(): WithdrawRequestDto {
        const json = this.toJSON();
        let result = new WithdrawRequestDto();
        result.init(json);
        return result;
    }
}

export interface IWithdrawRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    search: string | undefined;
}

export class ZaloPayCallbackRequest implements IZaloPayCallbackRequest {
    data: string | undefined;
    mac: string | undefined;
    type: number;

    constructor(data?: IZaloPayCallbackRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.mac = _data["mac"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ZaloPayCallbackRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ZaloPayCallbackRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["mac"] = this.mac;
        data["type"] = this.type;
        return data;
    }

    clone(): ZaloPayCallbackRequest {
        const json = this.toJSON();
        let result = new ZaloPayCallbackRequest();
        result.init(json);
        return result;
    }
}

export interface IZaloPayCallbackRequest {
    data: string | undefined;
    mac: string | undefined;
    type: number;
}

export class ZaloPayCreateOrderResponse implements IZaloPayCreateOrderResponse {
    returnCode: string | undefined;
    returnMessage: string | undefined;
    subReturnCode: string | undefined;
    subReturnMessage: string | undefined;
    zpTransToken: string | undefined;
    orderToken: string | undefined;
    orderUrl: string | undefined;
    qrCode: string | undefined;
    appTransId: string | undefined;

    constructor(data?: IZaloPayCreateOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnCode = _data["returnCode"];
            this.returnMessage = _data["returnMessage"];
            this.subReturnCode = _data["subReturnCode"];
            this.subReturnMessage = _data["subReturnMessage"];
            this.zpTransToken = _data["zpTransToken"];
            this.orderToken = _data["orderToken"];
            this.orderUrl = _data["orderUrl"];
            this.qrCode = _data["qrCode"];
            this.appTransId = _data["appTransId"];
        }
    }

    static fromJS(data: any): ZaloPayCreateOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ZaloPayCreateOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnCode"] = this.returnCode;
        data["returnMessage"] = this.returnMessage;
        data["subReturnCode"] = this.subReturnCode;
        data["subReturnMessage"] = this.subReturnMessage;
        data["zpTransToken"] = this.zpTransToken;
        data["orderToken"] = this.orderToken;
        data["orderUrl"] = this.orderUrl;
        data["qrCode"] = this.qrCode;
        data["appTransId"] = this.appTransId;
        return data;
    }

    clone(): ZaloPayCreateOrderResponse {
        const json = this.toJSON();
        let result = new ZaloPayCreateOrderResponse();
        result.init(json);
        return result;
    }
}

export interface IZaloPayCreateOrderResponse {
    returnCode: string | undefined;
    returnMessage: string | undefined;
    subReturnCode: string | undefined;
    subReturnMessage: string | undefined;
    zpTransToken: string | undefined;
    orderToken: string | undefined;
    orderUrl: string | undefined;
    qrCode: string | undefined;
    appTransId: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}